  (function() {
    var caches = window.COHORT_STATUS_CACHES || [];
    var cohorts = window.COHORTS || [];
    var CONFIG = window.COHORT_STATUS_CONFIG || {};
    var shopBaseUrl = CONFIG.shopBaseUrl || '';
    /*
      2026-10-17 (owner) - the student form path comes from the section setting
      "Student form page path", so the demo status page sends its link and QR
      to the demo form instead of the live one. Only a plain /pages/<handle>
      is accepted; anything else falls back to the live form, as before.
    */
    var defaultStudentFormPath = /^\/pages\/[a-z0-9][a-z0-9-]*$/i.test(String(CONFIG.studentFormPath || '').trim().replace(/\/+$/, ''))
      ? String(CONFIG.studentFormPath).trim().replace(/\/+$/, '')
      : '/pages/cohort-student';
    var adminDashboardPath = CONFIG.adminDashboardPath || '/pages/create-cohort-order';
    var finalizeWebhookUrl = CONFIG.finalizeWebhookUrl || '';
    var finalizeLateWebhookUrl = CONFIG.finalizeLateWebhookUrl || '';
    var lateBatchFinalizeInFlight = {};
    /* fixStudentEmailWebhookUrl, removeStudentWebhookUrl and
       sendCohortRemindersWebhookUrl went with the features they fed
       (2026-08-06). This page only finalizes. */

    var currentStudents = [];
    var currentCohortCode = '';
    var currentCohort = null;
    var currentPricing = null;
    var pendingStatusEmailMutation = null;
    var statusPageSyncTimer = null;
    var statusIdleSyncInterval = null;
    /*
      The resend-modal state (pendingResendRequest, pendingResendReuseDeadline,
      pendingResendExplicitNewBatch, optimisticOpenLateBatch,
      pendingEmailFixNoticesStatus, resendModalSuccessState,
      resendModalSuccessState) went with the modal itself on 2026-08-06 —
      step 3 of docs/roster-editing-rework-plan.md.
    */
    /* Still live: the idle sync and the status-line refresh both check it. */
    var reminderStatusHoldUntil = 0;
    var REMINDER_STATUS_HOLD_MS = 6000;
    var statusActionBlockingMinUntil = 0;
    var statusActionProgressRaf = null;
    var STATUS_ACTION_EDIT_MS = 15000;
    /* 25s (owner decision, 2026-08-04): removal also releases submission locks
       and rebuilds the cache, and 15s regularly ended before that finished. */
    var STATUS_ACTION_REMOVE_MS = 25000;
    /* 2 * PI * r, with r = 52 from the progress ring SVG markup. */
    var STATUS_RING_CIRCUMFERENCE = 326.73;
    var FINALIZE_INVOICE_MESSAGE = 'Your school invoice has been created and emailed to you. You can also open it from the School invoice link on this page. If you cannot find it, email contact@apres-scrubs.com.';
    var FINALIZE_IN_PROGRESS_MESSAGE = 'Creating the orders and your school invoice. Please keep this page open until it finishes.';
    var FINALIZE_INVOICE_PENDING_MESSAGE = 'Your school invoice is on its way and should reach you by email within about 10 minutes. If nothing arrives, reload this page and finalize again — repeating it is safe and will not create a duplicate order. Any questions, email contact@apres-scrubs.com.';
    var FINALIZE_JUST_DONE_KEY = 'cohort_finalize_just_done';
    var finalizeAwaitingConfirmation = false;
    /*
      Cross-page action lock. localStorage, not sessionStorage, on purpose: a
      write action has to keep the UI blocked across a manual browser refresh
      AND in any other tab of the same browser, because the Mechanic task keeps
      running no matter what this page does. Refreshing used to wipe the overlay
      and hand every button straight back to the admin while the task was still
      writing — that is the window in which a second click corrupted the roster
      (see docs/regression-log.md).

      Every record carries its own expiry, so a hung or failed Mechanic task can
      never brick the page: it always unlocks by itself. Mirrored in
      cohort-admin-form.js under the same key and shape, so the status page and
      the dashboard block each other.
    */
    var ACTION_LOCK_KEY = 'cohort_action_lock';
    /*
      2026-08-21 — five minutes for finalize, in step with
      cohort-admin-form.js. The two pages share this key, so a difference here
      would mean each page thought the other's block had already expired. The
      reasoning behind the number lives beside the copy in that file.
    */
    var ACTION_LOCK_MAX_MS = 300000;
    var FINALIZE_ACTION_LOCK_MS = 300000;
    var ACTION_LOCK_RESUMED_NOTE = 'Your last change is still being applied. This page unlocks automatically as soon as it finishes.';
    var actionLockReleaseTimer = null;
    var actionLockPollTimer = null;
    /*
      Browsers cap the total body of keepalive requests at roughly 64 KB and
      reject the fetch outright above it, so stay well under and fall back to a
      normal request for anything larger. keepalive lets a small write survive
      the page going away; it is a bonus, never the primary protection — the
      beforeunload guard below is.
    */
    var KEEPALIVE_MAX_BYTES = 50000;
    var allowNextUnload = false;
    var NO_CONFIRMED_STUDENTS_MESSAGE = 'No student from your list has confirmed the uniform size selection form yet.';

    function esc(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getParam(name) {
      return new URLSearchParams(window.location.search).get(name);
    }

    function normalizeCode(value) {
      return String(value || '')
        .replace(/^cohort-/i, '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function normalizeCodeLoose(value) {
      return normalizeCode(value).replace(/[^A-Z0-9]/g, '');
    }

    function buildAdminDashboardUrl(cohort) {
      var basePath = String(adminDashboardPath || '/pages/create-cohort-order').trim() || '/pages/create-cohort-order';
      var school = cohort && (cohort.schoolCode || cohort.school_code)
        ? String(cohort.schoolCode || cohort.school_code).trim()
        : '';

      if (!school) {
        return basePath;
      }

      var joiner = basePath.indexOf('?') === -1 ? '?' : '&';
      return basePath + joiner + 'school=' + encodeURIComponent(school);
    }

    function updateAdminDashboardLink(cohort) {
      var link = document.getElementById('cohort-admin-dashboard-link');
      if (!link) return;

      link.href = buildAdminDashboardUrl(cohort || currentCohort || null);

      /* 2026-10-16 (owner) - Edit this cohort: the same address plus edit=CODE,
         shown only while a cohort is loaded. */
      var editLink = document.getElementById('cohort-admin-edit-link');
      if (!editLink) return;

      var code = cohort ? normalizeCode(currentCohortCode) : '';
      if (!code) {
        editLink.hidden = true;
        return;
      }

      var base = buildAdminDashboardUrl(cohort);
      editLink.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'edit=' + encodeURIComponent(code);
      editLink.hidden = false;
    }

    function setMessage(message, type) {
      var element = document.getElementById('cohort-status-message');
      if (!element) return;

      element.classList.remove('cohort-status-error');

      if (type !== 'error') {
        element.textContent = '';
        return;
      }

      element.textContent = message || '';
      element.classList.add('cohort-status-error');
    }

    function showFinalizeNotice(title, text, type) {
      var notice = document.getElementById('cohort-finalize-notice');
      var titleElement = document.getElementById('cohort-finalize-notice-title');
      var textElement = document.getElementById('cohort-finalize-notice-text');
      var progress = document.getElementById('cohort-finalize-notice-progress');
      var wait = document.getElementById('cohort-finalize-notice-wait');

      if (!notice || !titleElement || !textElement) return;

      if (!title && !text && !notice.classList.contains('is-loading')) {
        notice.classList.remove('show', 'is-error', 'is-sent', 'is-loading');
        titleElement.textContent = '';
        textElement.textContent = '';
        if (progress) {
          progress.hidden = true;
          progress.setAttribute('aria-hidden', 'true');
        }
        if (wait) wait.hidden = true;
        return;
      }

      notice.classList.add('show');
      notice.classList.remove('is-error', 'is-sent', 'is-loading');
      notice.classList.toggle('is-error', type === 'error');
      notice.classList.toggle('is-sent', type === 'pending' || type === 'success');
      titleElement.textContent = title || '';
      textElement.textContent = text || '';
      if (progress) {
        progress.hidden = true;
        progress.setAttribute('aria-hidden', 'true');
      }
      if (wait) wait.hidden = true;
    }

    function setFinalizeNoticeLoading(active, detailText) {
      var notice = document.getElementById('cohort-finalize-notice');
      var progress = document.getElementById('cohort-finalize-notice-progress');
      var wait = document.getElementById('cohort-finalize-notice-wait');
      var titleElement = document.getElementById('cohort-finalize-notice-title');
      var textElement = document.getElementById('cohort-finalize-notice-text');

      if (!notice) return;

      if (active) {
        notice.classList.add('show', 'is-loading');
        notice.classList.remove('is-error', 'is-sent');
        if (titleElement) titleElement.textContent = '';
        if (textElement) textElement.textContent = detailText || '';
        if (progress) {
          progress.hidden = false;
          progress.setAttribute('aria-hidden', 'false');
        }
        if (wait) wait.hidden = false;
        return;
      }

      stopFinalizeProgress();
      notice.classList.remove('is-loading');
      if (progress) {
        progress.hidden = true;
        progress.setAttribute('aria-hidden', 'true');
      }
      if (wait) wait.hidden = true;
    }

    var finalizeProgressTimer = null;
    var finalizeProgressFinishTimer = null;
    var finalizeProgressCompleteTimer = null;
    var finalizeEarlyFinishTimer = null;
    var finalizeProgressStartedAt = 0;
    var finalizeProgressCompleteCallback = null;
    var FINALIZE_PROGRESS_DURATION_MS = 20000;

    function updateFinalizeProgressVisual(percent) {
      var bar = document.getElementById('cohort-finalize-notice-progress-bar');
      var percentEl = document.getElementById('cohort-finalize-notice-percent');
      var clamped = Math.max(0, Math.min(100, percent));

      if (percentEl) percentEl.textContent = ' ' + clamped + '%';
      setStatusRingProgress(clamped);
      if (!bar) return;

      bar.classList.toggle('is-complete', clamped >= 100);
      bar.style.width = clamped + '%';
    }

    function tickFinalizeProgress() {
      var elapsed = Date.now() - finalizeProgressStartedAt;
      var ratio = Math.min(1, elapsed / FINALIZE_PROGRESS_DURATION_MS);
      var eased = 1 - Math.pow(1 - ratio, 1.85);

      updateFinalizeProgressVisual(Math.round(eased * 100));
    }

    function stopFinalizeProgress(resetVisual) {
      stopFinalizeEarlyFinishPoll();

      if (finalizeProgressTimer) {
        window.clearInterval(finalizeProgressTimer);
        finalizeProgressTimer = null;
      }

      if (finalizeProgressFinishTimer) {
        window.clearTimeout(finalizeProgressFinishTimer);
        finalizeProgressFinishTimer = null;
      }

      if (finalizeProgressCompleteTimer) {
        window.clearTimeout(finalizeProgressCompleteTimer);
        finalizeProgressCompleteTimer = null;
      }

      finalizeProgressCompleteCallback = null;
      hideStatusRingOverlay();

      if (resetVisual !== false) {
        var bar = document.getElementById('cohort-finalize-notice-progress-bar');
        var percentEl = document.getElementById('cohort-finalize-notice-percent');
        if (bar) {
          bar.style.width = '0%';
          bar.classList.remove('is-active', 'is-complete');
        }
        if (percentEl) percentEl.textContent = '…';
      }
    }

    function finishFinalizeProgress() {
      if (finalizeProgressTimer) {
        window.clearInterval(finalizeProgressTimer);
        finalizeProgressTimer = null;
      }

      var bar = document.getElementById('cohort-finalize-notice-progress-bar');
      if (bar) {
        bar.classList.remove('is-active');
        bar.classList.add('is-complete');
      }

      updateFinalizeProgressVisual(100);

      if (finalizeProgressCompleteTimer) {
        window.clearTimeout(finalizeProgressCompleteTimer);
      }

      finalizeProgressCompleteTimer = window.setTimeout(function() {
        finalizeProgressCompleteTimer = null;
        var done = finalizeProgressCompleteCallback;
        finalizeProgressCompleteCallback = null;
        if (typeof done === 'function') done();
      }, 200);
    }

    function startFinalizeProgress(onComplete) {
      stopFinalizeProgress(false);
      finalizeProgressStartedAt = Date.now();
      finalizeProgressCompleteCallback = typeof onComplete === 'function' ? onComplete : null;
      showStatusRingOverlay('Finalizing', FINALIZE_IN_PROGRESS_MESSAGE);

      var bar = document.getElementById('cohort-finalize-notice-progress-bar');
      if (bar) {
        bar.classList.add('is-active');
        bar.classList.remove('is-complete');
        bar.style.width = '0%';
      }

      updateFinalizeProgressVisual(0);
      finalizeProgressTimer = window.setInterval(tickFinalizeProgress, 90);
      window.requestAnimationFrame(function() {
        tickFinalizeProgress();
      });

      if (finalizeProgressFinishTimer) {
        window.clearTimeout(finalizeProgressFinishTimer);
      }

      finalizeProgressFinishTimer = window.setTimeout(function() {
        finalizeProgressFinishTimer = null;
        finishFinalizeProgress();
      }, FINALIZE_PROGRESS_DURATION_MS);

      startFinalizeEarlyFinishPoll(onComplete);
    }

    /*
      The bar is a timer, not a real progress reading — nothing in the browser
      can know when the Mechanic run ends. So poll alongside it (2026-08-03,
      owner request): the moment the school order actually exists, jump the bar
      to 100% and finish, instead of making the admin watch out the full 20s.
      finishFinalizeProgress() runs the same completion callback, so the reload
      and the post-finalize copy behave identically either way.
    */
    function startFinalizeEarlyFinishPoll(onComplete) {
      stopFinalizeEarlyFinishPoll();

      if (!currentCohortCode) return;

      var watchedCode = currentCohortCode;

      finalizeEarlyFinishTimer = window.setInterval(function() {
        if (!finalizeProgressCompleteCallback) {
          stopFinalizeEarlyFinishPoll();
          return;
        }

        backgroundSyncStatusPage(watchedCode).then(function() {
          if (!finalizeProgressCompleteCallback) return;
          if (!finalizeLooksComplete(currentCohort)) return;

          stopFinalizeEarlyFinishPoll();

          if (finalizeProgressFinishTimer) {
            window.clearTimeout(finalizeProgressFinishTimer);
            finalizeProgressFinishTimer = null;
          }

          finishFinalizeProgress();
        });
      }, 3000);
    }

    function stopFinalizeEarlyFinishPoll() {
      if (finalizeEarlyFinishTimer) {
        window.clearInterval(finalizeEarlyFinishTimer);
        finalizeEarlyFinishTimer = null;
      }
    }

    function scrollFinalizeNoticeIntoView() {
      var notice = document.getElementById('cohort-finalize-notice');
      if (!notice || typeof notice.scrollIntoView !== 'function') return;

      try {
        notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        notice.scrollIntoView();
      }
    }

    /*
      The finalize progress bar reloads the page when it completes, which wipes
      any success message shown before the reload. So the post-finalize copy is
      handed across the reload in sessionStorage and shown once on the way back.
    */
    function markFinalizeJustCompleted(cohortCode, lateBatchCode) {
      try {
        window.sessionStorage.setItem(FINALIZE_JUST_DONE_KEY, JSON.stringify({
          cohort_code: normalizeCode(cohortCode),
          late_batch_code: lateBatchCode || ''
        }));
      } catch (error) {}
    }

    function consumeFinalizeJustCompleted(cohortCode) {
      var raw = null;

      try {
        raw = window.sessionStorage.getItem(FINALIZE_JUST_DONE_KEY);
      } catch (error) {
        return null;
      }

      if (!raw) return null;

      try {
        window.sessionStorage.removeItem(FINALIZE_JUST_DONE_KEY);
      } catch (error) {}

      var parsed = null;

      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        return null;
      }

      if (!parsed || parsed.cohort_code !== normalizeCode(cohortCode)) return null;

      return parsed;
    }

    function writeActionLock(label, durationMs, details) {
      var duration = Math.min(durationMs || ACTION_LOCK_MAX_MS, ACTION_LOCK_MAX_MS);
      var record = {
        cohortCode: normalizeCode(currentCohortCode),
        label: label || 'Please wait',
        action: (details && details.action) || 'edit',
        lateBatchCode: (details && details.lateBatchCode) || '',
        expiresAt: Date.now() + duration
      };

      try {
        window.localStorage.setItem(ACTION_LOCK_KEY, JSON.stringify(record));
      } catch (error) {}

      return record;
    }

    function readActionLock() {
      var raw = null;

      try {
        raw = window.localStorage.getItem(ACTION_LOCK_KEY);
      } catch (error) {
        return null;
      }

      if (!raw) return null;

      var parsed = null;

      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        clearActionLock();
        return null;
      }

      if (!parsed || !parsed.expiresAt || Date.now() >= parsed.expiresAt) {
        clearActionLock();
        return null;
      }

      return parsed;
    }

    function bodyFitsKeepalive(body) {
      try {
        return new Blob([body]).size <= KEEPALIVE_MAX_BYTES;
      } catch (error) {
        return false;
      }
    }

    /*
      Shared fetch options for every webhook POST on this page. keepalive is set
      only when the body is small enough for the browser to accept it, so a big
      payload degrades to a normal request instead of failing outright.
    */
    function webhookInit(payload) {
      var body = JSON.stringify(payload);
      var init = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      };

      if (bodyFitsKeepalive(body)) init.keepalive = true;

      return init;
    }

    function clearActionLock() {
      try {
        window.localStorage.removeItem(ACTION_LOCK_KEY);
      } catch (error) {}

      if (actionLockReleaseTimer) {
        window.clearTimeout(actionLockReleaseTimer);
        actionLockReleaseTimer = null;
      }

      if (actionLockPollTimer) {
        window.clearInterval(actionLockPollTimer);
        actionLockPollTimer = null;
      }
    }

    function showFinalizedBanner(cohort) {
      var banner = document.getElementById('cohort-finalized-banner');
      var textElement = document.getElementById('cohort-finalized-banner-text');

      if (!banner || !textElement) return;

      if (!isCohortFinalized(cohort)) {
        banner.classList.remove('show');
        textElement.textContent = '';
        return;
      }

      var message = 'This cohort has already been finalized. ' + FINALIZE_INVOICE_MESSAGE;

      banner.classList.add('show');
      textElement.textContent = message;
    }

    function isCohortFinalized(cohort) {
      /* Keep in step with the same function in cohort-admin-form.js (2026-08-02 fix). */
      if (!cohort) return false;

      var draftOrderId = String(cohort.schoolDraftOrderId || '').trim();
      var status = String(cohort.status || '').toLowerCase();
      var finalizeLock = String(cohort.finalizeLock || '').toLowerCase();

      return !!(
        draftOrderId ||
        status === 'closed' ||
        status === 'completed' ||
        status === 'delivered' ||
        finalizeLock === 'complete' ||
        finalizeLock === 'locked' ||
        finalizeLock === 'true'
      );
    }

    function updateFinalizeButtonState(cohort, students) {
      var button = document.getElementById('cohort-finalize-button');
      if (!button) return;

      students = students || currentStudents || [];
      var finalized = isCohortFinalized(cohort);
      var confirmedCount = countConfirmedForFinalize(students);
      var blocked = !finalized && confirmedCount < 1;

      if (finalized) {
        finalizeAwaitingConfirmation = false;
      }

      /*
        The page reloads as soon as the progress bar finishes, but the Mechanic
        finalize task may still be writing the cohort record — so the freshly
        reloaded page can legitimately still read as "not finalized" and the
        button would look clickable again. Keep it visibly locked until the
        cohort record actually confirms the finalize (the 4s idle sync re-reads
        it), instead of showing an active button for an already-finalized cohort.
      */
      if (!finalized && finalizeAwaitingConfirmation) {
        button.classList.remove('is-blocked');
        button.classList.add('is-finalized');
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Finalizing...';
        button.disabled = true;
        showFinalizeBlockedBanner(false, NO_CONFIRMED_STUDENTS_MESSAGE);
        showFinalizedBanner(cohort);
        return;
      }

      button.classList.toggle('is-finalized', finalized);
      button.classList.toggle('is-blocked', blocked);
      button.setAttribute('aria-disabled', finalized || blocked ? 'true' : 'false');
      button.textContent = finalized ? 'Cohort Finalized' : 'Cohort Finalize';
      button.disabled = false;

      showFinalizeBlockedBanner(blocked, NO_CONFIRMED_STUDENTS_MESSAGE);
      if (blocked) {
        showFinalizeNotice('', '');
      }
      showFinalizedBanner(cohort);
    }

    function parseJson(value, fallback) {
      if (value == null || value === '') return fallback;
      if (typeof value === 'object') return value;

      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    }

    function getStudentIdentityEmail(student) {
      if (!student) return '';

      return String(
        student.email ||
        student.roster_email ||
        student.contact_email ||
        student.submitted_email ||
        ''
      ).trim().toLowerCase();
    }

    function normalizeStudentRecord(student) {
      if (!student || typeof student !== 'object') return student;

      var next = Object.assign({}, student);
      var identityEmail = getStudentIdentityEmail(next);

      if (identityEmail) {
        next.email = identityEmail;
      }

      return next;
    }

    function studentIdentityEmails(student) {
      var emails = [];
      ['email', 'roster_email', 'contact_email', 'submitted_email'].forEach(function(key) {
        var value = String(student && student[key] ? student[key] : '').trim().toLowerCase();
        if (value && emails.indexOf(value) === -1) {
          emails.push(value);
        }
      });
      return emails;
    }

    function parseStudentsJson(value) {
      var parsed = parseJson(value, []);
      var guard = 0;

      while (typeof parsed === 'string' && guard < 3) {
        parsed = parseJson(parsed, []);
        guard += 1;
      }

      if (!Array.isArray(parsed)) return [];

      return parsed
        .map(normalizeStudentRecord)
        .filter(function(student) {
          return student && !isRemovedStudent(student);
        });
    }

    function expandStudentsWithRosterPlaceholders(students, cohort) {
      var merged = dedupeStudentsByEmail(students || []);
      var roster = getRosterEmailsOrdered(cohort);

      roster.forEach(function(rosterEmail) {
        if (!findStudentByEmail(merged, rosterEmail)) {
          merged.push({
            email: rosterEmail,
            roster_email: rosterEmail,
            status: 'pending',
            email_match_status: 'matched'
          });
        }
      });

      return merged;
    }

    function dedupeStudentsByEmail(students) {
      var byEmail = {};

      (students || []).forEach(function(student) {
        var email = getStudentIdentityEmail(student);
        if (!email) return;

        var normalizedStudent = normalizeStudentRecord(student);
        var existing = byEmail[email];

        if (!existing || studentSubmissionPriority(normalizedStudent) > studentSubmissionPriority(existing)) {
          byEmail[email] = normalizedStudent;
        }
      });

      return Object.keys(byEmail).map(function(key) {
        return byEmail[key];
      });
    }

    function pruneDuplicateRosterPlaceholders(students, cohort) {
      var roster = getRosterEmailsOrdered(cohort);
      var submittedByRoster = {};

      roster.forEach(function(rosterEmail) {
        var submitted = (students || []).find(function(student) {
          return hasSubmittedSizes(student) && studentMatchesRosterEmail(student, rosterEmail);
        });

        if (submitted) {
          submittedByRoster[rosterEmail] = submitted;
          studentIdentityEmails(submitted).forEach(function(identityEmail) {
            submittedByRoster[identityEmail] = submitted;
          });
        }
      });

      return (students || []).filter(function(student) {
        if (hasSubmittedSizes(student)) return true;

        var identities = studentIdentityEmails(student);
        if (!identities.length) return true;

        return !identities.some(function(identityEmail) {
          return submittedByRoster[identityEmail];
        });
      });
    }

    function stripCohortLabelSuffix(label, cohortCode) {
      var text = String(label || '').trim();
      var code = String(cohortCode || '').trim();
      if (!text || !code) return text;

      var suffix = ' (' + code + ')';
      if (text.length > suffix.length && text.slice(-suffix.length).toUpperCase() === suffix.toUpperCase()) {
        return text.slice(0, -suffix.length).trim();
      }

      return text;
    }

    function getCohortLabel(cohort) {
      if (!cohort) return '';

      var code = cohort.cohortCode || currentCohortCode || '';
      var label = stripCohortLabelSuffix(cohort.cohortLabel || cohort.cohort_label || '', code);
      return label;
    }

    function isRemovedStudent(student) {
      var status = String(student && student.status ? student.status : '').toLowerCase();
      return status === 'removed' || status === 'archived';
    }

    /*
      Phase 8 (2026-08-12) — answered the form, has not paid for delivery.

      Deliberately NOT folded into hasSubmittedSizes: they did submit, so they
      owe nobody a form and must not be chased for one. What they are missing
      is a payment, which is why they get counted and labelled on their own.

      Twin of the same function in cohort-admin-form.js — the two pages must
      say the same thing about the same student.
    */
    /*
      Paid for their own delivery — read from the order written on the record
      when the payment landed, never guessed from the status. See the twin in
      cohort-admin-form.js for why "confirmed" cannot answer this.
    */
    function isPaidStudent(student) {
      return String(student && student.paid_order_id ? student.paid_order_id : '').trim() !== '';
    }

    function isAwaitingPaymentStudent(student) {
      var status = String(student && student.status ? student.status : '').toLowerCase();
      return status === 'awaiting_payment';
    }

    function isLateResubmitStudent(student) {
      if (!student || isRemovedStudent(student) || isUnmatchedStudent(student)) return false;
      if (hasSubmittedSizes(student)) return false;
      return String(student.late_resubmit_deadline || '').trim() !== '';
    }

    /*
      ── 2026-08-25 — the waiting room shows who the next round will take ────

      It listed only students who had not answered, while Start late round
      takes two kinds of people: those, and the ones who answered and never
      paid for delivery. The task has carried both since 2026-08-17 —
      awaiting_payment is in none of the billable lists in cohort-finalize, so
      such a student is not on the school's invoice and has no order of their
      own; the round is their only way back in.

      So the screen was a page behind the system: a student the round would
      collect sat in Submitted students among people whose uniforms were
      already bought, and the block that says who is waiting said nothing
      about them.

      Only after the cohort is finalized, which is when this list becomes a
      waiting room at all. Before that a student who owes for delivery has
      nothing to wait for: their own cohort is still open.
    */
    function isLateRosterStudent(student) {
      if (!student || isRemovedStudent(student) || isUnmatchedStudent(student)) return false;
      return !hasSubmittedSizes(student) || isAwaitingPaymentStudent(student);
    }

    function isLateStudent(student) {
      if (isCohortFinalized(currentCohort)) {
        return isLateRosterStudent(student);
      }

      return !hasSubmittedSizes(student);
    }

    function hasLateBatch(student) {
      return !!String(student && student.late_batch_code || '').trim();
    }

    /*
      2026-08-11 — mirrors isOpenRoundStudent in cohort-admin-form.js. The two
      files keep their own copies of the shared rules on purpose; both have to
      move together or the two pages disagree about who is where.
    */
    function isOpenRoundStudent(cohort, student) {
      var batchCode = String(student && student.late_batch_code || '').trim().toUpperCase();
      if (!batchCode) return false;

      var batch = parseLateBatches(cohort && cohort.cohortCode).filter(function(entry) {
        return String(entry.late_batch_code || '').trim().toUpperCase() === batchCode;
      })[0];

      /* 2026-08-11 — no record of the round means the student stays in it. Read
         the other way, a submitted LATE-01 student was listed under the
         finalized main cohort while their round showed nobody. Kept in step
         with the same function in cohort-admin-form.js. */
      if (!batch) return true;

      return String(batch.status || '').toLowerCase() !== 'finalized';
    }

    /*
      Owner's model, 2026-08-11: a student leaves the finalized cohort's list at
      the moment their round gets a deadline, and not before.

      This used to drop anyone carrying a batch code at all, so a student whose
      round had since been finalized vanished from both pages — they are back in
      the waiting room, and this list is where they are seen until the next
      round gives them a date.
    */
    /*
      Everyone the waiting room has claimed, keyed by the address they are known
      by — so the Submitted list can hand them over rather than show them twice.
    */
    function waitingRoomIdentityIndex(students, cohort) {
      var index = {};

      getPendingStudentsForDisplay(students, cohort).forEach(function(student) {
        var email = getStudentIdentityEmail(student);
        if (email) index[email] = true;
      });

      return index;
    }

    function withoutWaitingRoomStudents(students, cohort) {
      if (!isCohortFinalized(cohort)) return students || [];

      var claimed = waitingRoomIdentityIndex(students, cohort);

      return (students || []).filter(function(student) {
        return !claimed[getStudentIdentityEmail(student)];
      });
    }

    function getPendingStudentsForDisplay(students, cohort) {
      var base;

      if (isCohortFinalized(cohort)) {
        base = (students || []).filter(isLateRosterStudent);
      } else {
        base = (students || []).filter(function(student) {
          return !hasSubmittedSizes(student);
        });
      }

      return base.filter(function(student) {
        return !isOpenRoundStudent(cohort, student);
      });
    }

    /*
      Removed 2026-08-05 with the reminder buttons they served:
      studentEligibleForReminder, countReminderEligiblePending,
      syncReminderButtonsVisibility, getResendFormButtonLabel,
      getBulkResendButtonLabel, getResendModalTitle, getResendModalConfirmLabel,
      getResendMode. Reminders are sent from the dashboard now.
    */

    function isStudentTrackFinalized(cohort, student) {
      var batchCode = String(student && student.late_batch_code || '').trim().toUpperCase();

      if (!batchCode) {
        if (!isCohortFinalized(cohort)) return false;

        /*
          Main is finalized, but this student is not in any late batch yet — they
          never confirmed and have no order, so nothing about them went into the
          school invoice. They are waiting for the next late round, and the admin
          must still be able to correct or remove them. (The Mechanic tasks already
          allow this: they gate on the student's status, not on late_batch_code.)
        */
        if (!hasSubmittedSizes(student) && String(student.draft_order_id || '').trim() === '') {
          return false;
        }

        return true;
      }

      var batches = parseLateBatches(cohort && cohort.cohortCode);
      var batch = batches.find(function(b) {
        return String(b.late_batch_code || '').trim().toUpperCase() === batchCode;
      });

      /*
        'finalizing' means the run is in flight and the batch's students are
        already being built into the school invoice — everything is locked
        (2026-08-02 fix). Keep in step with cohort-admin-form.js.
      */
      if (batch && batch.status === 'finalizing') return true;

      var batchFinalized = !!(
        batch &&
        (batch.status === 'finalized' || String(batch.school_draft_order_id || '').trim())
      );

      if (!batchFinalized) return false;

      /*
        Same carve-out the Main track above already has (2026-08-03): the batch
        is finalized, but this student never confirmed and has no order, so
        nothing about them went into the school invoice. The admin must still be
        able to remove them instead of being stuck resending the form forever.
        cohort-remove-student.liquid already permits exactly this — it gates on
        the student's status, not on the batch — so the UI was the only thing
        blocking it.
      */
      if (!hasSubmittedSizes(student) && String(student.draft_order_id || '').trim() === '') {
        return false;
      }

      return true;
    }

    function canEditStudentEmail(cohort, student) {
      /* Keep in step with the same function in cohort-admin-form.js (2026-08-02 fix). */
      if (isRemovedStudent(student)) return false;
      if (!student) return !isCohortFinalized(cohort);
      return !isStudentTrackFinalized(cohort, student);
    }

    function canRemoveStudent(cohort, student) {
      if (isRemovedStudent(student)) return false;
      if (!student) return !isCohortFinalized(cohort);
      return !isStudentTrackFinalized(cohort, student);
    }

    /*
      True when `email` already identifies a different, still-active student in
      the loaded cohort. Removed/archived entries do not count — their address is
      free to reuse.
    */
    function isEmailTakenByAnotherStudent(email, exceptStudent) {
      var normalized = String(email || '').trim().toLowerCase();
      if (!normalized) return false;

      var exceptIdentity = exceptStudent ? getStudentIdentityEmail(exceptStudent) : '';

      return (currentStudents || []).some(function(student) {
        if (isRemovedStudent(student)) return false;
        if (exceptStudent && student === exceptStudent) return false;
        if (exceptIdentity && getStudentIdentityEmail(student) === exceptIdentity) return false;

        return [
          student.email,
          student.roster_email,
          student.submitted_email,
          student.contact_email
        ].some(function(candidate) {
          return String(candidate || '').trim().toLowerCase() === normalized;
        });
      });
    }

    function findStudentByEmail(students, email) {
      var normalized = String(email || '').trim().toLowerCase();
      if (!normalized) return null;

      var matches = (students || []).filter(function(student) {
        var studentEmail = String(student.email || '').trim().toLowerCase();
        var rosterEmail = String(student.roster_email || '').trim().toLowerCase();
        var submittedEmail = String(student.submitted_email || '').trim().toLowerCase();
        var contactEmail = String(student.contact_email || '').trim().toLowerCase();
        return (
          studentEmail === normalized ||
          rosterEmail === normalized ||
          submittedEmail === normalized ||
          contactEmail === normalized
        );
      });

      if (!matches.length) return null;

      matches.sort(function(a, b) {
        return studentSubmissionPriority(b) - studentSubmissionPriority(a);
      });

      return matches[0];
    }

    function studentMatchesRosterEmail(student, email) {
      return !!findStudentByEmail([student], email);
    }

    function buildStatusStudentsList(students, cohort) {
      return pruneDuplicateRosterPlaceholders(
        expandStudentsWithRosterPlaceholders(
          dedupeStudentsByEmail(sortStudents(students || [])),
          cohort || {}
        ),
        cohort || {}
      );
    }

    function isStatusEmailEditing() {
      var results = document.getElementById('cohort-status-results');
      if (results && results.classList.contains('is-saving')) return true;

      var inputs = document.querySelectorAll('.status-em-input');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input === document.activeElement) return true;

        var saved = String(input.getAttribute('data-current-email') || '').trim().toLowerCase();
        var current = String(input.value || '').trim().toLowerCase();
        if (current !== saved) return true;
      }

      return false;
    }

    function studentSubmissionPriority(student) {
      if (hasSubmittedSizes(student)) return 3;
      var status = String(student && student.status ? student.status : '').toLowerCase();
      if (status === 'confirmed' || status === 'submitted') return 2;
      return 1;
    }

    function scheduleStatusPageRefresh(cohortCode, focusEmail) {
      finishStatusEmailMutation(cohortCode, focusEmail);
    }

    function setStatusActionLoading(active, waitText) {
      var results = document.getElementById('cohort-status-results');
      var progress = document.getElementById('cohort-status-action-progress');
      var progressText = document.getElementById('cohort-status-action-progress-text');

      if (results) {
        results.classList.toggle('cohort-inline-loading', !!active);
        results.classList.toggle('is-saving', !!active);
        results.classList.toggle('is-action-loading', !!active);
      }

      if (progress) {
        progress.hidden = !active;
        progress.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      if (progressText) {
        progressText.hidden = !active;
        progressText.setAttribute('aria-hidden', active ? 'false' : 'true');
        var progressLabelEl = document.getElementById('cohort-status-action-progress-label');
        if (progressLabelEl) progressLabelEl.textContent = waitText || 'Please wait';
      }
    }

    function setStatusEmailLoading(active) {
      setStatusActionLoading(active, 'Please wait');
    }

    function setStatusCardLoading(card, active) {
      if (!card) return;
      card.classList.toggle('is-email-saving', !!active);
      ['.status-em-save', '.status-em-resend', '.status-em-remove'].forEach(function(selector) {
        card.querySelectorAll(selector).forEach(function(el) {
          el.disabled = !!active;
        });
      });
    }

    /*
      The blocking edit/remove load shows a circular progress ring instead of the
      thin bar. The percent lives inside the ring, so the text label next to it
      is left as plain "Please wait" while the ring is running.
    */
    function setStatusRingProgress(pct) {
      var ringValue = document.getElementById('cohort-status-action-ring-value');
      var ringPercent = document.getElementById('cohort-status-action-ring-percent');
      var clamped = Math.max(0, Math.min(100, pct));

      if (ringValue) {
        ringValue.style.strokeDashoffset = String(STATUS_RING_CIRCUMFERENCE * (1 - clamped / 100));
      }
      if (ringPercent) ringPercent.textContent = clamped + '%';
    }

    /*
      One shared loading visual for the whole page. It is a fixed, viewport-
      centred overlay, so it always appears wherever the admin is scrolled to —
      and it lives outside #cohort-status-results, which gets opacity/filter
      while blocking (a filtered ancestor would also break position: fixed).
    */
    function showStatusRingOverlay(labelText, noteText) {
      var ring = document.getElementById('cohort-status-action-ring');
      var labelEl = document.getElementById('cohort-status-action-ring-label');
      var noteEl = document.getElementById('cohort-status-action-ring-note');

      if (labelEl) labelEl.textContent = labelText || 'Please wait';

      if (noteEl) {
        noteEl.textContent = noteText || '';
        noteEl.style.display = noteText ? '' : 'none';
      }

      if (ring) {
        ring.hidden = false;
        ring.setAttribute('aria-hidden', 'false');
      }

      setStatusRingProgress(0);
    }

    function hideStatusRingOverlay() {
      var ring = document.getElementById('cohort-status-action-ring');

      if (ring) {
        ring.hidden = true;
        ring.setAttribute('aria-hidden', 'true');
      }

      setStatusRingProgress(0);
    }

    function startStatusActionProgress(duration, labelText) {
      stopStatusActionProgress();

      var bar = document.querySelector('#cohort-status-action-progress .cohort-status-action-progress-bar');
      var percentEl = document.getElementById('cohort-status-action-progress-percent');
      var startedAt = Date.now();

      if (bar) {
        bar.classList.add('is-determinate');
        bar.style.width = '0%';
      }
      if (percentEl) percentEl.textContent = '';
      showStatusRingOverlay(labelText);

      function tick() {
        var elapsed = Date.now() - startedAt;
        var pct = Math.min(100, Math.round((elapsed / duration) * 100));
        if (bar) bar.style.width = pct + '%';
        setStatusRingProgress(pct);

        if (elapsed < duration) {
          statusActionProgressRaf = window.requestAnimationFrame(tick);
        } else {
          statusActionProgressRaf = null;
        }
      }

      statusActionProgressRaf = window.requestAnimationFrame(tick);
    }

    function stopStatusActionProgress() {
      if (statusActionProgressRaf) {
        window.cancelAnimationFrame(statusActionProgressRaf);
        statusActionProgressRaf = null;
      }

      var bar = document.querySelector('#cohort-status-action-progress .cohort-status-action-progress-bar');
      var percentEl = document.getElementById('cohort-status-action-progress-percent');

      if (bar) {
        bar.classList.remove('is-determinate');
        bar.style.width = '';
      }
      if (percentEl) percentEl.textContent = '…';
      hideStatusRingOverlay();
    }

    /*
      Whole-page block, not just #cohort-status-results: while any write action
      is in flight, every other action on this page — finalize, late finalize,
      another student's edit/remove, the cohort code form — has to be
      unclickable too. They all end up writing the same cohort record from
      separate Mechanic tasks, and letting a second one start mid-flight is
      what produced the lost-update bugs in docs/regression-log.md.
    */
    function setStatusPageBlocked(active) {
      var wrapper = document.querySelector('.cohort-status-wrapper');
      var results = document.getElementById('cohort-status-results');

      if (wrapper) wrapper.classList.toggle('is-page-blocked', !!active);
      if (results) results.classList.toggle('is-blocking', !!active);
    }

    function beginStatusActionBlockingLoad(durationMs, labelText, lockDetails) {
      var duration = durationMs || STATUS_ACTION_EDIT_MS;
      statusActionBlockingMinUntil = Date.now() + duration;
      setStatusEmailLoading(true);
      setStatusPageBlocked(true);
      writeActionLock(labelText, duration, lockDetails);
      startStatusActionProgress(duration, labelText);
    }

    /*
      2026-08-04 — the block used to end purely on a timer, so two things went
      wrong: a change that finished in 3s still held the page for the full
      duration, and a change that had NOT landed yet handed the page back
      showing stale data (a removed student stayed on screen until the admin
      reloaded by hand).

      Now the timer is only a MINIMUM. pendingStatusEmailMutation is the real
      signal — scheduleStatusPageSync clears it once the server confirms the
      change. So: confirmed early -> release early; not confirmed when the timer
      ends -> keep holding (never show stale data) up to a hard cap, then
      release and reload so the admin always ends up looking at the truth.
    */
    var STATUS_ACTION_CONFIRM_CAP_MS = 60000;
    var statusActionConfirmTimer = null;
    var statusActionConfirmCapAt = 0;
    var statusMutationUnconfirmed = false;

    function stopStatusActionConfirmWatch() {
      if (statusActionConfirmTimer) {
        window.clearTimeout(statusActionConfirmTimer);
        statusActionConfirmTimer = null;
      }
    }

    /* Called when the sync ladder confirms the change — cut the block short. */
    function onStatusMutationConfirmed() {
      if (!statusActionBlockingMinUntil && !statusActionConfirmTimer) return;
      finishStatusActionBlockingLoad(true);
    }

    function finishStatusActionBlockingLoad(force) {
      function release() {
        /*
          The lock is cleared here, not at the top of this function: the visible
          block runs to its minimum duration on purpose, and the Mechanic task is
          still writing during that tail. Clearing early would let a refresh in
          that window hand the buttons back too soon.
        */
        clearActionLock();
        setStatusEmailLoading(false);
        stopStatusActionProgress();
        setStatusPageBlocked(false);

        /*
          One last read straight after unblocking (2026-08-03). Without it the
          admin could be handed back a list the retry ladder had not caught up
          with yet — the point of waiting out the block is to see the result,
          not to reload the page by hand.
        */
        if (currentCohortCode) {
          backgroundSyncStatusPage(currentCohortCode).then(function() {
            refreshStatusStudentGrids();
            renderLateBatchesSection(currentCohortCode);
          });
        }
      }

      /*
        Runs once the minimum has elapsed. Releases only when the change is
        confirmed; otherwise keeps holding and re-checks, and as a last resort
        reloads rather than showing a list we know is out of date.
      */
      function releaseWhenConfirmed() {
        stopStatusActionConfirmWatch();

        if (!pendingStatusEmailMutation && !statusMutationUnconfirmed) {
          release();
          return;
        }

        if (!statusMutationUnconfirmed && Date.now() < statusActionConfirmCapAt) {
          statusActionConfirmTimer = window.setTimeout(releaseWhenConfirmed, 2000);
          return;
        }

        /* Gave it long enough — clear the lock first so the reloaded page does
           not immediately re-block, then let the server state speak. */
        statusMutationUnconfirmed = false;
        clearActionLock();
        stopStatusActionProgress();

        if (currentCohortCode) {
          reloadWithCohort(currentCohortCode);
          return;
        }

        release();
      }

      if (!statusActionBlockingMinUntil) {
        stopStatusActionConfirmWatch();
        release();
        return;
      }

      var remaining = force ? 0 : (statusActionBlockingMinUntil - Date.now());
      statusActionBlockingMinUntil = 0;

      if (!statusActionConfirmCapAt) {
        statusActionConfirmCapAt = Date.now() + STATUS_ACTION_CONFIRM_CAP_MS;
      }

      /*
        force means the change is already confirmed (or the request failed
        outright), so skip the confirmation wait entirely.
      */
      if (force) {
        statusActionConfirmCapAt = 0;
        statusMutationUnconfirmed = false;
        stopStatusActionConfirmWatch();
        release();
        return;
      }

      if (remaining > 0) {
        statusActionConfirmTimer = window.setTimeout(releaseWhenConfirmed, remaining);
      } else {
        releaseWhenConfirmed();
      }
    }

    /*
      ── The lock belongs to one cohort, not to the browser ─────────────────

      2026-09-14, owner: she finalized one cohort, opened a different one, and
      that page told her a change was still being applied. It was - to the
      other cohort.

      The record has always carried the cohort it was made for; this page
      simply never looked. So a five-minute wait for one cohort blocked every
      cohort the same person opened, and the early exit could not rescue her:
      it polls the cohort on screen, which was never going to finalize.

      One function, asked by both the block and the leave-the-page warning,
      because the same question answered in two places is how this project
      grows a pair of rules that quietly disagree.

      A lock that names no cohort still applies: it predates this field, or
      belongs to an action that is not about one cohort, and the careful answer
      there is to keep waiting.

      Worth saying plainly, since it reads like a leak and is not one: the
      record lives in this browser's own storage. No other administrator ever
      saw it.
    */
    function lockAppliesToThisPage(lock) {
      if (!lock) return false;

      var lockCode = normalizeCodeLoose(lock.cohortCode || '');
      if (!lockCode) return true;

      var pageCode = normalizeCodeLoose(
        currentCohortCode || getParam('cohort') || getParam('code') || getParam('cohort_code') || ''
      );
      if (!pageCode) return true;

      return lockCode === pageCode;
    }

    /*
      Re-apply the block after a manual browser refresh (or in a second tab).
      Runs on every page load: if a live lock record is present, the page comes
      back up already blocked, with the ring showing the time left.
    */
    function restoreActionLockUi() {
      var lock = readActionLock();
      if (!lock) return;

      if (!lockAppliesToThisPage(lock)) return;

      var remaining = lock.expiresAt - Date.now();
      if (remaining <= 0) {
        clearActionLock();
        return;
      }

      /*
        Nothing to wait for: the finalize already landed before this reload, so
        do not make the admin sit through a block for work that is done.
      */
      if ((lock.action === 'finalize' || lock.action === 'finalize_late') && restoredFinalizeLooksDone(lock)) {
        clearActionLock();
        return;
      }

      statusActionBlockingMinUntil = 0;
      setStatusPageBlocked(true);
      setStatusEmailLoading(true);
      startStatusActionProgress(remaining, lock.label);
      showStatusRingOverlay(lock.label, ACTION_LOCK_RESUMED_NOTE);

      actionLockReleaseTimer = window.setTimeout(releaseRestoredActionLock, remaining);

      /*
        Finalize is the long one, so it also gets an early exit: poll the server
        and drop the block the moment the cohort (or late batch) actually reads
        as finalized, instead of always sitting out the full two minutes.
      */
      if (lock.action === 'finalize' || lock.action === 'finalize_late') {
        actionLockPollTimer = window.setInterval(function() {
          if (!currentCohortCode) return;

          backgroundSyncStatusPage(currentCohortCode).then(function() {
            if (restoredFinalizeLooksDone(lock)) releaseRestoredActionLock();
          });
        }, 5000);
        return;
      }

      /*
        2026-08-05 — every other action (roster edits from the dashboard) now
        watches the lock itself. Two things were wrong before: this page sat out
        the lock's full expiry even when the dashboard had finished in twenty
        seconds, and when it finally unblocked it re-rendered from the data it
        had loaded at page load — so the newly added students were simply not
        there and the admin had to reload by hand.
      */
      actionLockPollTimer = window.setInterval(function() {
        if (readActionLock()) return;
        releaseRestoredActionLock();
      }, 2000);
    }

    function releaseRestoredActionLock() {
      clearActionLock();

      /*
        Fetch before rendering. refreshStatusStudentGrids() draws whatever is in
        memory, and in memory is the page as it was loaded — unblocking without
        a re-fetch shows a list that is already out of date.
      */
      if (currentCohortCode) {
        backgroundSyncStatusPage(currentCohortCode).then(function() {
          finishRestoredActionLockRelease();
        }).catch(function() {
          finishRestoredActionLockRelease();
        });
        return;
      }

      finishRestoredActionLockRelease();
    }

    function finishRestoredActionLockRelease() {
      setStatusEmailLoading(false);
      stopStatusActionProgress();
      setStatusPageBlocked(false);

      if (currentCohortCode) {
        refreshStatusStudentGrids();
        renderLateBatchesSection(currentCohortCode);
      }
    }

    /*
      "The finalize run actually finished" — deliberately NOT isCohortFinalized(),
      which already returns true on finalize_lock === 'locked', i.e. while the run
      is still in progress. Releasing the block on that would defeat the whole
      point. Completion means the school draft order exists, or finalize_lock has
      flipped to 'complete' (written by cohort-capture-draft-order.liquid once the
      order is confirmed). If neither ever lands, the lock's own expiry still
      unblocks the page — this check only makes the common case faster.
    */
    function finalizeLooksComplete(cohort) {
      if (!cohort) return false;

      var draftOrderId = String(cohort.schoolDraftOrderId || '').trim();
      var finalizeLock = String(cohort.finalizeLock || '').toLowerCase();

      return !!(draftOrderId || finalizeLock === 'complete');
    }

    function restoredFinalizeLooksDone(lock) {
      if (normalizeCode(lock.cohortCode) !== normalizeCode(currentCohortCode)) return false;

      if (lock.action === 'finalize_late') {
        var batchCode = String(lock.lateBatchCode || '').trim().toUpperCase();
        if (!batchCode) return false;

        var batch = parseLateBatches(currentCohortCode).find(function(entry) {
          return String(entry.late_batch_code || '').trim().toUpperCase() === batchCode;
        });

        return !!(
          batch &&
          (batch.status === 'finalized' || String(batch.school_draft_order_id || '').trim())
        );
      }

      return finalizeLooksComplete(currentCohort);
    }

    function persistStatusStudents(students) {
      var cache = findCacheByCode(currentCohortCode);
      if (cache) {
        cache.studentsJson = JSON.stringify(students || []);
      }

      rebuildStatusSummaryFromState();
    }

    function rebuildStatusSummaryFromState() {
      var cache = findCacheByCode(currentCohortCode);
      if (!cache) return;

      var roster = getRosterEmailsOrdered(currentCohort);
      var students = dedupeStudentsByEmail(currentStudents || []);
      var submitted = students.filter(hasSubmittedSizes).length;
      var unmatched = students.filter(function(student) {
        return isUnmatchedStudent(student) && hasSubmittedSizes(student);
      }).length;

      cache.summaryJson = JSON.stringify({
        total_students: Math.max(students.length, roster.length),
        submitted: submitted,
        confirmed: students.filter(function(student) {
          return String(student.status || '').toLowerCase() === 'confirmed';
        }).length,
        pending: Math.max(0, Math.max(students.length, roster.length) - submitted),
        unmatched: unmatched
      });
    }

    function beginStatusEmailMutation(type, details) {
      pendingStatusEmailMutation = {
        cohortCode: normalizeCode(currentCohortCode),
        type: type,
        details: details || {},
        startedAt: Date.now()
      };
    }

    function statusMutationLooksApplied(mutation, serverRoster, serverStudents) {
      if (!mutation) return true;

      var details = mutation.details || {};
      var roster = serverRoster || [];
      var students = serverStudents || [];

      function rosterHas(email) {
        return roster.indexOf(String(email || '').trim().toLowerCase()) !== -1;
      }

      function studentsHave(email) {
        var normalized = String(email || '').trim().toLowerCase();
        return students.some(function(student) {
          return String(student.email || '').trim().toLowerCase() === normalized;
        });
      }

      if (mutation.type === 'remove') {
        return !rosterHas(details.email) && !studentsHave(details.email);
      }

      if (mutation.type === 'fix') {
        var current = String(details.current || '').trim().toLowerCase();
        var corrected = String(details.corrected || '').trim().toLowerCase();

        if (!rosterHas(corrected) || rosterHas(current)) {
          return false;
        }

        if (studentsHave(current)) {
          return false;
        }

        if (details.hadSubmittedStudent) {
          return students.some(function(student) {
            return String(student.email || '').trim().toLowerCase() === corrected && hasSubmittedSizes(student);
          });
        }

        return true;
      }

      return true;
    }

    function mergeStatusPageServerData(freshCaches, freshCohorts) {
      if (!pendingStatusEmailMutation || normalizeCode(pendingStatusEmailMutation.cohortCode) !== normalizeCode(currentCohortCode)) {
        return { caches: freshCaches, cohorts: freshCohorts };
      }

      var localCache = findCacheByCode(currentCohortCode);
      var localRoster = getRosterEmailsOrdered(currentCohort);
      var localStudents = dedupeStudentsByEmail(currentStudents || []);

      var freshCache = (freshCaches || []).find(function(entry) {
        return normalizeCode(entry.cohortCode) === normalizeCode(currentCohortCode);
      });
      var freshCohort = (freshCohorts || []).find(function(entry) {
        return normalizeCode(entry.cohortCode || entry.code) === normalizeCode(currentCohortCode);
      });

      var serverRoster = getRosterEmailsOrdered(freshCohort || {});
      var serverStudents = [];

      try {
        var rawStudents = freshCache && freshCache.studentsJson;
        serverStudents = dedupeStudentsByEmail(
          Array.isArray(rawStudents) ? rawStudents : JSON.parse(rawStudents || '[]')
        );
      } catch (error) {
        serverStudents = [];
      }

      if (!statusMutationLooksApplied(pendingStatusEmailMutation, serverRoster, serverStudents)) {
        if (freshCache && localCache) {
          freshCache.studentsJson = localCache.studentsJson;
          freshCache.summaryJson = localCache.summaryJson;
        }
        if (freshCohort && currentCohort) {
          freshCohort.studentEmailsRaw = currentCohort.studentEmailsRaw;
        }
      }

      return { caches: freshCaches, cohorts: freshCohorts };
    }

    function scheduleStatusPageSync(cohortCode, attempt) {
      if (statusPageSyncTimer) {
        window.clearTimeout(statusPageSyncTimer);
        statusPageSyncTimer = null;
      }

      /*
        Ladder extended to ~45s (2026-08-03), matching cohort-admin-form.js. It
        used to give up at ~23s — sooner than the block itself on the slower
        actions — so polling had already stopped by the time the admin got the
        page back, and the change only appeared after a manual refresh.
      */
      var delays = [800, 2000, 4000, 6000, 10000, 10000, 12000];
      if (attempt >= delays.length) {
        /*
          Ladder ran out without the server ever confirming. pendingStatusEmail-
          Mutation has to be cleared (otherwise idle sync stays paused forever),
          so record the failure separately — the release path needs to know the
          change was never verified so it reloads instead of showing a list it
          could not confirm.
        */
        statusMutationUnconfirmed = true;
        pendingStatusEmailMutation = null;
        return;
      }

      statusPageSyncTimer = window.setTimeout(function() {
        backgroundSyncStatusPage(cohortCode).then(function(settled) {
          if (!settled) {
            scheduleStatusPageSync(cohortCode, attempt + 1);
            return;
          }

          pendingStatusEmailMutation = null;
          /* Server confirmed the change — no reason to keep the page blocked. */
          onStatusMutationConfirmed();
        });
      }, delays[attempt]);
    }

    function startStatusIdleSync() {
      stopStatusIdleSync();

      statusIdleSyncInterval = window.setInterval(function() {
        if (document.hidden || !currentCohortCode) return;

        var results = document.getElementById('cohort-status-results');
        if (results && results.classList.contains('is-saving')) return;
        if (pendingStatusEmailMutation) return;
        if (isStatusEmailEditing()) return;
        if (Date.now() < reminderStatusHoldUntil) return;

        backgroundSyncStatusPage(currentCohortCode);
      }, 4000);
    }

    function stopStatusIdleSync() {
      if (statusIdleSyncInterval) {
        window.clearInterval(statusIdleSyncInterval);
        statusIdleSyncInterval = null;
      }
    }

    function getRosterEmailsOrdered(cohort) {
      return getRosterEmails(cohort && cohort.studentEmailsRaw);
    }

    /*
      Keep in step with the same helper in cohort-admin-form.js — see the long
      note there. In short: a Liquid array that prints both a leading and a
      trailing comma yields [{a},,{b}], an array with holes. forEach/map/filter
      skip holes so pages look fine, but find() does not, and on the dashboard
      that turned into an overlay that never closed. Real objects only.
    */
    function sanitizeParsedArray(parsed) {
      if (!Array.isArray(parsed)) return parsed;

      return parsed.filter(function(entry) {
        return !!entry && typeof entry === 'object';
      });
    }

    function extractWindowArrayFromHtml(html, varName) {
      var marker = 'window.' + varName + ' = ';
      var start = html.indexOf(marker);
      if (start === -1) return null;

      start += marker.length;
      if (html.charAt(start) !== '[') return null;

      var depth = 0;
      for (var i = start; i < html.length; i += 1) {
        if (html.charAt(i) === '[') depth += 1;
        if (html.charAt(i) === ']') {
          depth -= 1;
          if (depth === 0) {
            var literal = html.slice(start, i + 1);

            try {
              return sanitizeParsedArray(JSON.parse(literal));
            } catch (error) {
              /*
                Keep in step with the same helper in cohort-admin-form.js.
                cohort-status.liquid writes these arrays with bare JavaScript
                keys (cohortCode: "..."), which JSON.parse cannot read: it threw
                on every sync and this returned null silently, so the status page
                never saw fresh data and only ever updated on a manual reload
                (found 2026-08-05). Evaluating the literal is safe here — it is
                same-origin markup this page already ran as script.
              */
              try {
                return sanitizeParsedArray((new Function('return (' + literal + ');'))());
              } catch (fallbackError) {
                if (window.console && console.warn) {
                  console.warn('[cohort] could not read ' + varName + ' from the synced page', fallbackError);
                }
                return null;
              }
            }
          }
        }
      }

      return null;
    }

    function backgroundSyncStatusPage(cohortCode) {
      var syncUrl = window.location.pathname + window.location.search;
      var joiner = syncUrl.indexOf('?') >= 0 ? '&' : '?';
      syncUrl += joiner + '_sync=' + Date.now();

      /* Same request shape as the dashboard's sync — see the note there. */
      return fetch(syncUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var freshCaches = extractWindowArrayFromHtml(html, 'COHORT_STATUS_CACHES');
          var freshCohorts = extractWindowArrayFromHtml(html, 'COHORTS');

          /*
            2026-08-06 — keep in step with backgroundSyncEmailPanel in
            cohort-admin-form.js, where this bit me: a refresh that comes back
            empty is a read that failed, not proof the shop is empty. On the
            dashboard it emptied a cohort on screen and made an already-open
            late round look absent, which invited a second one. This page only
            displays, so the damage here would be smaller — but it would be the
            same lie, and an admin acting on it is the same problem.
          */
          var cachesUsable = Array.isArray(freshCaches) && (freshCaches.length > 0 || caches.length === 0);
          var cohortsUsable = Array.isArray(freshCohorts) && (freshCohorts.length > 0 || cohorts.length === 0);

          if (!cachesUsable || !cohortsUsable) {
            if (window.console && console.warn) {
              console.warn(
                '[cohort] ignoring an empty background refresh — keeping what is on screen. ' +
                'cohorts: ' + (freshCohorts ? freshCohorts.length : 'unreadable') + ' (had ' + cohorts.length + '), ' +
                'caches: ' + (freshCaches ? freshCaches.length : 'unreadable') + ' (had ' + caches.length + ')'
              );
            }

            return false;
          }

          var merged = mergeStatusPageServerData(freshCaches, freshCohorts);
          var serverRoster = [];
          var serverStudents = [];

          if (merged.caches) {
            window.COHORT_STATUS_CACHES = merged.caches;
            caches = merged.caches;
          }

          if (merged.cohorts) {
            window.COHORTS = merged.cohorts;
            cohorts = merged.cohorts;
          }

          if (currentCohortCode && normalizeCode(currentCohortCode) === normalizeCode(cohortCode)) {
            var cache = findCacheByCode(cohortCode);
            var cohort = findCohortByCode(cohortCode);
            currentCohort = cohort || currentCohort || {};
            currentStudents = buildStatusStudentsList(
              cache ? parseStudentsJson(cache.studentsJson) : [],
              currentCohort
            );
            serverRoster = getRosterEmailsOrdered(currentCohort);
            serverStudents = currentStudents.slice();
            if (!isStatusEmailEditing()) {
              refreshStatusStudentGrids();
            } else {
              rebuildStatusSummaryFromState();
            }
          }

          if (pendingStatusEmailMutation && !statusMutationLooksApplied(pendingStatusEmailMutation, serverRoster, serverStudents)) {
            return false;
          }

          return true;
        })
        .catch(function() {
          return false;
        });
    }

    function applyOptimisticStatusEmailFix(currentEmail, correctedEmail) {
      var current = String(currentEmail || '').trim().toLowerCase();
      var corrected = String(correctedEmail || '').trim().toLowerCase();
      var roster = getRosterEmailsOrdered(currentCohort);

      var nextRoster = roster.map(function(email) {
        var normalizedEmail = String(email || '').trim().toLowerCase();
        return normalizedEmail === current ? corrected : normalizedEmail;
      });

      if (roster.indexOf(current) === -1 && nextRoster.indexOf(corrected) === -1) {
        nextRoster.push(corrected);
      }

      var seenRoster = {};
      nextRoster = nextRoster.filter(function(email) {
        if (!email || seenRoster[email]) return false;
        seenRoster[email] = true;
        return true;
      });

      var correctedOnRoster = nextRoster.indexOf(corrected) !== -1;

      currentStudents = currentStudents.map(function(student) {
        if (String(student.email || '').trim().toLowerCase() !== current) {
          return student;
        }

        var updated = Object.assign({}, student, {
          email: corrected,
          submitted_email: corrected,
          contact_email: corrected,
          roster_email: correctedOnRoster ? corrected : ''
        });
        updated.email_match_status = correctedOnRoster ? 'matched' : 'unmatched';

        return updated;
      });

      currentStudents = dedupeStudentsByEmail(currentStudents);

      var seenCorrected = false;
      currentStudents = currentStudents.filter(function(student) {
        var email = String(student.email || '').trim().toLowerCase();
        if (email !== corrected) return true;
        if (!seenCorrected) {
          seenCorrected = true;
          return true;
        }
        return false;
      });

      if (currentCohort) {
        currentCohort.studentEmailsRaw = JSON.stringify(nextRoster);
        var cohortMatchFix = cohorts.find(function(entry) {
          return normalizeCode(entry.cohortCode || entry.code) === normalizeCode(currentCohortCode);
        });
        if (cohortMatchFix) {
          cohortMatchFix.studentEmailsRaw = currentCohort.studentEmailsRaw;
        }
      }

      persistStatusStudents(currentStudents);
    }

    function applyOptimisticStatusRemove(email) {
      var normalized = String(email || '').trim().toLowerCase();

      currentStudents = currentStudents.filter(function(student) {
        return String(student.email || '').trim().toLowerCase() !== normalized;
      });

      var nextRoster = getRosterEmailsOrdered(currentCohort).filter(function(item) {
        return item !== normalized;
      });

      if (currentCohort) {
        currentCohort.studentEmailsRaw = JSON.stringify(nextRoster);
        var cohortMatch = cohorts.find(function(entry) {
          return normalizeCode(entry.cohortCode || entry.code) === normalizeCode(currentCohortCode);
        });
        if (cohortMatch) {
          cohortMatch.studentEmailsRaw = currentCohort.studentEmailsRaw;
        }
      }

      persistStatusStudents(currentStudents);
    }

    /*
      Hidden while the number is zero, which is every cohort until the payment
      step ships. An empty pill reading "Waiting for payment 0" would add a
      worry to a page where nothing is wrong.
    */
    function renderAwaitingPaymentPill(count) {
      var pill = document.getElementById('summary-awaiting-payment-pill');
      var value = document.getElementById('summary-awaiting-payment');
      if (!pill || !value) return;

      value.textContent = count;
      pill.hidden = count < 1;
    }

    /*
      2026-08-24 — one writer for the lines under the counters (owner).

      Two functions draw this row: this page renders once from the cache and
      again when the full student list arrives. Only the later one had been
      taught the new lines, so the first paint showed the old "listed 5 / not
      listed 1" under Confirmed and nothing at all under Total, and a second
      later the words changed under the reader's eye.

      Both call this now, so the notes appear with their numbers and stay put.
      Written as HTML for the line break only; every value in it is a count.
    */
    function renderSummaryNotes(students, rosterCount) {
      var list = students || [];

      var totalNote = document.getElementById('summary-total-note');
      if (totalNote) {
        var joinedByLink = list.filter(function(student) {
          return !isRemovedStudent(student) && isUnmatchedStudent(student);
        }).length;

        /* One line now: the tile is left aligned and wide enough to hold it,
           and a break in the middle of a sentence read as two facts. */
        totalNote.textContent = joinedByLink > 0
          ? rosterCount + ' uploaded by admin, ' + joinedByLink + ' not on the list'
          : rosterCount + ' uploaded by admin';
      }

      var submittedNote = document.getElementById('summary-submitted-note');
      if (submittedNote) {
        submittedNote.textContent = 'sizes chosen, shipping paid';
      }
    }

    function refreshStatusStudentGrids(focusEmail) {
      var pending = getPendingStudentsForDisplay(currentStudents, currentCohort);
      var submitted = currentStudents.filter(hasSubmittedSizes);
      var mainSubmitted = withoutWaitingRoomStudents(
        submitted.filter(function(student) {
          return !hasLateBatch(student);
        }),
        currentCohort
      );
      /* The confirmed-but-unlisted tally stood here for the old note under
         Confirmed. renderSummaryNotes counts its own, over the whole cohort
         rather than the confirmed part of it, and nothing else read this. */
      var cohortFinalized = isCohortFinalized(currentCohort);

      var rosterTotal = getRosterEmailCount(currentCohort && currentCohort.studentEmailsRaw);
      var displayTotal = Math.max(currentStudents.length, rosterTotal);
      var pendingCount = countApprovedListPending(currentStudents, currentCohort);

      /*
        2026-08-11, owner's model — these pills count the WHOLE cohort, main and
        every round together. The dashboard answers the same questions one block
        at a time, so the two are meant to differ once a round exists.

        "Not submitted" therefore counts everyone still owing a form, including
        those inside an open round. It used to reuse the number that drives the
        list below, which excludes them — so a finalized cohort with people
        waiting in its round reported 0.
      */
      var stillOwingForm = currentStudents.filter(function(student) {
        return !isRemovedStudent(student) && !hasSubmittedSizes(student);
      }).length;

      /*
        Confirmed means paid for, so a student still owing the delivery
        payment is counted beside it, never inside it. The same subtraction
        drives the progress line: a cohort is not further along because
        somebody filled a form they have not paid for.
      */
      var awaitingPayment = currentStudents.filter(isAwaitingPaymentStudent);
      var confirmedPaid = submitted.filter(function(student) {
        return !isAwaitingPaymentStudent(student);
      });

      document.getElementById('summary-total').textContent = displayTotal;
      document.getElementById('summary-submitted').textContent = confirmedPaid.length;
      document.getElementById('summary-pending').textContent = stillOwingForm;
      renderAwaitingPaymentPill(awaitingPayment.length);
      updateOverallProgress(displayTotal, confirmedPaid.length);

      /*
        2026-08-25 — the split belongs to Total, not to Confirmed (owner).

        "listed 5 / not listed 1" hung under Confirmed and described the whole
        cohort, not the confirmed part of it, so the number above it and the
        line below it counted different people. It belongs to Total Students,
        which is the pill those two numbers add up to.

        Confirmed says the thing nobody could tell from the word: that these
        students have paid. Both lines are written in renderSummaryNotes.
      */
      renderSummaryNotes(currentStudents, rosterTotal);

      updatePendingSectionHeader(pendingCount, cohortFinalized);
      document.getElementById('confirmed-count').textContent = mainSubmitted.length;

      var pendingGrid = document.getElementById('pending-students');
      var confirmedGrid = document.getElementById('confirmed-students');

      pendingGrid.innerHTML = pending.length
        ? mapStudentsWithListNumbers(pending).map(function(entry) {
            return studentCardHtml(entry.student, entry.listNumber, entry.unmatched);
          }).join('')
        : '<div class="empty-section">' + getPendingEmptyMessage(cohortFinalized) + '</div>';
      pendingGrid.classList.toggle('is-empty', pending.length < 1);

      confirmedGrid.innerHTML = mainSubmitted.length
        ? mapStudentsWithListNumbers(mainSubmitted).map(function(entry) {
            return studentCardHtml(entry.student, entry.listNumber, entry.unmatched);
          }).join('')
        : '<div class="empty-section">No submitted students yet.</div>';
      confirmedGrid.classList.toggle('is-empty', mainSubmitted.length < 1);

      currentPricing = getPricingData(currentCohort, currentStudents);
      renderPricingSection(currentPricing, currentStudents.length, countBillableStudents(currentStudents));
      renderPrintLayout(currentCohort, currentStudents, currentPricing);
      updateFinalizeButtonState(currentCohort, currentStudents);
      renderLateBatchesSection(currentCohortCode);

      /* Карточки только что перерисованы — вернуть фильтр, если он был. */
      reapplySearchFilter();

      if (focusEmail) {
        var cards = document.querySelectorAll('.student-card[data-student-email]');
        cards.forEach(function(card) {
          if (String(card.getAttribute('data-student-email') || '').toLowerCase() === String(focusEmail).toLowerCase()) {
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }

    function finishStatusEmailMutation(cohortCode, focusEmail) {
      refreshStatusStudentGrids(focusEmail);
      renderLateBatchesSection(cohortCode);
      finishStatusActionBlockingLoad();
      scheduleStatusPageSync(cohortCode, 0);
    }

    function restoreStatusPageEmailFocus() {
      try {
        var raw = sessionStorage.getItem('cohort_status_email_focus');
        if (!raw) return;
        sessionStorage.removeItem('cohort_status_email_focus');
        var saved = JSON.parse(raw);
        if (!saved || !saved.email) return;

        var cards = document.querySelectorAll('.student-card[data-student-email]');
        cards.forEach(function(card) {
          if (String(card.getAttribute('data-student-email') || '').toLowerCase() === String(saved.email).toLowerCase()) {
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      } catch (error) {}
    }

    function getRosterEmails(raw) {
      if (!raw) return [];

      try {
        var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!Array.isArray(parsed)) return [];

        return parsed.map(function(email) {
          return String(email || '').trim().toLowerCase();
        }).filter(Boolean);
      } catch (error) {
        return [];
      }
    }

    function getRosterEmailCount(raw) {
      return getRosterEmails(raw).length;
    }

    /*
      2026-08-11 — an invite line counts as answered when the student who holds
      it has submitted, whether or not the address they used was on the list.

      The `!isUnmatchedStudent` test made an outside-list submission invisible to
      this question, so the invite line still read as unanswered while its owner
      sat in the Submitted list. That is where "2 students have not confirmed"
      came from with only one person waiting, and the same two counted the
      student twice: once as submitted, once as a silent invite line.

      Such a student IS billed — cohort-finalize selects them like anyone else —
      so treating their line as unanswered was never consistent with what the
      cohort actually does with them.
    */
    function hasApprovedSubmissionForEmail(students, email) {
      var match = findStudentByEmail(students, email);
      return !!(match && hasSubmittedSizes(match));
    }

    var studentsSetupRefreshTimer = null;

    function clearStudentsSetupRefresh() {
      if (studentsSetupRefreshTimer) {
        window.clearTimeout(studentsSetupRefreshTimer);
        studentsSetupRefreshTimer = null;
      }
    }

    function scheduleStudentsSetupRefresh(code) {
      clearStudentsSetupRefresh();

      var normalized = normalizeCode(code);
      var storageKey = 'cohort_setup_poll_' + normalized;
      var attempts = parseInt(window.sessionStorage.getItem(storageKey) || '0', 10) || 0;

      if (attempts >= 12) {
        setMessage('Students are still being set up. Please refresh this page in about a minute.', 'error');
        return;
      }

      window.sessionStorage.setItem(storageKey, String(attempts + 1));

      studentsSetupRefreshTimer = window.setTimeout(function() {
        reloadWithCohort(normalized);
      }, 5000);
    }

    function toNumber(value) {
      var number = parseFloat(value);
      return isNaN(number) ? 0 : number;
    }

    function formatMoney(amount, currencyCode) {
      var numericAmount = Number(amount) || 0;
      var currency = currencyCode || 'USD';

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericAmount);
      } catch (error) {
        return '$' + numericAmount.toFixed(2);
      }
    }

    function toAbsoluteUrl(pathOrUrl) {
      if (!pathOrUrl) return '';

      try {
        return new URL(pathOrUrl, shopBaseUrl).toString();
      } catch (error) {
        return '';
      }
    }

    function buildStudentFormUrl(cohort) {
      var fallbackUrl = toAbsoluteUrl(defaultStudentFormPath + '?cohort=' + encodeURIComponent(currentCohortCode));
      var raw = cohort && cohort.studentFormUrl ? String(cohort.studentFormUrl).trim() : '';

      if (!raw) {
        return fallbackUrl;
      }

      try {
        var url = new URL(raw, shopBaseUrl);
        var pathname = decodeURIComponent(url.pathname || '');
        var hasOnlyAscii = /^[\x00-\x7F]*$/.test(pathname);
        var normalizedPath = pathname.replace(/\/+$/, '');

        if (!hasOnlyAscii || normalizedPath !== defaultStudentFormPath) {
          return fallbackUrl;
        }

        url.pathname = defaultStudentFormPath;

        if (currentCohortCode) {
          url.searchParams.set('cohort', currentCohortCode);
        }

        return url.toString();
      } catch (error) {
        return fallbackUrl;
      }
    }

    function buildQrUrl(url) {
      return url ? 'https://quickchart.io/qr?size=598&text=' + encodeURIComponent(url) : '';
    }

    function parseSizes(value) {
      var parsed = parseJson(value, null);

      if (!parsed) return {};

      if (Array.isArray(parsed)) {
        var objectFromArray = {};
        parsed.forEach(function(item, index) {
          var key = item.instance_key || item.product_id || String(index);
          objectFromArray[key] = item;
        });
        return objectFromArray;
      }

      if (typeof parsed === 'object') return parsed;

      return {};
    }

    function getStudentItems(student) {
      var items = parseJson(student.items, null);
      if (Array.isArray(items)) return items;

      var sizes = parseSizes(student.sizes);
      return Object.keys(sizes).map(function(key) {
        var item = sizes[key] || {};
        item._key = key;
        return item;
      });
    }

    function hasDraftOrder(student) {
      var status = String(student.status || '').toLowerCase();
      var orderStatus = String(student.order_status || '').toLowerCase();

      return !!(
        student.draft_order_id ||
        student.draft_order_name ||
        student.draft_order_invoice_url ||
        status === 'draft_order_queued' ||
        status === 'draft_order_created' ||
        orderStatus === 'draft_order_queued' ||
        orderStatus === 'draft_order_created'
      );
    }

    function hasSubmittedSizes(student) {
      if (!student) return false;

      if (String(student.submitted_at || '').trim()) {
        return true;
      }

      var status = String(student.status || '').toLowerCase();
      var orderStatus = String(student.order_status || '').toLowerCase();

      return !!(
        status === 'confirmed' ||
        status === 'submitted' ||
        status === 'complete' ||
        status === 'completed' ||
        status === 'draft_order_queued' ||
        status === 'draft_order_created' ||
        orderStatus === 'draft_order_queued' ||
        orderStatus === 'draft_order_created' ||
        hasDraftOrder(student) ||
        getStudentItems(student).length > 0 ||
        Object.keys(parseSizes(student.sizes)).length > 0
      );
    }

    function countSubmittedStudents(students) {
      return (students || []).filter(hasSubmittedSizes).length;
    }

    /*
      ── 2026-08-25 — the estimate counts who will be billed (owner) ─────────

      It counted everyone who had chosen sizes, which is not who the school
      pays for: finalization bills the students whose delivery is settled and
      leaves the ones still owing out of the invoice entirely. So the figure
      on this page ran ahead of the invoice that follows it, by however many
      people had filled the form and not paid — and it is the number an admin
      shows their finance office.

      Where students do not pay for delivery nobody is ever "awaiting", so this
      is the same count as before and a school-delivery cohort reads exactly as
      it did.
    */
    function isBillableStudent(student) {
      return hasSubmittedSizes(student) && !isAwaitingPaymentStudent(student);
    }

    function countBillableStudents(students) {
      return (students || []).filter(isBillableStudent).length;
    }

    function isUnmatchedStudent(student) {
      var status = String(student.status || '').toLowerCase();
      var matchStatus = String(student.email_match_status || '').toLowerCase();

      return matchStatus === 'unmatched' || status === 'unmatched';
    }

    function formatApprovedListStatus(student) {
      if (!student) return '—';
      if (isUnmatchedStudent(student)) return 'Not on approved list';
      if (hasSubmittedSizes(student)) return 'On approved list';
      return 'Waiting to submit';
    }

    /*
      Kept in step with cohort-finalize.liquid:450 — see the twin of this
      function in cohort-admin-form.js for why awaiting_payment is excluded
      (owner, 2026-08-12: a cohort where nobody had paid still offered to
      finalize, and the task then refused it in a log nobody was watching).
    */
    function isConfirmedForFinalize(student) {
      if (!student) return false;
      /*
        A student who is not on the admin's list still counts — see the twin of
        this function in cohort-admin-form.js for the whole reasoning (business
        rule 4.4, and the task has never filtered them either).
      */
      if (!hasSubmittedSizes(student)) return false;
      if (hasLateBatch(student)) return false;

      var status = String(student.status || '').toLowerCase();
      return status !== 'pending' &&
        status !== 'awaiting_payment' &&
        status !== 'removed' &&
        status !== 'archived';
    }

    function countConfirmedForFinalize(students) {
      return (students || []).filter(isConfirmedForFinalize).length;
    }

    function countApprovedListPending(students, cohort) {
      if (isCohortFinalized(cohort)) {
        return getPendingStudentsForDisplay(students, cohort).length;
      }

      var pendingEntries = (students || []).filter(function(student) {
        return !isUnmatchedStudent(student) && !hasSubmittedSizes(student);
      }).length;

      var rosterEmails = getRosterEmails(cohort && cohort.studentEmailsRaw);
      if (!rosterEmails.length) {
        return pendingEntries;
      }

      var rosterWithoutSubmission = rosterEmails.filter(function(email) {
        return !hasApprovedSubmissionForEmail(students, email);
      }).length;

      return Math.max(pendingEntries, rosterWithoutSubmission);
    }

    function pulseFinalizeBlockedBanner() {
      var banner = document.getElementById('cohort-finalize-blocked-banner');
      if (!banner) return;

      banner.classList.remove('cohort-finalize-blocked-banner--pulse');
      void banner.offsetWidth;
      banner.classList.add('cohort-finalize-blocked-banner--pulse');
    }

    function showFinalizeBlockedBanner(show, message) {
      var banner = document.getElementById('cohort-finalize-blocked-banner');
      var textElement = document.getElementById('cohort-finalize-blocked-text');

      if (!banner || !textElement) return;

      if (show) {
        banner.classList.add('show');
        textElement.textContent = message || NO_CONFIRMED_STUDENTS_MESSAGE;
      } else {
        banner.classList.remove('show');
        textElement.textContent = '';
      }
    }

    function formatDeadline(value) {
      if (!value) return 'Not set';

      var date = new Date(value + 'T00:00:00');
      if (isNaN(date.getTime())) date = new Date(value);
      if (isNaN(date.getTime())) return value;

      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    function getOrderTypeLabel(value) {
      value = String(value || '').trim();

      if (value === 'individual_student_orders' || value === 'individual_student_order') return 'Ship to home';
      if (value === 'school_order') return 'Ship to school';

      return value || 'Not set';
    }

    function isTruthy(value) {
      value = String(value || '').toLowerCase();
      return value === 'true' || value === '1' || value === 'yes';
    }

    function isPersonalized(cohort) {
      return isTruthy(cohort && cohort.personalizeOrder);
    }

    function getCohortProducts(cohort) {
      var parsed = parseJson(cohort && cohort.products, []);
      return Array.isArray(parsed) ? parsed : [];
    }

    function getProductQuantityPerStudent(product) {
      var raw =
        product.quantity_per_student != null ? product.quantity_per_student :
        product.quantity != null ? product.quantity :
        product.qty_per_student != null ? product.qty_per_student :
        product.qty != null ? product.qty :
        product.selected_quantity != null ? product.selected_quantity :
        0;

      var quantity = parseInt(raw, 10);
      return isNaN(quantity) ? 0 : Math.max(0, quantity);
    }

    function getProductUnitPrice(product) {
      return toNumber(
        product.price_amount != null ? product.price_amount :
        product.unit_price != null ? product.unit_price :
        product.unitPrice != null ? product.unitPrice :
        product.price != null ? product.price :
        product.price_per_unit != null ? product.price_per_unit :
        product.unitPriceAmount != null ? product.unitPriceAmount :
        0
      );
    }

    /*
      ── 2026-08-18 — the estimate stops charging everyone for every campus ──

      Reported by the owner from a live cohort: the headline read $1,139.00
      while the breakdown under it added up to $569.50 — exactly double.

      The arithmetic named the cause. A cohort with two campuses had seventeen
      students submitted, and every line was priced at its own rate times all
      seventeen: 20.10 × 17 for the Cleveland top AND 20.10 × 17 for the
      Chicago one. Nobody buys both. The right multiplier is the students of
      that line's campus — eight and nine, which is what the breakdown already
      showed and what the total ignored.

      The breakdown was taught this in an earlier pass and the totals were not,
      so the two halves of one card disagreed by a factor of two.

      Only for lines that carry a campus. A cohort with one campus, or an older
      one with none, has "everyone submitted" and "everyone in this campus"
      meaning the same number, and behaves exactly as before.
    */
    function submittedForLineItem(item, cohortWideSubmitted) {
      var campusName = String((item && item.campus_name) || '').trim();
      if (!campusName) return cohortWideSubmitted;

      return countSubmittedInCampus(campusName);
    }

    function normalizePricingLineItems(rawLineItems, totalStudents, submittedStudents) {
      var items = Array.isArray(rawLineItems) ? rawLineItems : [];

      return items.map(function(item, index) {
        var quantityPerStudent = toNumber(
          item.quantity_per_student != null ? item.quantity_per_student :
          item.quantity != null ? item.quantity :
          item.qty_per_student != null ? item.qty_per_student :
          0
        );

        var unitPrice = toNumber(
          item.unit_price != null ? item.unit_price :
          item.price_amount != null ? item.price_amount :
          item.price != null ? item.price :
          0
        );

        var lineTotalPerStudent = toNumber(
          item.line_total_per_student != null ? item.line_total_per_student :
          item.per_student_total != null ? item.per_student_total :
          quantityPerStudent * unitPrice
        );

        return {
          title: item.title || item.product_title || item.name || 'Item ' + (index + 1),
          program_names: item.program_names || '',
          campus_name: item.campus_name || '',
          quantity_per_student: quantityPerStudent,
          unit_price: unitPrice,
          line_total_per_student: lineTotalPerStudent,
          all_students_total: toNumber(item.all_students_total != null ? item.all_students_total : lineTotalPerStudent * totalStudents),
          /* Per campus where there is one — see submittedForLineItem. A stored
             figure is trusted only for a line with no campus, because a stored
             one was worked out cohort-wide and is the very number being fixed. */
          submitted_students_total: toNumber(
            (!item.campus_name && item.submitted_students_total != null)
              ? item.submitted_students_total
              : lineTotalPerStudent * submittedForLineItem(item, submittedStudents)
          )
        };
      });
    }

    function derivePricingTotalsFromLineItems(lineItems) {
      return (lineItems || []).reduce(function(acc, item) {
        acc.allProductsTotal += toNumber(item.all_students_total);
        acc.submittedProductsTotal += toNumber(item.submitted_students_total);
        return acc;
      }, {
        allProductsTotal: 0,
        submittedProductsTotal: 0
      });
    }

    function getStoredPricing(cohort, students) {
      var raw = parseJson(cohort && cohort.pricingJson, null);

      if (!raw || typeof raw !== 'object') {
        return null;
      }

      var totalStudents = students.length;
      var submittedStudents = countBillableStudents(students);
      var normalizedLineItems = normalizePricingLineItems(raw.line_items || raw.lineItems, totalStudents, submittedStudents);

      return {
        sourceLabel: raw.pricing_source || raw.context_label || raw.status || 'Saved pricing',
        currencyCode: raw.currency_code || raw.currencyCode || 'USD',
        rawAllProductsTotal: toNumber(raw.all_students && raw.all_students.products_total != null ? raw.all_students.products_total : raw.all_students_total),
        rawSubmittedProductsTotal: toNumber(raw.submitted_students && raw.submitted_students.products_total != null ? raw.submitted_students.products_total : raw.submitted_students_total),
        lineItems: normalizedLineItems,
        note: raw.note || ''
      };
    }

    function buildComputedPricing(cohort, students) {
      var products = getCohortProducts(cohort);
      var totalStudents = students.length;
      var submittedStudents = countBillableStudents(students);
      var personalizationFee = toNumber(cohort && cohort.personalizationFeePerStudent) || 5;
      var personalized = isPersonalized(cohort);
      var currencyCode = 'USD';
      var lineItems = [];
      var perStudentProductsTotal = 0;

      products.forEach(function(product, index) {
        var quantityPerStudent = getProductQuantityPerStudent(product);
        var unitPrice = getProductUnitPrice(product);
        var lineTotalPerStudent = toNumber(product.line_total_per_student);

        if (!lineTotalPerStudent && quantityPerStudent > 0 && unitPrice > 0) {
          lineTotalPerStudent = quantityPerStudent * unitPrice;
        }

        if (product.currency_code) {
          currencyCode = product.currency_code;
        }

        perStudentProductsTotal += lineTotalPerStudent;

        lineItems.push({
          title: product.title || product.product_title || 'Item ' + (index + 1),
          program_names: product.program_names || '',
          campus_name: product.campus_name || '',
          quantity_per_student: quantityPerStudent,
          unit_price: unitPrice,
          line_total_per_student: lineTotalPerStudent,
          all_students_total: lineTotalPerStudent * totalStudents,
          submitted_students_total: lineTotalPerStudent * submittedForLineItem(product, submittedStudents)
        });
      });

      var allProductsTotal = perStudentProductsTotal * totalStudents;

      /* Summed from the lines rather than multiplied out of an average: the
         lines now know their campus and this did not, which is how the total
         came to differ from the breakdown printed directly beneath it. */
      var submittedProductsTotal = lineItems.reduce(function(sum, line) {
        return sum + toNumber(line.submitted_students_total);
      }, 0);
      var allPersonalizationTotal = personalized ? personalizationFee * totalStudents : 0;
      var submittedPersonalizationTotal = personalized ? personalizationFee * submittedStudents : 0;

      return {
        sourceLabel: 'Preview from cohort setup',
        currencyCode: currencyCode,
        allProductsTotal: allProductsTotal,
        allPersonalizationTotal: allPersonalizationTotal,
        allGrandTotal: allProductsTotal + allPersonalizationTotal,
        submittedProductsTotal: submittedProductsTotal,
        submittedPersonalizationTotal: submittedPersonalizationTotal,
        submittedGrandTotal: submittedProductsTotal + submittedPersonalizationTotal,
        lineItems: lineItems,
        note: 'Estimated preview based on the cohort products and current submissions.'
      };
    }

    function getPricingData(cohort, students) {
      var computed = buildComputedPricing(cohort, students);
      var stored = getStoredPricing(cohort, students);

      if (!stored) {
        return computed;
      }

      var useStoredLineItems = stored.lineItems && stored.lineItems.length > 0;
      var storedLineTotals = derivePricingTotalsFromLineItems(stored.lineItems || []);
      var allProductsTotal = storedLineTotals.allProductsTotal || stored.rawAllProductsTotal || computed.allProductsTotal;
      var submittedProductsTotal = storedLineTotals.submittedProductsTotal || stored.rawSubmittedProductsTotal || computed.submittedProductsTotal;

      return {
        sourceLabel: stored.sourceLabel || computed.sourceLabel,
        currencyCode: stored.currencyCode || computed.currencyCode || 'USD',
        allProductsTotal: allProductsTotal,
        allPersonalizationTotal: computed.allPersonalizationTotal,
        allGrandTotal: allProductsTotal + computed.allPersonalizationTotal,
        submittedProductsTotal: submittedProductsTotal,
        submittedPersonalizationTotal: computed.submittedPersonalizationTotal,
        submittedGrandTotal: submittedProductsTotal + computed.submittedPersonalizationTotal,
        lineItems: useStoredLineItems ? stored.lineItems : computed.lineItems,
        note: stored.note || computed.note
      };
    }

    function getItemDisplayTitle(item, fallbackKey) {
      var productTitle = item.product_title || item.product || item.title || item.name || '';
      if (!productTitle && fallbackKey) productTitle = 'Product ' + fallbackKey;

      var itemNumber = parseInt(item.item_number, 10) || parseInt(item.instance_index, 10) || null;
      var totalQuantity = parseInt(item.total_quantity, 10) || null;

      if (productTitle && itemNumber && totalQuantity && totalQuantity > 1) {
        return productTitle + ' #' + itemNumber + ' of ' + totalQuantity;
      }

      if (productTitle && itemNumber && !totalQuantity) {
        return productTitle + ' #' + itemNumber;
      }

      return productTitle || 'Item';
    }

    function getItemSelection(item) {
      var selection = String(item.selection || item.size || item.variant_title || item.option || '').trim();

      /*
        2026-08-05 — a product with no size options has nothing to report.
        Shopify labels such a variant "Default Title", and the student form has
        been seen storing the SKU in its place; both were printed as if they were
        a chosen size. Keep in step with buildSizesSummary in
        cohort-admin-form.js.
      */
      var sku = String(item.sku || item.variant_sku || '').trim();
      if (selection.toLowerCase() === 'default title' || (sku && selection === sku)) return '';

      return selection;
    }

    function renderSizes(student) {
      var items = getStudentItems(student);

      if (!items.length) {
        return '';
      }

      return '<div class="sizes-list">' + items.map(function(item, index) {
        var fallbackKey = item._key || item.product_id || String(index + 1);
        var title = esc(getItemDisplayTitle(item, fallbackKey));
        var selection = getItemSelection(item);

        /*
          2026-09-14, owner: a product with no size prints its name and stops.

          The dash was standing in for an answer that was never asked for -
          getItemSelection already returns nothing for a product that has no
          size options, and a water bottle listed as "Bottle: —" reads as a
          student who skipped a question. The dashboard has always printed
          just the name; this is the status page catching up.
        */
        return selection
          ? '<div class="sizes-list-item"><strong>' + title + ':</strong> ' + esc(selection) + '</div>'
          : '<div class="sizes-list-item"><strong>' + title + '</strong></div>';
      }).join('') + '</div>';
    }

    function getSearchText(student) {
      return [
        student.first_name || '',
        student.last_name || '',
        student.email || '',
        student.student_id || '',
        student.status || '',
        student.email_match_status || '',
        getStudentItems(student).map(function(item) {
          return (item.product_title || item.title || item.name || '') + ' ' + (item.selection || item.size || '');
        }).join(' ')
      ].join(' ').toLowerCase();
    }

    /*
      One counter for the list you are looking at (2026-08-09).

      There used to be two — one for students on the approved list, one for
      those off it — which only reads correctly if the two are drawn in separate
      blocks. They are not: both go into the same grid, so the numbers came out
      1, 1, 2, 2 and stopped meaning "how many people are in front of me".

      Outside-list students are still marked; that is what `unmatched` carries,
      and the card colours the number with it. Position and status are two
      different questions.
    */
    function mapStudentsWithListNumbers(students) {
      var listNumber = 0;

      return (students || []).map(function(student) {
        listNumber += 1;

        return {
          student: student,
          listNumber: listNumber,
          unmatched: isUnmatchedStudent(student)
        };
      });
    }

    /*
      ── 2026-08-19 — заметка админа (владелица) ──────────────────────────

      Пишется на дашборде, здесь только читается. Право записи у этой
      страницы забрали 2026-08-05 вместе с редактированием списка, и
      возвращать его ради заметки незачем.

      Витрина несёт заметку, только когда она есть, — у студента без заметки
      здесь не появляется ничего.
    */
    function studentNoteHtml(student) {
      var note = String((student && student.note) || '').trim();
      if (!note) return '';

      return '<p class="student-note">' +
        '<span class="student-note-label">Note</span>' +
        '<span class="student-note-text">' + esc(note) + '</span>' +
      '</p>';
    }

    function studentCardHtml(student, listNumber, unmatched) {
      var submitted = hasSubmittedSizes(student);
      if (typeof unmatched !== 'boolean') {
        unmatched = isUnmatchedStudent(student);
      }
      var fullName = [student.first_name || '', student.last_name || ''].join(' ').trim() || 'Name not submitted';
      var finalized = isCohortFinalized(currentCohort);
      var lateHighlight = finalized && isLateStudent(student);
      var cardClass = submitted ? 'student-card confirmed' : 'student-card pending';

      if (submitted && unmatched) {
        cardClass = 'student-card confirmed unmatched-confirmed';
      }

      /*
        2026-08-25 — paid and unpaid are not the same card (owner).

        Both were drawn as "confirmed", which is true of the form and not of
        the money: one of them is on the school's invoice and the other is
        deliberately left off it. The card now says which.
      */
      if (submitted && isAwaitingPaymentStudent(student)) {
        cardClass += ' is-awaiting-payment';
      }

      if (lateHighlight) {
        cardClass += ' is-late-highlight';
      }

      var indexHtml = listNumber
        ? '<div class="student-leading"><span class="student-index' + (unmatched ? ' is-unmatched' : '') + '" aria-hidden="true">' + listNumber + '.</span></div>'
        : '<div class="student-leading"></div>';

      /*
        2026-08-05, step 3 of docs/roster-editing-rework-plan.md — this card no
        longer writes anything. Editing an email, removing a student and
        resending their form all moved to the dashboard, which is the single
        writer now.

        Why one writer at all: the two pages carried independent copies of the
        same rules, and every disagreement the admin was shown came from those
        copies drifting apart. One page writing removes the class of bug rather
        than fixing instances of it.
      */
      var contactEmail = getStudentIdentityEmail(student);

      /*
        2026-08-11 — both addresses, matching the dashboard row.

        A student who submitted off-list has two: the one their invitation was
        built on and the one they typed. This card showed only `email`, which is
        the typed one, so the same person read as a different address on each
        page. The invitation leads, because that is who the admin invited and
        how they are listed everywhere else.
      */
      var studentCampus = getStudentCampusName(student);
      var invitedEmail = String(student.roster_email || '').trim().toLowerCase();
      var submittedEmail = String(student.submitted_email || student.email || '').trim().toLowerCase();
      var primaryEmail = student.email || '';
      var altEmailHtml = '';

      if (unmatched && invitedEmail && submittedEmail && invitedEmail !== submittedEmail) {
        primaryEmail = invitedEmail;
        altEmailHtml = '<p class="student-alt-email">Submitted as <strong>' + esc(submittedEmail) + '</strong></p>';
      }

      var removeHtml = '';

      /*
        2026-08-24 — locked by the student's own track, not by the cohort.

        This asked isCohortFinalized, which answers only for the main cohort. A
        student in an open late round, in a cohort whose main track was billed
        weeks ago, was told their address was locked — while the dashboard,
        which asks canEditStudentEmail and through it isStudentTrackFinalized,
        let the admin change it. Two screens, opposite answers, and the one
        saying no was wrong.

        Main and a late round are separate finalization scopes; a finalized one
        must not lock the other. isStudentTrackFinalized is the shared answer
        both pages already own, so it is asked here too, and the sentence names
        whichever scope actually closed.
      */
      var trackLocked = isStudentTrackFinalized(currentCohort, student);
      var lockedBatchCode = String(student.late_batch_code || '').trim().toUpperCase();
      var lockedScopeText = lockedBatchCode
        ? 'Email locked — Late ' + esc(lockedBatchCode.replace(/^LATE-/i, '')) + ' finalized.'
        : 'Email locked — cohort finalized.';

      var emailFixHtml = trackLocked && submitted
        ? '<p class="student-status-plaque-wrap"><span class="student-status-plaque student-status-plaque--info">' + lockedScopeText + '</span></p>'
        : '';

      return (
        '<div class="' + cardClass + '" data-search="' + esc(getSearchText(student)) + '" data-student-email="' + esc(contactEmail) + '">' +
          '<div class="student-card-inner">' +
            indexHtml +
            '<div class="student-body">' +
              '<div class="student-name-row">' +
                '<h3 class="student-name">' + esc(fullName) + '</h3>' +
              '</div>' +
              '<p class="student-meta-compact">' +
                '<span>ID: ' + esc(student.student_id || '—') + '</span>' +
                '<span class="student-meta-sep">·</span>' +
                '<span>' + esc(primaryEmail || '—') + '</span>' +
                /* 2026-08-11, phase 6 — the campus they chose, beside the rest
                   of their details. Blank until they submit. */
                (studentCampus
                  /* 2026-10-05 - the dot and the chip wrap together, so a
                     line that runs out of room never ends on a lone "·". */
                  ? '<span class="student-campus-group"><span class="student-meta-sep">·</span><span class="student-campus-chip">' + esc(studentCampus) + '</span></span>'
                  : '') +
              '</p>' +
              /*
                Phase 8 (2026-08-12, owner) — the plaques moved out of the
                details line onto one of their own.

                They used to sit at the end of "ID · address", where they read
                as another detail of the address rather than as the state of
                the student. They are the two things an admin acts on — who
                still owes a payment, and who was never on their list — so they
                get their own line under the details, with room around them.

                "Paid" is here for the same reason its opposite is: an admin
                scanning for money needs to see both answers, not infer one
                from the absence of the other.
              */
              '<p class="student-status-plaques">' +
                (isAwaitingPaymentStudent(student)
                  ? '<span class="student-status-plaque student-status-plaque--unpaid">Not paid yet</span>'
                  : '') +
                (isPaidStudent(student)
                  ? '<span class="student-status-plaque student-status-plaque--paid">Paid</span>'
                  : '') +
                (unmatched
                  ? '<span class="student-status-plaque student-status-plaque--warning">Not on approved list</span>'
                  : '') +
              '</p>' +
              altEmailHtml +
              emailFixHtml +
            '</div>' +
            '<div class="student-items">' + renderSizes(student) + '</div>' +
            studentNoteHtml(student) +
            removeHtml +
          '</div>' +
        '</div>'
      );
    }

    function infoTipTriggerHtml() {
      return (
        '<button type="button" class="cf-info-tip-trigger" aria-label="More information">' +
          '<svg class="cf-info-tip-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
            '<circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" stroke-width="1.25"></circle>' +
            '<circle cx="8" cy="5.15" r="0.85" fill="currentColor"></circle>' +
            '<path d="M8 7.35v3.2" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"></path>' +
          '</svg>' +
        '</button>'
      );
    }

    function pricingInfoTip(text) {
      return (
        '<span class="cf-info-tip">' +
          infoTipTriggerHtml() +
          '<span class="cf-info-tip-bubble" role="tooltip">' + esc(text) + '</span>' +
        '</span>'
      );
    }

    function heroCodeInfoTip(text) {
      return (
        '<span class="cf-info-tip cohort-hero-code-tip">' +
          infoTipTriggerHtml() +
          '<span class="cf-info-tip-bubble" role="tooltip">' + esc(text) + '</span>' +
        '</span>'
      );
    }

    function getInfoTipBubble(tip) {
      return tip._infoTipBubble || tip.querySelector('.cf-info-tip-bubble');
    }

    function mountInfoTipBubble(tip, bubble) {
      if (!bubble._infoTipHome) {
        bubble._infoTipHome = bubble.parentNode;
      }

      tip._infoTipBubble = bubble;

      if (bubble.parentNode !== document.body) {
        document.body.appendChild(bubble);
      }
    }

    function unmountInfoTipBubble(tip) {
      var bubble = getInfoTipBubble(tip);

      if (!bubble || !bubble._infoTipHome) {
        return;
      }

      if (bubble.parentNode === document.body) {
        bubble._infoTipHome.appendChild(bubble);
      }

      tip._infoTipBubble = null;
    }

    function positionInfoTipBubble(tip) {
      var trigger = tip.querySelector('.cf-info-tip-trigger');
      var bubble = getInfoTipBubble(tip);

      if (!trigger || !bubble) {
        return;
      }

      mountInfoTipBubble(tip, bubble);
      tip.classList.add('cf-info-tip--floating');
      bubble.classList.remove('cf-info-tip-bubble--below');
      bubble.classList.remove('cf-info-tip-bubble--portaled');
      bubble.style.visibility = 'hidden';
      bubble.style.display = 'block';
      bubble.style.position = 'fixed';
      bubble.style.left = '-9999px';
      bubble.style.top = '0';
      bubble.style.bottom = 'auto';
      bubble.style.height = 'auto';
      bubble.style.whiteSpace = 'normal';
      bubble.style.textTransform = 'none';
      bubble.style.transform = 'none';

      var bubbleWidth = bubble.offsetWidth;
      var bubbleHeight = bubble.offsetHeight;
      var triggerRect = trigger.getBoundingClientRect();
      var gap = 10;
      var viewportPadding = 12;
      var placeBelow = triggerRect.top - bubbleHeight - gap < viewportPadding;
      var centerX = triggerRect.left + triggerRect.width / 2;
      var minLeft = viewportPadding + bubbleWidth / 2;
      var maxLeft = window.innerWidth - viewportPadding - bubbleWidth / 2;

      centerX = Math.max(minLeft, Math.min(maxLeft, centerX));

      if (placeBelow) {
        bubble.classList.add('cf-info-tip-bubble--below');
        bubble.style.left = centerX + 'px';
        bubble.style.top = (triggerRect.bottom + gap) + 'px';
        bubble.style.bottom = 'auto';
        bubble.style.transform = 'translate(-50%, 0)';
      } else {
        bubble.style.left = centerX + 'px';
        bubble.style.top = (triggerRect.top - gap) + 'px';
        bubble.style.bottom = 'auto';
        bubble.style.transform = 'translate(-50%, -100%)';
      }

      bubble.style.visibility = '';
      bubble.classList.add('cf-info-tip-bubble--portaled');
    }

    function resetInfoTipBubble(tip) {
      var bubble = getInfoTipBubble(tip);

      if (!bubble) {
        return;
      }

      tip.classList.remove('cf-info-tip--floating');
      bubble.classList.remove('cf-info-tip-bubble--below');
      bubble.classList.remove('cf-info-tip-bubble--portaled');
      bubble.style.position = '';
      bubble.style.left = '';
      bubble.style.top = '';
      bubble.style.bottom = '';
      bubble.style.height = '';
      bubble.style.whiteSpace = '';
      bubble.style.textTransform = '';
      bubble.style.transform = '';
      bubble.style.visibility = '';
      bubble.style.display = '';
      unmountInfoTipBubble(tip);
    }

    function openInfoTip(tip) {
      if (!tip) {
        return;
      }

      positionInfoTipBubble(tip);
      tip.classList.add('is-open');
    }

    function closeInfoTip(tip) {
      if (!tip) {
        return;
      }

      tip.classList.remove('is-open');
      resetInfoTipBubble(tip);
    }

    function bindInfoTips(root) {
      if (!root || root.dataset.tipsBound === '1') {
        return;
      }

      root.dataset.tipsBound = '1';

      var openTip = null;
      var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function closeAll() {
        if (!openTip) {
          return;
        }

        closeInfoTip(openTip);
        openTip = null;
      }

      root.addEventListener('click', function(event) {
        var trigger = event.target.closest('.cf-info-tip-trigger');

        if (trigger) {
          event.preventDefault();
          event.stopPropagation();

          if (supportsHover) {
            return;
          }

          var tip = trigger.closest('.cf-info-tip');
          var isOpen = tip && tip.classList.contains('is-open');
          closeAll();

          if (tip && !isOpen) {
            openInfoTip(tip);
            openTip = tip;
          }

          return;
        }

        if (!event.target.closest('.cf-info-tip')) {
          closeAll();
        }
      });

      if (supportsHover) {
        root.addEventListener('mouseover', function(event) {
          var trigger = event.target.closest('.cf-info-tip-trigger');

          if (!trigger || !root.contains(trigger)) {
            return;
          }

          var tip = trigger.closest('.cf-info-tip');

          if (!tip) {
            return;
          }

          closeAll();
          openInfoTip(tip);
          openTip = tip;
        });

        root.addEventListener('mouseout', function(event) {
          var tip = event.target.closest('.cf-info-tip');

          if (!tip || tip.contains(event.relatedTarget)) {
            return;
          }

          if (openTip === tip) {
            closeAll();
          }
        });
      }

      window.addEventListener('resize', function() {
        if (openTip) {
          positionInfoTipBubble(openTip);
        }
      });

      window.addEventListener('scroll', function() {
        if (openTip) {
          positionInfoTipBubble(openTip);
        }
      }, true);
    }

    /*
      Which campus a student belongs to: the one their items carry. Derived, not
      stored — see the note in the student form. Blank for anyone who has not
      submitted yet, which is the truth: they have not chosen one.
    */
    /* Mirrors groupLineItemsByCampus in cohort-admin-form.js — the two pages
       keep their own copies of shared rules, and both move together. */
    function groupLineItemsByCampus(lineItems) {
      var order = [];
      var byCampus = {};

      (lineItems || []).forEach(function(item) {
        var campus = String(item.campus_name || '').trim();

        if (!byCampus[campus]) {
          byCampus[campus] = { campus: campus, items: [] };
          order.push(campus);
        }

        byCampus[campus].items.push(item);
      });

      return order.map(function(campus) {
        return byCampus[campus];
      });
    }

    function getStudentCampusName(student) {
      var items = student && student.items;

      try {
        if (typeof items === 'string') items = JSON.parse(items);
      } catch (error) {
        return '';
      }

      if (!Array.isArray(items)) return '';

      for (var i = 0; i < items.length; i += 1) {
        var name = String((items[i] && items[i].campus_name) || '').trim();
        if (name) return name;
      }

      return '';
    }

    function countSubmittedInCampus(campusName) {
      var target = String(campusName || '').trim().toLowerCase();

      /* Billable, not merely submitted — the same rule the cohort-wide count
         uses, so a campus line and the total it belongs to cannot disagree. */
      return (currentStudents || []).filter(function(student) {
        if (!isBillableStudent(student)) return false;
        if (!target) return true;
        return getStudentCampusName(student).toLowerCase() === target;
      }).length;
    }

    function pricingLineItemsHtml(pricing, totalStudents, submittedStudents) {
      var currencyCode = pricing.currencyCode || 'USD';
      var lineItems = pricing.lineItems || [];
      var cohortTotal = Math.max(0, parseInt(totalStudents, 10) || 0);
      var submittedCount = Math.max(0, parseInt(submittedStudents, 10) || 0);
      var fullCohortHint = cohortTotal === 1 ? '1 student' : cohortTotal + ' students';

      if (!lineItems.length) {
        return '<div class="pricing-empty">No pricing line items found for this cohort.</div>';
      }

      /*
        2026-08-11 — grouped under a campus heading, and counted per campus.

        Every line used to show the cohort's overall submitted count, so an item
        that only Concord orders read "1 of 2" because one Fresno student had
        submitted. Reported exactly that way. The count now asks how many
        students of THAT campus have submitted; the denominator stays the whole
        cohort, because a student who has not submitted has not chosen a campus
        either and cannot be attributed to one.
      */
      return groupLineItemsByCampus(lineItems).map(function(group) {
        var groupSubmitted = group.campus ? countSubmittedInCampus(group.campus) : submittedCount;
        var submittedHint = groupSubmitted + ' of ' + cohortTotal;

        var rows = group.items.map(function(item) {
          /* Per-campus money too: the estimate multiplies by the students who
             actually ordered this item, not by everyone who submitted. */
          var submittedTotal = group.campus
            ? (toNumber(item.line_total_per_student) * groupSubmitted)
            : (item.submitted_students_total || 0);

          return (
            '<article class="pricing-line-item">' +
              '<div class="pricing-line-main">' +
                '<h4 class="pricing-line-title">' + esc(item.title || 'Item') + '</h4>' +
                (item.program_names ? '<p class="pricing-line-program">' + esc(item.program_names) + '</p>' : '') +
                '<p class="pricing-line-meta">' + esc(item.quantity_per_student || 0) + ' per student · ' + esc(formatMoney(item.unit_price || 0, currencyCode)) + ' each</p>' +
              '</div>' +
              '<div class="pricing-line-amounts">' +
                '<div class="pricing-line-amount is-full-cohort">' +
                  '<span class="pricing-line-amount-label">Full cohort</span>' +
                  '<span class="pricing-line-amount-hint">' + esc(fullCohortHint) + '</span>' +
                  '<span class="pricing-line-amount-value">' + esc(formatMoney(item.all_students_total || 0, currencyCode)) + '</span>' +
                '</div>' +
                '<div class="pricing-line-amount is-submitted">' +
                  '<span class="pricing-line-amount-label">Ready to bill</span>' +
                  '<span class="pricing-line-amount-hint">' + esc(submittedHint) + '</span>' +
                  '<span class="pricing-line-amount-value">' + esc(formatMoney(submittedTotal, currencyCode)) + '</span>' +
                '</div>' +
              '</div>' +
            '</article>'
          );
        }).join('');

        return group.campus
          ? '<div class="pricing-campus-group">' +
              '<p class="pricing-campus-title">' + esc(group.campus) + '</p>' +
              rows +
            '</div>'
          : rows;
      }).join('');
    }

    /*
      ── 2026-10-05 — the estimate by campus, and each Late round on its own ──

      Asked by the owner: one total for the whole cohort does not tell a school
      what each campus will be billed, and once the main cohort is closed and a
      Late round is open, the Late students belong to a different invoice.

      The same students and the same arithmetic as the total above, only
      grouped: billable students (sizes chosen and, where they pay for
      delivery, paid - isBillableStudent), each worth the lines of their own
      campus plus lines with no campus, plus the personalization fee - the
      sums submittedForLineItem() and buildComputedPricing() already make.

      Grouped by round first (main, then each Late batch by code), then by
      campus. Nothing is drawn when there is one round and at most one campus:
      the total above already says it all.
    */
    function pricingScopes(pricing) {
      var lineItems = pricing.lineItems || [];
      var personalized = isPersonalized(currentCohort);
      var fee = personalized ? (toNumber(currentCohort && currentCohort.personalizationFeePerStudent) || 5) : 0;
      var scopes = {};
      var scopeKeys = [];

      (currentStudents || []).forEach(function(student) {
        if (!isBillableStudent(student)) return;

        var campus = getStudentCampusName(student);
        var campusKey = campus.toLowerCase();
        var amount = fee;

        lineItems.forEach(function(line) {
          var lineCampus = String(line.campus_name || '').trim().toLowerCase();
          if (!lineCampus || lineCampus === campusKey) amount += toNumber(line.line_total_per_student);
        });

        var batch = String(student.late_batch_code || '').trim().toUpperCase();
        var key = batch || 'MAIN';
        if (!scopes[key]) {
          scopes[key] = { batch: batch, total: 0, count: 0, campuses: {} };
          scopeKeys.push(key);
        }

        var campusLabel = campus || 'No campus';
        if (!scopes[key].campuses[campusLabel]) scopes[key].campuses[campusLabel] = { name: campusLabel, count: 0, total: 0 };
        scopes[key].campuses[campusLabel].count += 1;
        scopes[key].campuses[campusLabel].total += amount;
        scopes[key].count += 1;
        scopes[key].total += amount;
      });

      scopeKeys.sort(function(a, b) {
        if (a === 'MAIN') return -1;
        if (b === 'MAIN') return 1;
        return a.localeCompare(b);
      });

      return scopeKeys.map(function(key) {
        var scope = scopes[key];
        scope.campusList = Object.keys(scope.campuses).map(function(name) { return scope.campuses[name]; })
          .sort(function(a, b) {
            if (a.name === 'No campus') return 1;
            if (b.name === 'No campus') return -1;
            return a.name.localeCompare(b.name);
          });
        return scope;
      });
    }

    function pricingScopesHtml(pricing) {
      var currencyCode = pricing.currencyCode || 'USD';
      var scopes = pricingScopes(pricing);
      var hasLate = scopes.some(function(scope) { return scope.batch; });

      if (!scopes.length) return '';
      if (!hasLate && scopes[0].campusList.length < 2) return '';

      return '<div class="pricing-scopes">' + scopes.map(function(scope) {
        var title = scope.batch
          ? 'Late round ' + scope.batch.replace(/^LATE-/i, '')
          : (hasLate ? 'Main cohort' : 'By campus');

        var rows = scope.campusList.map(function(campus) {
          return '' +
            '<div class="pricing-scope-row">' +
              '<span class="pricing-scope-campus">' + esc(campus.name) + '</span>' +
              '<span class="pricing-scope-count">' + esc(campus.count === 1 ? '1 student' : campus.count + ' students') + '</span>' +
              '<span class="pricing-scope-amount">' + esc(formatMoney(campus.total, currencyCode)) + '</span>' +
            '</div>';
        }).join('');

        return '' +
          '<div class="pricing-scope' + (scope.batch ? ' is-late' : '') + '">' +
            '<div class="pricing-scope-head">' +
              '<span class="pricing-scope-title">' + esc(title) + '</span>' +
              (hasLate ? '<span class="pricing-scope-total">' + esc(formatMoney(scope.total, currencyCode)) + '</span>' : '') +
            '</div>' +
            rows +
          '</div>';
      }).join('') + '</div>';
    }

    function getPricingSectionRenderKey(pricing, totalStudents, submittedStudents) {
      return JSON.stringify({
        scopes: pricingScopesHtml(pricing),
        cohortCode: currentCohortCode || '',
        currencyCode: pricing.currencyCode || 'USD',
        submittedGrandTotal: pricing.submittedGrandTotal,
        submittedProductsTotal: pricing.submittedProductsTotal,
        submittedPersonalizationTotal: pricing.submittedPersonalizationTotal,
        sourceLabel: pricing.sourceLabel || '',
        note: pricing.note || '',
        lineItems: pricing.lineItems || [],
        totalStudents: totalStudents,
        submittedStudents: submittedStudents
      });
    }

    function renderPricingSection(pricing, totalStudents, submittedStudents) {
      var container = document.getElementById('pricing-section');
      if (!container) {
        return;
      }

      var renderKey = getPricingSectionRenderKey(pricing, totalStudents, submittedStudents);
      var existingBreakdown = container.querySelector('.pricing-breakdown');
      var wasOpen = !!(existingBreakdown && existingBreakdown.open);

      if (container.dataset.pricingRenderKey === renderKey) {
        return;
      }

      container.dataset.pricingRenderKey = renderKey;

      var currencyCode = pricing.currencyCode || 'USD';
      var lineItems = pricing.lineItems || [];
      var lineItemCount = lineItems.length;
      var cohortTotal = Math.max(0, parseInt(totalStudents, 10) || 0);
      var submittedCount = Math.max(0, parseInt(submittedStudents, 10) || 0);

      container.innerHTML =
        '<div class="pricing-section-inner">' +
          '<div class="pricing-header">' +
            '<h2 class="pricing-title">Estimated <span class="tb-gradient-text">cohort pricing</span></h2>' +
            '<p class="pricing-lead">A quick estimate for the students your school will be billed for.</p>' +
          '</div>' +
          '<div class="pricing-focus-card">' +
            '<div class="pricing-focus-label">' +
              '<span class="label-with-tip">Estimated total' + pricingInfoTip('Sum of product costs and personalization fees for the students the school will be billed for: those who chose their sizes and, where students pay for delivery themselves, have paid. Students still waiting to pay are left out here for the same reason the invoice leaves them out.') + '</span>' +
            '</div>' +
            '<div class="pricing-focus-value">' + esc(formatMoney(pricing.submittedGrandTotal, currencyCode)) + '</div>' +
            '<p class="pricing-focus-note">Based on students ready to be billed · ' + esc(pricing.sourceLabel || 'Preview') + '</p>' +
          '</div>' +
          pricingScopesHtml(pricing) +
          '<div class="pricing-metrics-compact">' +
            '<div class="pricing-metric-mini">' +
              '<span class="label"><span class="label-with-tip">Products' + pricingInfoTip('Total uniform product cost for the students who will be billed. Each line item price is multiplied by quantity per student.') + '</span></span>' +
              '<span class="value">' + esc(formatMoney(pricing.submittedProductsTotal, currencyCode)) + '</span>' +
            '</div>' +
            '<div class="pricing-metric-mini">' +
              '<span class="label"><span class="label-with-tip">Personalization' + pricingInfoTip('Fee for labeling each student\'s packages with their name and ID before shipment to your school, so items are easy to find in the group order box and hand out to students. Not embroidery. Shows $0 when disabled.') + '</span></span>' +
              '<span class="value">' + esc(formatMoney(pricing.submittedPersonalizationTotal, currencyCode)) + '</span>' +
            '</div>' +
          '</div>' +
          '<details class="pricing-breakdown"' + (wasOpen ? ' open' : '') + '>' +
            '<summary class="pricing-breakdown-summary">' +
              '<span class="pricing-breakdown-summary-main">' +
                '<span class="pricing-breakdown-icon" aria-hidden="true">$</span>' +
                '<span>' +
                  '<span class="pricing-breakdown-title">Product breakdown</span>' +
                  '<span class="pricing-breakdown-subtitle">See cost per uniform product</span>' +
                '</span>' +
              '</span>' +
              '<span class="pricing-breakdown-count">' + esc(lineItemCount) + ' ' + (lineItemCount === 1 ? 'item' : 'items') + '</span>' +
              '<span class="pricing-breakdown-chevron" aria-hidden="true"></span>' +
            '</summary>' +
            '<div class="pricing-breakdown-body">' +
              '<p class="pricing-breakdown-intro"><strong>Full cohort</strong> (' + esc(String(cohortTotal)) + ' students) shows the estimate if every student on your list orders this product. <strong>Ready to bill</strong> shows how many are counted in the total above (' + esc(String(submittedCount)) + ' of ' + esc(String(cohortTotal)) + ') — students who chose their sizes and owe nothing for delivery.</p>' +
              '<div class="pricing-line-items">' + pricingLineItemsHtml(pricing, cohortTotal, submittedCount) + '</div>' +
            '</div>' +
          '</details>' +
          (pricing.note
            ? '<p class="pricing-footnote">' + esc(pricing.note) + '</p>'
            : '') +
          surchargeNoticeHtml() +
        '</div>';
    }

    /*
      The estimate is built from list prices and excludes the per-item surcharge
      (2026-08-06). Kept as a sentence rather than a line in the total: the
      invoice is assembled by Mechanic from each student's saved items, and a
      second calculation here would only ever drift away from it.
    */
    function surchargeNoticeHtml() {
      /*
        Owner decision, 2026-08-06 — no surcharge sentence on any page. The
        money is unchanged: it is snapshotted at submit and billed by finalize
        as a Custom Fee line on the invoice. Keep in step with
        renderSurchargeNotice() in cohort-admin-form.js, which is switched off
        the same way and for the same reason.

        2026-08-11 — asked back by the owner, on this page and on the
        dashboard. The sentence is the only place the admin is told that the
        invoice will be higher than the estimate above it, and the amount it
        names is read from the same product data the estimate is built from,
        so the two cannot drift apart. Switched on by deleting the early
        return that turned it off; nothing else about it changed.
      */

      /* cohort.products arrives as a JSON string, same as everywhere else on
         this page — parse it rather than treating it as an array. */
      var products = parseJson(currentCohort && currentCohort.products, []);

      if (!Array.isArray(products)) return '';

      /* Named, not counted — keep in step with renderSurchargeNotice() in
         cohort-admin-form.js, which words the same sentence on the dashboard. */
      var byRate = {};

      products.forEach(function(product) {
        var rate = Number(product && product.surcharge) || 0;
        if (rate <= 0) return;

        var key = String(rate);
        if (!byRate[key]) byRate[key] = [];

        var title = String((product && (product.title || product.product_title)) || '').trim();
        if (title && byRate[key].indexOf(title) === -1) byRate[key].push(title);
      });

      var rates = Object.keys(byRate);
      if (!rates.length) return '';

      var text = rates.map(function(rate) {
        return 'A ' + formatMoney(Number(rate)) + ' processing fee applies to: ' + byRate[rate].join(', ') + '.';
      }).join(' ') + ' It is not included in the estimate above and will be added to the school invoice.';

      return '<p class="pricing-footnote pricing-surcharge-note">' + esc(text) + '</p>';
    }

    function heroMiniTile(label, value, extraClass, truncate) {
      return (
        '<div class="cohort-hero-mini' + (extraClass ? ' ' + extraClass : '') + '">' +
          '<span class="cohort-hero-mini-label">' + label + '</span>' +
          '<span class="cohort-hero-mini-value' + (truncate ? ' cohort-hero-mini-value--truncate' : '') + '">' + value + '</span>' +
        '</div>'
      );
    }

    function heroDeadlineCard(deadlineRaw, deadlineLabel) {
      var overdue = isPastDate(deadlineRaw);
      var note = overdue ? 'Deadline passed' : 'Submission ends';

      return (
        '<div class="cohort-hero-deadline-card' + (overdue ? ' cohort-hero-deadline-card--overdue' : '') + '">' +
          '<span class="cohort-hero-deadline-label">Deadline</span>' +
          '<span class="cohort-hero-deadline-icon" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M8 3v3M16 3v3M3 10h18"/></svg>' +
          '</span>' +
          '<span class="cohort-hero-deadline-value">' + esc(deadlineLabel) + '</span>' +
          '<span class="cohort-hero-deadline-note">' + esc(note) + '</span>' +
        '</div>'
      );
    }

    function heroStudentsStat(total) {
      return (
        '<div class="cohort-hero-stat cohort-hero-board-students">' +
          '<span class="cohort-hero-stat-label">Students</span>' +
          '<span class="cohort-hero-stat-value">' + esc(String(total)) + '</span>' +
        '</div>'
      );
    }

    function renderCohortHero(cohort, students) {
      var hero = document.getElementById('cohort-hero');
      var studentFormUrl = buildStudentFormUrl(cohort);
      var qrUrl = buildQrUrl(studentFormUrl);
      var personalized = isPersonalized(cohort);
      var schoolName = cohort && cohort.schoolName ? cohort.schoolName : 'Cohort';
      var cohortLabel = getCohortLabel(cohort);
      var heroTitle = cohortLabel || schoolName;
      var totalStudents = students.length;
      var deadlineLabel = formatDeadline(cohort.deadline);

      hero.innerHTML =
        '<div class="cohort-hero">' +
          '<div class="cohort-hero-main">' +
            '<div class="cohort-hero-head">' +
              '<p class="cohort-hero-eyebrow">School Cohort Overview</p>' +
              '<h2 class="cohort-hero-title">' + esc(heroTitle) + '</h2>' +
            '</div>' +
            '<div class="cohort-hero-board">' +
              '<div class="cohort-hero-code-badge cohort-hero-board-code">' +
                '<div class="cohort-hero-code-copy">' +
                  '<span class="cohort-hero-code-label">Cohort Code</span>' +
                  '<span class="cohort-hero-code-value">' + esc(currentCohortCode) + '</span>' +
                '</div>' +
                heroCodeInfoTip('This is your cohort\'s unique code. Enter it at the top of this dashboard anytime to load the cohort and view statistics.') +
              '</div>' +
              '<div class="cohort-hero-board-school">' +
                '<span class="cohort-hero-mini-label">School</span>' +
                '<span class="cohort-hero-mini-value">' + esc(schoolName) + '</span>' +
              '</div>' +
              '<div class="cohort-hero-board-deadline">' +
                heroDeadlineCard(cohort.deadline, deadlineLabel) +
              '</div>' +
              heroStudentsStat(totalStudents) +
              /*
                2026-08-11 — wraps instead of truncating. The tile asked for an
                ellipsis, so "Yana Ratskevich" arrived as "Yana Rat…" and the
                admin could not read their own name. A name is short enough to
                take a second line; cutting it saved nothing.
              */
              heroMiniTile('Admin Name', esc(cohort.adminName || '—'), 'cohort-hero-board-admin') +
              heroMiniTile('Personalized', esc(personalized ? 'Yes' : 'No'), 'cohort-hero-board-pers') +
              heroMiniTile('Order Type', esc(getOrderTypeLabel(cohort.orderType)), 'cohort-hero-board-order') +
              '<div class="cohort-hero-board-email">' +
                '<span class="cohort-hero-mini-label">Admin Email</span>' +
                '<span class="cohort-info-value">' + esc(cohort.adminEmail || '—') + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          /*
            2026-08-11 — a finalized cohort stops offering its form.

            The link and the QR still pointed at it, and following either landed
            on "Form closed" — correct, and a dead end. The way on for someone
            who missed the deadline is a late round, so say that instead of
            handing out a door that no longer opens.
          */
          (isCohortFinalized(cohort)
            ? '<aside class="cohort-qr-panel is-closed">' +
                '<div class="cohort-qr-panel-inner">' +
                  '<p class="cohort-qr-eyebrow">Student Access</p>' +
                  '<h3 class="cohort-qr-title">This cohort is closed</h3>' +
                  /* No Create PDF either (owner, 2026-08-11): the sheet it
                     makes is the QR poster for students to scan, and there is
                     nothing left to scan. */
                  '<p class="cohort-qr-closed-text">The form link and QR code no longer accept submissions. To give latecomers a new deadline, open this cohort on the dashboard and start a late round — everyone still waiting gets a fresh link of their own.</p>' +
                '</div>' +
              '</aside>'
            : '<aside class="cohort-qr-panel">' +
                '<div class="cohort-qr-panel-inner">' +
                  '<p class="cohort-qr-eyebrow">Student Access</p>' +
                  '<h3 class="cohort-qr-title">Scan to submit sizes</h3>' +
                  '<div class="cohort-qr-frame">' +
                    (qrUrl
                      ? '<img class="cohort-qr-image" src="' + esc(qrUrl) + '" alt="Student form QR code">'
                      : '<div class="cohort-qr-empty">No form URL</div>') +
                  '</div>' +
                  '<div class="cohort-qr-actions">' +
                    '<button type="button" class="cohort-qr-btn" id="qr-create-pdf-btn">Create PDF</button>' +
                    (studentFormUrl
                      ? '<a class="cohort-qr-link" href="' + esc(studentFormUrl) + '" target="_blank" rel="noopener">Open form link</a>'
                      : '') +
                  '</div>' +
                '</div>' +
              '</aside>') +
        '</div>';

      var printButton = document.getElementById('qr-create-pdf-btn');

      if (printButton) {
        printButton.addEventListener('click', function() {
          if (!qrUrl) {
            return;
          }

          var qrHtml =
            '<div class="print-only-qr">' +
              '<div class="print-only-qr-sheet">' +
                '<img class="print-only-qr-image" src="' + esc(qrUrl) + '" alt="Student form QR code">' +
                '<h2 class="print-only-qr-title">Scan to open Student Form</h2>' +
                '<p class="print-only-qr-meta">' + esc(schoolName) + ' · ' + esc(currentCohortCode) + '</p>' +
              '</div>' +
            '</div>';

          printHtmlInIframe({
            qrOnly: true,
            title: 'Cohort ' + currentCohortCode + ' QR',
            bodyHtml: qrHtml
          });
        });
      }
    }

    function getStudentPrintStatus(student) {
      var submitted = hasSubmittedSizes(student);
      var unmatched = isUnmatchedStudent(student);

      if (submitted && unmatched) return { cardClass: 'unmatched', badgeClass: 'unmatched', text: 'Not on approved list' };
      if (submitted) return { cardClass: 'submitted', badgeClass: 'submitted', text: 'Submitted' };

      return { cardClass: 'pending', badgeClass: 'pending', text: 'Pending' };
    }

    function getPrintStudentItems(student) {
      var items = getStudentItems(student);

      if (!items.length) {
        return '—';
      }

      return items.map(function(item, index) {
        var fallbackKey = item._key || item.product_id || String(index + 1);
        var title = getItemDisplayTitle(item, fallbackKey);
        var selection = getItemSelection(item);

        /* Same rule as renderSizes: no size to report, no punctuation for it. */
        return selection ? title + ': ' + selection : title;
      }).join(' • ');
    }

    function buildPrintStudentsHtml(students, emptyMessage) {
      if (!students.length) {
        return '<div class="print-student-card pending"><div class="print-student-name">' + esc(emptyMessage || 'No students in this section.') + '</div></div>';
      }

      return mapStudentsWithListNumbers(students).map(function(entry) {
        var student = entry.student;
        var status = getStudentPrintStatus(student);
        var fullName = [student.first_name || '', student.last_name || ''].join(' ').trim() || 'Name not submitted';
        var indexClass = 'print-student-index' + (entry.unmatched ? ' is-unmatched' : '');

        return (
          '<div class="print-student-card ' + esc(status.cardClass) + '">' +
            '<div class="print-student-row">' +
              '<span class="' + indexClass + '" aria-hidden="true">' + entry.listNumber + '.</span>' +
              '<div class="print-student-content">' +
                '<div class="print-student-top">' +
                  '<p class="print-student-name">' + esc(fullName) + '</p>' +
                  '<span class="print-student-badge ' + esc(status.badgeClass) + '">' + esc(status.text) + '</span>' +
                '</div>' +
                '<div class="print-student-meta">' +
                  '<div><strong>ID:</strong> ' + esc(student.student_id || '—') + '</div>' +
                  '<div><strong>Email:</strong> ' + esc(student.email || '—') + '</div>' +
                  '<div><strong>Approved list:</strong> ' + esc(formatApprovedListStatus(student)) + '</div>' +
                '</div>' +
                '<div class="print-student-items"><strong>Items:</strong> ' + esc(getPrintStudentItems(student)) + '</div>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function buildPrintPricingLineItemsHtml(pricing) {
      var currencyCode = pricing.currencyCode || 'USD';
      var lineItems = pricing.lineItems || [];

      if (!lineItems.length) return '';

      /*
        2026-08-11 — the printed sheet is grouped by campus like the screen it
        prints. It is the version that gets handed around, so it is the last
        place that should describe the cohort differently: the campus is what
        decides which invoice a line lands on.
      */
      return groupLineItemsByCampus(lineItems).map(function(group) {
        var groupSubmitted = group.campus ? countSubmittedInCampus(group.campus) : null;

        var rows = group.items.map(function(item) {
          var submittedTotal = groupSubmitted === null
            ? (item.submitted_students_total || 0)
            : (toNumber(item.line_total_per_student) * groupSubmitted);

          return (
            '<div class="print-line-item">' +
              '<div class="print-line-item-title">' + esc(item.title || 'Item') +
                (item.program_names ? ' (' + esc(item.program_names) + ')' : '') + '</div>' +
              '<div class="print-line-item-meta">Qty: ' + esc(item.quantity_per_student || 0) + '</div>' +
              '<div class="print-line-item-meta">Unit: ' + esc(formatMoney(item.unit_price || 0, currencyCode)) + '</div>' +
              '<div class="print-line-item-meta">Ready to bill: ' + esc(formatMoney(submittedTotal, currencyCode)) + '</div>' +
            '</div>'
          );
        }).join('');

        return (group.campus ? '<div class="print-line-campus">' + esc(group.campus) + '</div>' : '') +
          '<div class="print-line-items">' + rows + '</div>';
      }).join('');
    }

    function renderPrintLayout(cohort, students, pricing) {
      var container = document.getElementById('cohort-print-layout');
      var studentFormUrl = buildStudentFormUrl(cohort);
      var qrUrl = buildQrUrl(studentFormUrl);
      var submitted = countSubmittedStudents(students);
      var pending = students.length - submitted;
      var unmatched = students.filter(function(student) {
        return isUnmatchedStudent(student) && hasSubmittedSizes(student);
      }).length;
      var currencyCode = pricing && pricing.currencyCode ? pricing.currencyCode : 'USD';
      var pendingStudents = students.filter(function(student) {
        return !hasSubmittedSizes(student);
      });
      var submittedStudents = students.filter(hasSubmittedSizes);

      container.innerHTML =
        '<div class="print-report">' +
          '<div class="print-header">' +
            '<h1 class="print-school-name">' + esc(cohort.schoolName || 'Cohort') + '</h1>' +
            '<p class="print-cohort-code">Cohort Code: ' + esc(currentCohortCode || '—') + '</p>' +
          '</div>' +
          '<div class="print-qr-wrap">' +
            '<div class="print-qr-box">' + (qrUrl ? '<img src="' + esc(qrUrl) + '" alt="Student form QR code">' : 'No student form URL') + '</div>' +
          '</div>' +
          '<div class="print-section">' +
            '<h2 class="print-section-title">Admin Details</h2>' +
            '<div class="print-admin-grid">' +
              '<div class="print-info-box"><span class="print-info-label">Admin Name</span><span class="print-info-value">' + esc(cohort.adminName || '—') + '</span></div>' +
              '<div class="print-info-box"><span class="print-info-label">Admin Email</span><span class="print-info-value">' + esc(cohort.adminEmail || '—') + '</span></div>' +
              '<div class="print-info-box"><span class="print-info-label">Deadline</span><span class="print-info-value">' + esc(formatDeadline(cohort.deadline)) + '</span></div>' +
              '<div class="print-info-box"><span class="print-info-label">Order Type</span><span class="print-info-value">' + esc(getOrderTypeLabel(cohort.orderType)) + '</span></div>' +
            '</div>' +
          '</div>' +
          '<div class="print-section">' +
            '<h2 class="print-section-title">Submission Summary</h2>' +
            '<div class="print-stats-grid">' +
              '<div class="print-stat-box"><span class="print-stat-label">Total Students</span><span class="print-stat-value">' + esc(students.length) + '</span></div>' +
              '<div class="print-stat-box"><span class="print-stat-label">Submitted</span><span class="print-stat-value">' + esc(submitted) + '</span></div>' +
              '<div class="print-stat-box"><span class="print-stat-label">Pending</span><span class="print-stat-value">' + esc(pending) + '</span></div>' +
              '<div class="print-stat-box"><span class="print-stat-label">Not on approved list</span><span class="print-stat-value">' + esc(unmatched) + '</span></div>' +
            '</div>' +
          '</div>' +
          '<div class="print-section">' +
            '<h2 class="print-section-title">Pending Students</h2>' +
            '<div class="print-students-list">' + buildPrintStudentsHtml(pendingStudents, 'No pending students.') + '</div>' +
          '</div>' +
          '<div class="print-section">' +
            '<h2 class="print-section-title">Submitted Students</h2>' +
            '<div class="print-students-list">' + buildPrintStudentsHtml(submittedStudents, 'No submitted students yet.') + '</div>' +
          '</div>' +
          '<div class="print-section">' +
            '<h2 class="print-section-title">Pricing Summary</h2>' +
            '<div class="print-pricing-grid">' +
              '<div class="print-price-box"><span class="print-price-label">Billable Products</span><span class="print-price-value">' + esc(formatMoney(pricing.submittedProductsTotal, currencyCode)) + '</span></div>' +
              '<div class="print-price-box"><span class="print-price-label">Billable Personalization</span><span class="print-price-value">' + esc(formatMoney(pricing.submittedPersonalizationTotal, currencyCode)) + '</span></div>' +
              '<div class="print-price-box"><span class="print-price-label">Billable Total</span><span class="print-price-value">' + esc(formatMoney(pricing.submittedGrandTotal, currencyCode)) + '</span></div>' +
            '</div>' +
            buildPrintPricingLineItemsHtml(pricing) +
            '<div class="print-note-text"><strong>Source:</strong> ' + esc(pricing.sourceLabel || 'Preview') + '. ' + esc(pricing.note || '') + '</div>' +
          '</div>' +
        '</div>';
    }

    function getCacheTimestamp(cache) {
      var timestamp = Date.parse(cache && cache.updatedAt ? String(cache.updatedAt) : '');
      return isNaN(timestamp) ? 0 : timestamp;
    }

    function findCacheByCode(code) {
      var normalized = normalizeCode(code);
      var loose = normalizeCodeLoose(code);

      var matches = caches.filter(function(cache) {
        return normalizeCode(cache.cohortCode) === normalized || normalizeCodeLoose(cache.cohortCode) === loose;
      });

      if (!matches.length) return null;

      matches.sort(function(a, b) {
        return getCacheTimestamp(b) - getCacheTimestamp(a);
      });

      return matches[0];
    }

    function findCohortByCode(code) {
      var normalized = normalizeCode(code);
      var loose = normalizeCodeLoose(code);

      return cohorts.find(function(cohort) {
        return normalizeCode(cohort.cohortCode) === normalized || normalizeCodeLoose(cohort.cohortCode) === loose;
      }) || null;
    }

    function sortStudents(students) {
      return students.sort(function(a, b) {
        var nameA = [a.last_name || '', a.first_name || '', a.email || ''].join(' ').toLowerCase();
        var nameB = [b.last_name || '', b.first_name || '', b.email || ''].join(' ').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }

    function updateOverallProgress(total, submittedCount) {
      var el = document.getElementById('overall-progress-fraction');
      if (!el) return;
      el.textContent = submittedCount + ' of ' + total;
    }

    function updatePendingSectionHeader(pendingCount, finalized) {
      var section = document.getElementById('pending-students-section');
      var title = document.getElementById('pending-section-title');
      var lateNotice = document.getElementById('pending-late-notice');
      var count = Math.max(0, parseInt(pendingCount, 10) || 0);
      var isLateMode = finalized && count > 0;

      if (section) {
        section.classList.toggle('is-late-mode', isLateMode);

        /*
          2026-08-06, owner decision — once the cohort is finalized this page
          shows the order, and pending students are not in it. They are managed
          on the dashboard and invited into a late round from there; listing
          them beside the people who were actually billed only invited the
          question of why they were not.

          This replaces the earlier rule, which kept them whenever no late round
          existed yet.

          Students from the "Outside list" stay: cohort-finalize.liquid selects
          by cohort code and status only, with no email_match_status filter, so
          a student who submitted with an address that was never on the list IS
          billed on this invoice. Hiding them would hide people the school is
          paying for.
        */
        /*
          2026-08-11, owner's model — supersedes the rule above. A finalized
          cohort hides its waiting students only once they have somewhere else
          to be: the moment a late round is given a deadline, they belong to it
          and are listed there. Until then this page was the only one not
          showing them, and the dashboard was.

          getPendingStudentsForDisplay already drops anyone in an open round, so
          the count answers exactly that question and the section can follow it.
        */
        section.style.display = count > 0 ? '' : 'none';
      }

      if (title) {
        if (finalized) {
          title.innerHTML = '<span class="section-title-accent late-accent">Late</span> students <span class="section-count" id="pending-count">' + count + '</span>';
        } else {
          title.innerHTML = '<span class="section-title-accent pending-accent">Pending</span> students <span class="section-count" id="pending-count">' + count + '</span>';
        }
      }

      /*
        2026-08-06 — say where these students can be acted on, whenever there
        are any. This page stopped writing in step 3 of the rework, so a list of
        people you cannot do anything to is a dead end unless it names the way
        out. Empty list, no sentence: there is nothing to act on.

        Worded without naming a late batch, unlike the same note on a Late card.
        This is the main cohort — there is no "Late 01" list to send anyone to,
        and pointing at one would send them looking for something that is not
        there.
      */
      if (lateNotice) {
        var showNotice = count > 0;

        lateNotice.textContent = showNotice
          ? 'To edit these students or send them a reminder, open this cohort on the dashboard.'
          : '';
        lateNotice.style.display = showNotice ? '' : 'none';
      }
    }

    function getPendingEmptyMessage(finalized) {
      if (finalized) {
        /* 2026-08-25 — the sentence follows the list: it now holds students who
           answered but never paid for delivery as well as those who never
           answered, so 'everyone submitted' was no longer the whole reason it
           can be empty. */
        return 'No late students. Everyone on your list was billed on this cohort.';
      }

      return 'No pending students. Everyone has submitted!';
    }

    function loadAndRender(cohortCode) {
      var button = document.getElementById('cohort-status-button');
      var results = document.getElementById('cohort-status-results');
      var normalized = normalizeCode(cohortCode);

      button.disabled = true;
      showFinalizeNotice('', '');
      setMessage('');

      if (!normalized) {
        setMessage('Please enter a valid cohort code.', 'error');
        button.disabled = false;
        return;
      }

      currentCohortCode = normalized;

      var cohort = findCohortByCode(normalized);
      var cache = findCacheByCode(normalized);

      if (!cohort && !cache) {
        results.style.display = 'none';
        document.getElementById('cohort-print-layout').innerHTML = '';
        setMessage('No cohort found for code "' + normalized + '". Please check the code and try again.', 'error');
        button.disabled = false;
        return;
      }

      currentCohort = cohort || {};

      /*
        Read this before the first updateFinalizeButtonState call below, so the
        button can be rendered as still-finalizing when the reload outran the
        Mechanic task that writes the cohort record.
      */
      var finalizeJustCompleted = consumeFinalizeJustCompleted(normalized);
      if (finalizeJustCompleted && !isCohortFinalized(currentCohort)) {
        finalizeAwaitingConfirmation = true;
      }

      updateAdminDashboardLink(currentCohort);
      currentStudents = buildStatusStudentsList(
        cache ? parseStudentsJson(cache.studentsJson) : [],
        cohort || {}
      );
      currentPricing = getPricingData(currentCohort, currentStudents);
      clearStudentsSetupRefresh();

      var rosterEmailCount = getRosterEmailCount(currentCohort.studentEmailsRaw);
      var studentsStillProvisioning = currentStudents.length === 0 && rosterEmailCount > 0;

      if (currentStudents.length > 0) {
        try {
          window.sessionStorage.removeItem('cohort_setup_poll_' + normalized);
        } catch (error) {}
      }

      var pending = getPendingStudentsForDisplay(currentStudents, currentCohort);

      var submitted = currentStudents.filter(hasSubmittedSizes);
      var mainSubmitted = withoutWaitingRoomStudents(
        submitted.filter(function(student) {
          return !hasLateBatch(student);
        }),
        currentCohort
      );

      /* The confirmed-but-unlisted tally stood here for the old note under
         Confirmed. renderSummaryNotes counts its own, over the whole cohort
         rather than the confirmed part of it, and nothing else read this. */

      renderCohortHero(currentCohort, currentStudents);

      /*
        2026-08-11 — the same numbers as refreshStatusStudentGrids, written the
        same way. This second copy is why the summary could disagree with itself
        depending on which render ran last, and it still held a reference to the
        pill that has since been merged into Confirmed — reading textContent off
        an element that is no longer there would have taken the page down.
      */
      var stillOwingForm = currentStudents.filter(function(student) {
        return !isRemovedStudent(student) && !hasSubmittedSizes(student);
      }).length;

      /* Same subtraction as the other copy, for the same reason. */
      var awaitingPaymentHere = currentStudents.filter(isAwaitingPaymentStudent);
      var confirmedPaidHere = submitted.filter(function(student) {
        return !isAwaitingPaymentStudent(student);
      });

      document.getElementById('summary-total').textContent = Math.max(currentStudents.length, rosterEmailCount);
      document.getElementById('summary-submitted').textContent = confirmedPaidHere.length;
      document.getElementById('summary-pending').textContent = stillOwingForm;
      renderAwaitingPaymentPill(awaitingPaymentHere.length);
      updateOverallProgress(Math.max(currentStudents.length, rosterEmailCount), confirmedPaidHere.length);

      /* The same lines as the other renderer, from the same function — this
         one runs first, so writing anything else here is what the reader saw
         change a second later. */
      renderSummaryNotes(currentStudents, rosterEmailCount);

      updatePendingSectionHeader(countApprovedListPending(currentStudents, currentCohort), isCohortFinalized(currentCohort));
      document.getElementById('confirmed-count').textContent = mainSubmitted.length;

      var pendingGrid = document.getElementById('pending-students');
      var confirmedGrid = document.getElementById('confirmed-students');
      var cohortFinalized = isCohortFinalized(currentCohort);

      pendingGrid.innerHTML = pending.length
        ? mapStudentsWithListNumbers(pending).map(function(entry) {
            return studentCardHtml(entry.student, entry.listNumber, entry.unmatched);
          }).join('')
        : '<div class="empty-section">' + getPendingEmptyMessage(cohortFinalized) + '</div>';
      pendingGrid.classList.toggle('is-empty', pending.length < 1);

      confirmedGrid.innerHTML = mainSubmitted.length
        ? mapStudentsWithListNumbers(mainSubmitted).map(function(entry) {
            return studentCardHtml(entry.student, entry.listNumber, entry.unmatched);
          }).join('')
        : '<div class="empty-section">No submitted students yet.</div>';
      confirmedGrid.classList.toggle('is-empty', mainSubmitted.length < 1);

      renderPricingSection(currentPricing, currentStudents.length, countBillableStudents(currentStudents));
      renderPrintLayout(currentCohort, currentStudents, currentPricing);
      updateFinalizeButtonState(currentCohort, currentStudents);
      renderLateBatchesSection(currentCohortCode);

      /* И при первой отрисовке тоже: браузер восстанавливает содержимое поля
         при возврате «назад», и оно не должно расходиться со списком. */
      reapplySearchFilter();

      restoreStatusPageEmailFocus();

      results.style.display = 'block';

      if (studentsStillProvisioning) {
        scheduleStudentsSetupRefresh(normalized);
      } else {
        setMessage('');
      }

      if (finalizeJustCompleted) {
        showFinalizeNotice(
          finalizeJustCompleted.late_batch_code
            ? 'Late Cohort ' + String(finalizeJustCompleted.late_batch_code).replace(/^LATE-/i, '') + ' finalized'
            : 'Cohort finalized',
          FINALIZE_INVOICE_PENDING_MESSAGE,
          'success'
        );
        scrollFinalizeNoticeIntoView();
      }

      button.disabled = false;
      startStatusIdleSync();
    }

    function downloadCsv() {
      if (!currentCohortCode) {
        setMessage('Load a cohort before downloading.', 'error');
        return;
      }

      var rows = [[
        'Cohort Code',
        'First Name',
        'Last Name',
        'Student ID',
        'Email',
        'Status',
        'Approved list status',
        'Items'
      ]];

      currentStudents.forEach(function(student) {
        rows.push([
          currentCohortCode,
          student.first_name || '',
          student.last_name || '',
          student.student_id || '',
          student.email || '',
          hasSubmittedSizes(student) ? 'submitted' : 'pending',
          formatApprovedListStatus(student),
          getStudentItems(student).map(function(item, index) {
            var fallbackKey = item._key || item.product_id || String(index + 1);
            return getItemDisplayTitle(item, fallbackKey) + ': ' + (getItemSelection(item) || '');
          }).join(' | ')
        ]);
      });

      var csv = rows.map(function(row) {
        return row.map(function(cell) {
          var value = String(cell == null ? '' : cell);
          return '"' + value.replace(/"/g, '""') + '"';
        }).join(',');
      }).join('\r\n');

      var blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');

      link.href = url;
      link.download = 'cohort-' + currentCohortCode + '-status.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    function collectPageStyles() {
      var css = '';

      document.querySelectorAll('style').forEach(function(node) {
        css += node.textContent + '\n';
      });

      return css;
    }

    /*
      2026-08-06 — the print window used to receive only the page's inline
      <style> blocks. This page has none: its CSS arrives as
      {{ 'cohort-status.css' | asset_url | stylesheet_tag }}, which renders a
      <link>. So the printed document was built with no styling at all — that is
      why the report came out plain and the QR code sat against the left edge
      instead of centred. Copying the <link> elements is the whole fix; the
      centring rules were always there, they just never arrived.
    */
    function copyPageStylesheets(doc) {
      var links = Array.prototype.slice.call(
        document.querySelectorAll('link[rel="stylesheet"][href]')
      );

      if (!links.length) return Promise.resolve();

      var waits = links.map(function(link) {
        var clone = doc.createElement('link');
        clone.rel = 'stylesheet';
        clone.href = link.href;

        var settled = new Promise(function(resolve) {
          clone.addEventListener('load', resolve);
          clone.addEventListener('error', resolve);
        });

        doc.head.appendChild(clone);
        return settled;
      });

      /*
        Printing before the stylesheets load produces the same unstyled page
        this fix is about, so wait for them — but never longer than two seconds.
        A stylesheet that will not load must not leave the admin staring at a
        print dialog that never opens.
      */
      return Promise.race([
        Promise.all(waits),
        new Promise(function(resolve) { window.setTimeout(resolve, 2000); })
      ]);
    }

    function printHtmlInIframe(options) {
      options = options || {};

      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none';
      document.body.appendChild(iframe);

      var win = iframe.contentWindow;
      var doc = win.document;

      /*
        Centring stated here as well as in the stylesheet. If a stylesheet fails
        to load, the report should still come out readable rather than pinned to
        the left edge — the one complaint that started this.
      */
      var css = collectPageStyles() +
        'body{margin:0;padding:0;background:#ffffff;}' +
        '#cohort-print-layout,.print-only-qr,.print-report{display:block!important;visibility:visible!important;}' +
        '.print-only-qr,.print-only-qr-sheet{text-align:center!important;}' +
        '.print-only-qr-image{display:block!important;margin-left:auto!important;margin-right:auto!important;width:110mm!important;height:110mm!important;}' +
        '.print-only-qr-title,.print-only-qr-meta{text-align:center!important;}' +
        /* Keep the code, the caption and the QR on one sheet. */
        '.print-only-qr-sheet{page-break-inside:avoid!important;break-inside:avoid!important;}';

      doc.open();
      doc.close();

      doc.title = options.title || 'Cohort Report';

      var stylesReady = copyPageStylesheets(doc);

      var styleNode = doc.createElement('style');
      styleNode.textContent = css;
      doc.head.appendChild(styleNode);

      if (options.qrOnly) {
        doc.body.className = 'print-qr-mode';
      }

      var mount = doc.createElement('div');
      mount.innerHTML = options.bodyHtml || '';
      while (mount.firstChild) {
        doc.body.appendChild(mount.firstChild);
      }

      function cleanup() {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }

      function runPrint() {
        if (!win) {
          cleanup();
          return;
        }

        win.focus();
        win.print();
        setTimeout(cleanup, 1200);
      }

      /*
        Wait for the stylesheets first, then keep the old short pause so images
        — the QR among them — have a moment to decode before the dialog opens.
      */
      stylesReady.then(function() {
        setTimeout(runPrint, options.qrOnly ? 700 : 450);
      });
    }

    function printPdf() {
      if (!currentCohortCode) {
        setMessage('Load a cohort before printing.', 'error');
        return;
      }

      if (currentCohort && currentPricing) {
        renderPrintLayout(currentCohort, currentStudents, currentPricing);
      }

      var layout = document.getElementById('cohort-print-layout');
      if (!layout || !layout.innerHTML) {
        setMessage('Nothing to print yet. Load a cohort and try again.', 'error');
        return;
      }

      printHtmlInIframe({
        title: 'Cohort ' + currentCohortCode + ' Status',
        bodyHtml: '<div id="cohort-print-layout">' + layout.innerHTML + '<' + '/div>'
      });
    }

    function openFinalizedInfoModal() {
      return new Promise(function(resolve) {
        var overlay = document.getElementById('finalized-info-modal-overlay');
        var closeButton = document.getElementById('finalized-info-modal-close');
        var textElement = document.getElementById('finalized-info-modal-text');

        if (textElement) {
          textElement.textContent = FINALIZE_INVOICE_MESSAGE;
        }

        function closeModal() {
          overlay.classList.remove('show');
          overlay.setAttribute('aria-hidden', 'true');
          closeButton.removeEventListener('click', onClose);
          overlay.removeEventListener('click', onOverlayClick);
          document.removeEventListener('keydown', onKeyDown);
          resolve();
        }

        function onClose() {
          closeModal();
        }

        function onOverlayClick(event) {
          if (event.target === overlay) {
            closeModal();
          }
        }

        function onKeyDown(event) {
          if (event.key === 'Escape') {
            closeModal();
          }
        }

        closeButton.addEventListener('click', onClose);
        overlay.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeyDown);

        overlay.classList.add('show');
        overlay.setAttribute('aria-hidden', 'false');

        setTimeout(function() {
          closeButton.focus();
        }, 50);
      });
    }

    function openFinalizeModal(options) {
      options = options || {};

      return new Promise(function(resolve) {
        var overlay = document.getElementById('finalize-modal-overlay');
        var confirmButton = document.getElementById('finalize-modal-confirm');
        var cancelButton = document.getElementById('finalize-modal-cancel');
        var notConfirmedCount = Math.max(0, parseInt(options.notConfirmedCount, 10) || 0);

        /*
          2026-08-17 — the unpaid warning is its own block, not a sentence
          appended to the one above.

          "Has not confirmed" and "has confirmed and owes for delivery" are two
          different losses. The first costs a student their uniform until
          somebody gets round to a late round; the second costs the school
          nothing and the shop a uniform, permanently, because paying moves the
          student out of the state a round collects from.

          Shown independently: a cohort can have one, the other, both or
          neither.
        */
        /*
          2026-08-24 — the three numbers, as on the round's dialog. confirmedCount
          is worked out by the caller with countConfirmedForFinalize, the browser's
          copy of the rule cohort-finalize applies; the two are meant to be read
          together.
        */
        var billedEl = document.getElementById('cohort-finalize-billed');
        var unpaidEl = document.getElementById('cohort-finalize-unpaid');
        var waitingEl = document.getElementById('cohort-finalize-waiting');

        if (billedEl) billedEl.textContent = Math.max(0, parseInt(options.billedCount, 10) || 0);
        if (unpaidEl) unpaidEl.textContent = Math.max(0, parseInt(options.awaitingPaymentCount, 10) || 0);
        if (waitingEl) waitingEl.textContent = Math.max(0, parseInt(options.notConfirmedCount, 10) || 0);

        var unpaidBlock = document.getElementById('finalize-modal-unpaid');
        var unpaidLead = document.getElementById('finalize-modal-unpaid-lead');
        var unpaidCount = Math.max(0, parseInt(options.awaitingPaymentCount, 10) || 0);
        var notAnsweredCount = Math.max(0, parseInt(options.notConfirmedCount, 10) || 0);

        /*
          2026-08-24 — both numbers in one sentence (owner).

          The block used to name only the students who had answered and not
          paid, while the ones who never answered were counted in a separate
          warning further down. Two blocks about the same thing — people this
          invoice leaves out — and one Late round brings back both.
        */
        /*
          2026-08-24 — the numbers are not repeated here any more (owner).

          The three counter rows above carry them, and this block used to say
          them again in prose, which is how a dialog stops fitting on a laptop.
          It shows or hides on the same condition as before; only the sentence
          has gone.
        */
        if (unpaidBlock) {
          unpaidBlock.style.display = (unpaidCount + notAnsweredCount) > 0 ? 'block' : 'none';
          if (unpaidLead) unpaidLead.textContent = '';
        }

        function closeModal(result) {
          overlay.classList.remove('show');
          overlay.setAttribute('aria-hidden', 'true');
          confirmButton.removeEventListener('click', onConfirm);
          cancelButton.removeEventListener('click', onCancel);
          overlay.removeEventListener('click', onOverlayClick);
          document.removeEventListener('keydown', onKeyDown);
          resolve(result);
        }

        function onConfirm() {
          closeModal(true);
        }

        function onCancel() {
          closeModal(false);
        }

        function onOverlayClick(event) {
          if (event.target === overlay) {
            closeModal(false);
          }
        }

        function onKeyDown(event) {
          if (event.key === 'Escape') {
            closeModal(false);
          }
        }

        confirmButton.addEventListener('click', onConfirm);
        cancelButton.addEventListener('click', onCancel);
        overlay.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeyDown);

        overlay.classList.add('show');
        overlay.setAttribute('aria-hidden', 'false');

        setTimeout(function() {
          confirmButton.focus();
        }, 50);
      });
    }

    /*
      2026-08-11, phase 7 — the school's invoices, one per campus.

      Read from a field of their own rather than from the summary: the page
      rewrites the summary locally whenever it updates counts optimistically,
      and a list living in there would disappear on the next such update.

      Kept in step with the same block in cohort-admin-form.js — shared
      concepts have to read the same on both pages.
    */
    function parseCampusInvoices(cohortCode) {
      var cache = findCacheByCode(cohortCode);
      if (!cache || !cache.campusInvoicesJson) return [];

      try {
        var parsed = JSON.parse(cache.campusInvoicesJson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function campusInvoiceScopeLabel(invoice) {
      var batchCode = String(invoice.late_batch_code || '').trim();
      if (!batchCode) return 'Main cohort';
      return 'Late ' + batchCode.replace(/^LATE-/i, '');
    }

    function campusInvoiceStatusLabel(invoice) {
      var status = String(invoice.status || '').trim().toLowerCase();
      if (status === 'created') return 'Ready to pay';
      if (status === 'paid') return 'Paid';
      if (status === 'creating') return 'Being created';
      return 'Not created';
    }

    /*
      ── 2026-08-25 — a statement, not a wall of cards (owner: A5) ───────────

      Every campus is a line: name and state on the left, the amount on the
      right, the way anybody reads money. Two amounts one under the other can
      be compared without thinking; two amounts inside two cards cannot.

      The paid line keeps the badge this page has always used — solid green
      with near-black green text — and takes a green wash and a green edge as
      well, so the state is read before the badge is.
    */
    function campusInvoiceAmountValue(invoice) {
      var raw = String(invoice && invoice.total_price || '').trim();
      if (!raw) return null;

      var cleaned = raw.replace(/[^0-9.]/g, '');
      if (!cleaned) return null;

      var value = Number(cleaned);
      return isFinite(value) ? value : null;
    }

    function formatCampusInvoiceAmount(value) {
      return '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    /*
      What the school still owes, across every campus that has not paid.

      Written only when every unpaid invoice carries an amount: a total that
      quietly leaves one campus out is worse than no total at all, because it
      looks like the whole answer.
    */
    function campusInvoicesOutstanding(invoices) {
      var total = 0;
      var counted = 0;

      for (var i = 0; i < invoices.length; i++) {
        var status = String(invoices[i].status || '').trim().toLowerCase();
        if (status === 'paid') continue;

        var value = campusInvoiceAmountValue(invoices[i]);
        if (value === null) return null;

        total += value;
        counted += 1;
      }

      if (!counted) return null;
      return { total: total, count: counted };
    }

    function campusInvoiceCardHtml(invoice) {
      var studentCount = Number(invoice.student_count || 0);
      var status = String(invoice.status || '').trim().toLowerCase();
      var invoiceUrl = String(invoice.invoice_url || '').trim();
      var isPaid = status === 'paid';
      /* Blank when Shopify's payload did not carry a total — the card simply
         leaves the amount out rather than printing a confident zero. */
      var totalLabel = String(invoice.total_price || '').trim();
      if (totalLabel && totalLabel.charAt(0) !== '$') totalLabel = '$' + totalLabel;

      /*
        A paid invoice loses the call to action: pressing "Pay" on something
        already paid is how a school pays twice. The card says "Paid" in a
        badge of its own rather than only in the small print.

        2026-10-05 (owner) — and it loses the link too. Shopify retires an
        invoice's address once it is paid, so "View invoice" opened a page
        that said it did not exist. In its place, the number of the order the
        payment became, written by Cohort: Capture Paid Order and carried by
        the cache as paid_order_name. Text, not a link: that order lives in
        Shopify admin, which a school cannot open.
      */
      var paidOrderName = String(invoice.paid_order_name || '').trim();
      var linkHtml = '';
      /*
        The demo draws the button and answers when it is pressed.

        It began as a sentence where the button would have been, and that was
        wrong for a page whose job is to show what the system looks like: the
        paying button is the end of the whole story the demo tells, and a
        visitor who never sees it does not know it exists. Owner, 2026-09-14.

        The button is a button element and carries no address, so there is
        nothing to open, nothing in the page source to copy, and nothing to
        pay - the same guarantee as before, made where a person can see it.
      */
      if (CONFIG.demoMode) {
        linkHtml =
          '<button type="button" class="cohort-campus-invoice-link cohort-campus-invoice-demo-button' +
          (demoInvoiceNoteShown(invoice) ? ' is-answered' : '') +
          '" data-demo-invoice="' + esc(demoInvoiceKey(invoice)) + '">Open invoice &amp; pay</button>';
      } else if (isPaid) {
        if (paidOrderName) {
          linkHtml = '<span class="cohort-campus-invoice-paid-order">Order ' + esc(paidOrderName) + '</span>';
        }
      } else if (invoiceUrl) {
        linkHtml = '<a class="cohort-campus-invoice-link" href="' + esc(invoiceUrl) + '" target="_blank" rel="noopener">Open invoice &amp; pay</a>';
      } else if (status === 'creating') {
        linkHtml = '<span class="cohort-campus-invoice-pending">The payment link appears here in a moment. Refresh the page.</span>';
      }

      /*
        ── 2026-09-03 — the link, without opening it (owner) ────────────────

        An admin who wants to put the payment link into a letter of her own had
        to open the invoice, wait for Shopify, and copy out of the address bar.
        The link is right here; this hands it over.

        Quiet on purpose: paying is what this card is for, and a second filled
        button beside the first would make the school choose between two things
        that look equally like the way forward.
      */
      /*
        ── 2026-09-03 — the tools stand apart from the way forward (owner) ──

        All three controls first went into the action cell, and that cell is the
        third column of a three-column row sized to its contents. Three pills
        side by side ran off the end of the card: the last one could not even be
        pressed, because it was no longer on the page.

        They are also not the same KIND of thing. "Open invoice and pay" is what
        the school came here to do; copying a link and printing a sheet are the
        admin tidying up afterwards. Set side by side at equal weight they made
        a school choose between three things that looked equally like paying.

        So the two tools drop to a strip of their own along the bottom of the
        card, smaller and quieter, under the button they follow.
      */
      var toolsHtml = '';

      /* Copy link goes with the paying link: once paid, it would copy an
         address that no longer opens. Save PDF stays - the sheet is still the
         record of what was billed. */
      if (invoiceUrl) {
        toolsHtml =
          '<div class="cohort-campus-invoice-tools">' +
            (isPaid ? '' : '<button type="button" class="cohort-campus-invoice-tool cohort-campus-invoice-copy" data-invoice-url="' + esc(invoiceUrl) + '">Copy link</button>') +
            '<button type="button" class="cohort-campus-invoice-tool cohort-campus-invoice-print">Save PDF</button>' +
          '</div>';
      }

      var warningHtml = String(invoice.ship_to_source || '') === 'school_fallback'
        ? '<p class="cohort-campus-invoice-warning">This campus has no delivery address of its own, so the school address is on this invoice. Check the delivery address before paying.</p>'
        : '';

      var metaParts = [studentCount + (studentCount === 1 ? ' student' : ' students')];
      if (invoice.draft_order_name) metaParts.push(String(invoice.draft_order_name));

      return '' +
        '<div class="cohort-campus-invoice-row' + (isPaid ? ' is-paid' : '') + '">' +
          '<div class="cohort-campus-invoice-main">' +
            '<div class="cohort-campus-invoice-head">' +
              '<span class="cohort-campus-invoice-campus">' + esc(invoice.campus_name || 'No campus') + '</span>' +
              '<span class="cohort-campus-invoice-scope">' + esc(campusInvoiceScopeLabel(invoice)) + '</span>' +
              '<span class="cohort-campus-invoice-badge' + (isPaid ? ' is-paid' : '') + '">' + esc(campusInvoiceStatusLabel(invoice)) + '</span>' +
            '</div>' +
            '<p class="cohort-campus-invoice-meta">' + esc(metaParts.join(' · ')) + '</p>' +
            warningHtml +
          '</div>' +
          (totalLabel ? '<p class="cohort-campus-invoice-amount">' + esc(totalLabel) + '</p>' : '') +
          (linkHtml ? '<div class="cohort-campus-invoice-action">' + linkHtml + '</div>' : '') +
          toolsHtml +
          demoInvoiceNoteHtml(invoice) +
        '</div>';
    }

    /*
      ── The demo note under an invoice ──────────────────────────────────────

      Two things this has to survive, both found by the owner on 2026-09-14.

      It cannot live inside the button's cell. The row is a grid whose last
      columns are sized to their contents, so a sentence in there squeezed the
      campus name into three lines and stacked the badges. It is its own
      full-width cell instead - see the stylesheet in the section.

      And it cannot live only in the DOM. The invoice cards are rebuilt from
      scratch every time the page refreshes itself in the background, which is
      often, so a note revealed by a click was wiped seconds later. Whether it
      has been asked for is remembered here and read back while rendering, so
      a rebuild redraws it already open.

      Keyed by the invoice rather than by position: the cards can be reordered
      by a rebuild, and a note that jumped to another campus would be worse
      than one that vanished.
    */
    var demoInvoiceNotesShown = {};

    function demoInvoiceKey(invoice) {
      return [
        String((invoice && invoice.campus_name) || 'no-campus'),
        String((invoice && invoice.scope) || ''),
        String((invoice && invoice.draft_order_name) || '')
      ].join('|');
    }

    function demoInvoiceNoteShown(invoice) {
      return demoInvoiceNotesShown[demoInvoiceKey(invoice)] === true;
    }

    function demoInvoiceNoteHtml(invoice) {
      if (!CONFIG.demoMode) return '';

      var key = esc(demoInvoiceKey(invoice));

      return '<span class="cohort-campus-invoice-demo" data-demo-invoice-note="' + key + '"' +
        (demoInvoiceNoteShown(invoice) ? '' : ' hidden') + '>' +
        '<button type="button" class="cohort-campus-invoice-demo-close" data-demo-invoice-close="' + key +
        '" aria-label="Close this message">&times;</button>' +
        'Payment is disabled in the demo. The invoice is real in shape and in total - this is where the school pays it in the live system.' +
        '</span>';
    }

    /*
      ── 2026-09-01 — why the invoices come out higher than the estimate ─────

      The owner watched a school read $1,206.00 in the estimate and $1,422.00
      across its invoices, with nothing on the page joining the two numbers.
      The difference is the per-item processing fee: the estimate is built
      from list prices and leaves it out, the invoice adds it as its own line.

      A sentence already said so — surchargeNoticeHtml(), a footnote at the
      bottom of the pricing card. It was there and it was not read: the
      question is asked in front of the invoices, and the answer sat under a
      different block in grey.

      So the same fact is said again here, where the larger number is, and
      said loudly. Deliberately from the SAME source — the cohort's own
      products snapshot and its surcharge field — so the two statements can
      never name different money.

      Named, not totalled, for the reason written beside surchargeNoticeHtml():
      the invoice is assembled by Mechanic from each student's saved items,
      and a second sum computed in the browser would only ever drift from it.
      The rate is a fact; the total is the invoice's business.

      Nothing is shown when nothing is surcharged — a shop with no fee sees
      the block exactly as it was.

      No twin: the dashboard has no invoice block. The sentence it does carry,
      renderSurchargeNotice() in cohort-admin-form.js, is untouched.
    */
    function campusInvoiceFeeNoticeHtml() {
      /* cohort.products arrives as a JSON string, same as everywhere else on
         this page — parse it rather than treating it as an array. */
      var products = parseJson(currentCohort && currentCohort.products, []);
      if (!Array.isArray(products)) return '';

      /* Grouped by rate, because a cohort may carry two of them and one
         sentence naming a single figure would be wrong for both. */
      var byRate = {};

      products.forEach(function(product) {
        var rate = Number(product && product.surcharge) || 0;
        if (rate <= 0) return;

        var key = String(rate);
        if (!byRate[key]) byRate[key] = [];

        var title = String((product && (product.title || product.product_title)) || '').trim();
        if (title && byRate[key].indexOf(title) === -1) byRate[key].push(title);
      });

      var rates = Object.keys(byRate).sort(function(a, b) { return Number(b) - Number(a); });
      if (!rates.length) return '';

      var linesHtml = rates.map(function(rate) {
        var titles = byRate[rate];
        /* 2026-09-01 — shorter, and it names the garment (owner). "Per scrub
           set" is what the school actually pays: the fee sits on one item of
           the set, so a set is charged once. The line under it says which
           item, and would list two if a shop ever put a fee on both — the
           reader would see that rather than be told a half-truth. */
        /* 2026-09-01 — two lines, not four (owner). The block was taller than
           the invoices it explains, which put the emphasis in the wrong place:
           the amounts a school owes are the subject of this panel, and the fee
           is a footnote to them. So the closing sentence folds into the line
           that names the garment. */
        var on = titles.length
          ? '<p class="cohort-campus-invoice-fee-on">Charged on the top: ' + esc(titles.join(', ')) + ' — not in the estimate above.</p>'
          : '<p class="cohort-campus-invoice-fee-on">Not included in the estimate above.</p>';

        return '' +
          '<div class="cohort-campus-invoice-fee-line">' +
            '<b class="cohort-campus-invoice-fee-amount">' + esc(formatMoney(Number(rate))) + '</b>' +
            '<span class="cohort-campus-invoice-fee-per">per scrub set</span>' +
          '</div>' +
          on;
      }).join('');

      return '' +
        '<div class="cohort-campus-invoice-fee">' +
          '<span class="cohort-campus-invoice-fee-label">Processing fee · included in these invoices</span>' +
          linesHtml +
        '</div>';
    }

    /*
      Two ways, because one of them is not always allowed. The clipboard API
      needs a secure context and a gesture, and returns a promise that can
      reject for reasons the page cannot see. The old selection trick works
      where it does not, and where neither works the button says so instead of
      pretending — an admin who thinks a link is on the clipboard and pastes
      the last thing she copied into a letter to a school is worse off than one
      told plainly to copy it by hand.
    */
    function copyTextToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(function() {
          return true;
        }).catch(function() {
          return legacyCopy(text);
        });
      }

      return Promise.resolve(legacyCopy(text));
    }

    function legacyCopy(text) {
      var field = document.createElement('textarea');

      field.value = text;
      field.setAttribute('readonly', 'readonly');
      field.style.position = 'fixed';
      field.style.top = '-1000px';
      field.style.opacity = '0';

      document.body.appendChild(field);
      field.select();

      var copied = false;

      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(field);

      return copied;
    }

    function wireCampusInvoiceCopyButtons(container) {
      var buttons = container.querySelectorAll('.cohort-campus-invoice-copy');

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener('click', function() {
          var url = button.getAttribute('data-invoice-url') || '';
          if (!url) return;

          copyTextToClipboard(url).then(function(copied) {
            /* Said on the button itself: a message elsewhere on a long page is
               a message nobody sees. */
            button.textContent = copied ? 'Link copied' : 'Could not copy';
            button.classList.add('is-said');

            window.setTimeout(function() {
              if (!button.isConnected) return;
              button.textContent = 'Copy link';
              button.classList.remove('is-said');
            }, 2200);
          });
        });
      });
    }

    /*
      A printable invoice for the school accounts (owner, 2026-09-03).

      Shopify's own invoice cannot be turned into a PDF from this page: it lives
      on another domain, and a browser will not let one page read another. This
      is our own sheet, built from the cohort's cache and printed through the
      same hidden iframe the status report uses — wrapped in
      #cohort-print-layout, because the print stylesheet hides every direct
      child of body that is not that element.

      Prices come from the cohort's products snapshot, matched on variant id.
      That is deliberately the same place, and the same match, that
      cohort-finalize used when it wrote the invoice, so a line here and a line
      there cannot quietly name different money. A variant the snapshot does not
      know is shown with a dash rather than a zero: a missing price is a thing
      to ask about, and a zero looks like a decision.

      Three totals at the foot. Uniforms and the processing fee are added up
      here; the last line is the invoice's own total, carried across untouched.
      If the two ever disagree the sheet shows both rather than hiding it, which
      is the point of printing them beside each other.

      Who belongs on it: the tokens the invoice recorded when it was created.
      Invoices written before that field existed carry none, and for those the
      campus on each student's own items answers instead. The sheet says which
      of the two answered.
    */
    function unitPriceForVariantId(variantId) {
      var wanted = String(variantId || '').replace(/[^0-9]/g, '');
      if (!wanted) return null;

      var products = parseJson(currentCohort && currentCohort.products, []);
      if (!Array.isArray(products)) return null;

      for (var p = 0; p < products.length; p++) {
        var variants = (products[p] && products[p].variants) || [];

        for (var v = 0; v < variants.length; v++) {
          var variant = variants[v] || {};
          var id = String(variant.variant_id || variant.id || variant.variant_gid || variant.gid || '').replace(/[^0-9]/g, '');
          if (id !== wanted) continue;

          var price = variant.price_amount != null ? variant.price_amount : variant.price;
          var asNumber = Number(price);
          return isFinite(asNumber) ? asNumber : null;
        }
      }

      return null;
    }

    /*
      ── The printed invoice, rebuilt from the owner's reference ────────────

      2026-09-15. Her finance team keeps this sheet by hand in a spreadsheet,
      and it is the shape everyone downstream already reads: a company block, a
      pricing notice, the notes, BILL TO, and then one line per student with
      their sizes across the row.

      Two things that changed from the sheet this replaces.

      One line per student, not one per garment. The old sheet repeated a
      person's name down as many rows as they had items; this puts each garment
      in its own column - the reference's "Top size" and "Pants size", except
      the columns are built from whatever the cohort actually sells, so a
      cohort with a water bottle gets a column for it.

      And the totals left the tfoot. A browser repeats tfoot on every printed
      page, which is why the grand total appeared on all of them - the owner
      asked for it once, at the end, and moving the rows into the body is what
      does that. thead stays: column headings SHOULD repeat.
    */
    function invoiceTextBlock(raw, leadStyle, bodyStyle) {
      var lines = String(raw || '').split('\n').map(function(line) { return line.trim(); })
        .filter(function(line) { return line !== ''; });

      if (!lines.length) return '';

      return lines.map(function(line, index) {
        return '<p style="margin:0;' + (index === 0 ? leadStyle : bodyStyle) + '">' + esc(line) + '</p>';
      }).join('');
    }

    function invoiceBillToLines() {
      var billing = (window.COHORT_STATUS_SCHOOL_BILLING || {})[
        String((currentCohort && currentCohort.schoolCode) || '').trim().toUpperCase()
      ] || {};

      var cityLine = [
        [billing.city, billing.province].filter(Boolean).join(', '),
        billing.zip
      ].filter(Boolean).join('  ');

      return {
        company: String(billing.company || (currentCohort && currentCohort.schoolName) || '').trim(),
        address: [billing.address1, billing.address2, cityLine, billing.country]
          .map(function(part) { return String(part || '').trim(); })
          .filter(function(part) { return part !== ''; })
          .join(' ')
      };
    }

    /*
      ── The grey rows (owner, 2026-09-15) ──────────────────────────────────

      The heading row and the total row are filled, the way her finance sheet
      fills them: the two rows that are not students, marked as not students.

      The fill is asked for once, on the cells. print-color-adjust is not
      repeated here: the page's own print stylesheet already sets it on html
      and body, and that inherits.

      It was repeated here for a day, and removed on 2026-09-15 while looking
      into a saved PDF whose table came out as a picture while the text above
      it stayed text. Whether it was the cause is not settled - see the note in
      the deployment card - but a property set twice is a property to rule out
      first.
    */
    var GREY = 'background:#e6e6e6;';

    /*
      Long text in a narrow column, cut rather than wrapped: a wrapped cell
      makes its whole row two lines tall. The reference clips its cohort names
      the same way, and for the same reason.
    */
    function clipForColumn(text, limit) {
      var value = String(text || '').trim();
      if (value.length <= limit) return value;

      /* A cut that lands on "&" or a dash leaves the line looking broken
         rather than shortened. Trailing punctuation goes with the tail. */
      return value.slice(0, limit).replace(/[\s&\-,;:.+/]+$/, '');
    }

    function campusInvoicePrintHtml(invoice) {
      /* Borders on every cell: this is a data table, the one place the house
         rule about fills rather than lines does not apply. A finance
         department reads down columns, and columns need edges. */
      /*
        Sized against the owner's reference, 2026-09-15, second pass: hers fits
        a cohort on one sheet and mine ran to two. Everything here is smaller
        than a screen would want, which is the point - paper reads closer than a
        monitor, and a finance sheet is scanned down columns rather than read.
      */
      /*
        Third pass on the size, 2026-09-15. Small enough that a name, a campus
        and a column heading each keep to one line - the wrapping was what made
        the table tall, not the number of students.

        nowrap on the cells that hold names: a wrapped cell sets the height of
        its whole row, and sixteen two-line rows are a second page.
      */
      var CELL = 'border:1px solid #000000;padding:1.5px 3px;font-size:7px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:clip;';
      var HEAD = CELL + 'font-weight:700;text-align:center;vertical-align:middle;' + GREY;

      var campusName = String(invoice.campus_name || '').trim() || 'No campus';
      /* Named in the first column of every row, as on the reference: the sheet
         is built to survive being pasted beside another cohort's. */
      var cohortLabel = getCohortLabel(currentCohort) || String(currentCohortCode || '');
      /* The school's name now comes with its billing address, in one place -
         see invoiceBillToLines. The local copy that stood here went with the
         heading it used to fill. */
      var invoiceName = String(invoice.draft_order_name || '').trim();
      var invoiceTotal = campusInvoiceAmountValue(invoice);
      var invoiceUrl = String(invoice.invoice_url || '').trim();

      var tokens = String(invoice.student_tokens || '').split(',').map(function(entry) {
        return entry.trim().toLowerCase();
      }).filter(function(entry) { return entry !== ''; });

      var source;
      var rows;

      if (tokens.length) {
        /*
          The tokens ARE the answer, so nothing is filtered before them. An
          earlier version narrowed to students billable today and then matched,
          which quietly dropped anyone since moved into a late round although
          this invoice did bill them. What an invoice covered was settled when
          it was written.
        */
        source = 'the tokens recorded on this invoice';
        rows = (currentStudents || []).filter(function(student) {
          return tokens.indexOf(String(student.unique_token || '').trim().toLowerCase()) !== -1;
        });
      } else {
        source = 'the campus on each student\u2019s own order';
        rows = (currentStudents || []).filter(isConfirmedForFinalize).filter(function(student) {
          return (getStudentCampusName(student) || 'No campus') === campusName;
        });
      }

      var uniformsTotal = 0;
      var feeTotal = 0;
      var studentRows = '';

      /*
        The garment columns are whatever this cohort actually sells, in the
        order the students' own forms list them. The reference has two, Top
        size and Pants size, because that is what its cohorts sold; a cohort
        with a water bottle gets a column for the bottle.
      */
      var productColumns = [];

      rows.forEach(function(student) {
        getStudentItems(student).forEach(function(item, itemIndex) {
          var title = getItemDisplayTitle(item, item._key || item.product_id || String(itemIndex + 1));
          if (title && productColumns.indexOf(title) === -1) productColumns.push(title);
        });
      });

      /* Six is already a wide sheet; beyond that the names stop fitting. */
      if (productColumns.length > 6) productColumns = productColumns.slice(0, 6);

      /*
        ── Short column headings (owner, 2026-09-15) ────────────────────────

        A school's products are named in full: "Midwestern Navy Blue Unisex
        Scrub Top" and "... Scrub Pants". Printed as headings they wrapped to
        four lines each and pushed the table onto a second page.

        The words they share are the school's own name and its colour, which
        the sheet has already said twice by the time anyone reaches the table.
        Dropping the common opening leaves "Top" and "Pants" - the reference's
        own headings, arrived at rather than hardcoded.

        Only when it leaves something behind: two products called exactly the
        same thing keep their full names rather than becoming two blank
        columns.
      */
      var shortColumns = productColumns.slice();

      if (productColumns.length > 1) {
        var wordLists = productColumns.map(function(title) { return title.split(/\s+/); });
        var common = 0;

        while (true) {
          var word = wordLists[0][common];
          if (word === undefined || common >= wordLists[0].length - 1) break;

          var shared = wordLists.every(function(words) {
            return words.length > common + 1 && words[common].toLowerCase() === word.toLowerCase();
          });

          if (!shared) break;
          common += 1;
        }

        if (common > 0) {
          var trimmed = wordLists.map(function(words) { return words.slice(common).join(' '); });
          var allDistinct = trimmed.every(function(name, index) {
            return name && trimmed.indexOf(name) === index;
          });

          if (allDistinct) shortColumns = trimmed;
        }
      }

      var perStudentUniforms = null;
      var perStudentFee = null;
      var amountsVary = false;

      rows.forEach(function(student, index) {
        var name = [student.first_name, student.last_name].join(' ').trim() || getStudentIdentityEmail(student);
        var items = getStudentItems(student);
        var sizes = {};
        var studentUniforms = 0;
        var studentFee = 0;

        items.forEach(function(item, itemIndex) {
          var title = getItemDisplayTitle(item, item._key || item.product_id || String(itemIndex + 1));
          var quantity = Number(item.total_quantity || item.quantity || 1) || 1;
          var unit = unitPriceForVariantId(item.variant_id);

          if (unit !== null) studentUniforms += unit * quantity;
          studentFee += (Number(item.custom_fee_each || 0) || 0) * quantity;

          if (title && sizes[title] === undefined) sizes[title] = getItemSelection(item) || '';
        });

        uniformsTotal += studentUniforms;
        feeTotal += studentFee;

        if (perStudentUniforms === null) {
          perStudentUniforms = studentUniforms;
          perStudentFee = studentFee;
        } else if (perStudentUniforms !== studentUniforms || perStudentFee !== studentFee) {
          amountsVary = true;
        }

        /*
          Every column clips, not only the three that hold long text. A size
          is two characters and a student number is six, but a school is free
          to record either as something longer, and one overlong cell pushes
          its neighbour's text across a line that is supposed to separate them.
        */
        var sizeCells = productColumns.map(function(title) {
          return '<td style="' + CELL + 'text-align:center;">' + esc(clipForColumn(sizes[title] || '', 8)) + '</td>';
        }).join('');

        studentRows += '<tr>' +
          '<td style="' + CELL + '">' + esc(clipForColumn(cohortLabel, 26)) + '</td>' +
          '<td style="' + CELL + '">' + esc(clipForColumn(campusName, 20)) + '</td>' +
          '<td style="' + CELL + 'text-align:center;">' + (index + 1) + '</td>' +
          '<td style="' + CELL + '">' + esc(clipForColumn(name, 30)) + '</td>' +
          '<td style="' + CELL + 'text-align:center;">' + esc(clipForColumn(String(student.student_id || ''), 12)) + '</td>' +
          sizeCells +
          '<td style="' + CELL + 'text-align:right;">' + esc(formatCampusInvoiceAmount(studentUniforms)) + '</td>' +
          '<td style="' + CELL + 'text-align:right;">' + esc(formatCampusInvoiceAmount(studentFee)) + '</td>' +
          '<td style="' + CELL + 'text-align:right;">' + esc(formatCampusInvoiceAmount(studentUniforms + studentFee)) + '</td>' +
        '</tr>';
      });

      var leadingColumns = 5 + productColumns.length;

      /*
        The total, once, at the end of the list - in the body rather than in a
        tfoot, which browsers reprint on every page. That repetition is exactly
        what the owner asked to be rid of.
      */
      var TOTAL_CELL = CELL + 'font-weight:700;text-align:right;' + GREY;

      var totalRowHtml = '<tr>' +
        '<td colspan="' + leadingColumns + '" style="' + TOTAL_CELL + '">TOTAL</td>' +
        '<td style="' + TOTAL_CELL + '">' + esc(formatCampusInvoiceAmount(uniformsTotal)) + '</td>' +
        '<td style="' + TOTAL_CELL + '">' + esc(formatCampusInvoiceAmount(feeTotal)) + '</td>' +
        '<td style="' + TOTAL_CELL + '">' + esc(formatCampusInvoiceAmount(uniformsTotal + feeTotal)) + '</td>' +
      '</tr>';

      var emptyRow = '<tr><td colspan="' + (leadingColumns + 3) + '" style="' + CELL + '">No students could be matched to this invoice.</td></tr>';

      /*
        The sentence above the table. The reference states what one student
        costs, which only means anything when every student costs the same -
        so it is printed when they do, and left out when they do not rather
        than quoting a figure that is true of nobody.
      */
      var perStudentLine = '';

      if (rows.length && !amountsVary && productColumns.length) {
        perStudentLine = 'Each student: ' + productColumns.join(' + ') + '. ' +
          'Uniform subtotal ' + formatCampusInvoiceAmount(perStudentUniforms) +
          ' + processing ' + formatCampusInvoiceAmount(perStudentFee) +
          ' = ' + formatCampusInvoiceAmount(perStudentUniforms + perStudentFee);
      } else if (productColumns.length) {
        perStudentLine = 'Each student: ' + productColumns.join(' + ') + '.';
      }

      /*
        The link to pay, kept from the sheet this replaces (owner, 2026-09-03).
        The reference has none because a spreadsheet cannot hold one; the sheet
        goes to an accounts department, and where to pay is the one thing a
        list of students cannot tell them.

        Printed as the address itself: on paper a link that hides where it goes
        is not a link.
      */
      var payHtml = '';
      var sheetPaid = String(invoice.status || '').trim().toLowerCase() === 'paid';
      var sheetPaidOrder = String(invoice.paid_order_name || '').trim();

      /* A paid invoice's sheet says so, instead of printing a payment address
         that stopped working when it was paid (owner, 2026-10-05). */
      if (sheetPaid) {
        payHtml =
          '<div style="margin:9px 0 0;padding:5px 8px;border:1px dashed #000000;">' +
            '<p style="margin:0;font-size:6.5px;font-weight:700;letter-spacing:0.06em;color:#000000;">PAID' +
              (sheetPaidOrder ? ' · ORDER ' + esc(sheetPaidOrder) : '') + '</p>' +
          '</div>';
      } else if (invoiceUrl) {
        /*
          Quieter, 2026-09-15 (owner). It was a solid box in the same weight as
          the table, which put a link in competition with the money. Dashed and
          smaller: still findable by anyone looking for where to pay, no longer
          the second thing the eye lands on.
        */
        payHtml =
          '<div style="margin:9px 0 0;padding:5px 8px;border:1px dashed #000000;">' +
            '<p style="margin:0 0 2px;font-size:6.5px;font-weight:700;letter-spacing:0.06em;color:#000000;">PAY THIS INVOICE</p>' +
            '<a href="' + esc(invoiceUrl) + '" style="font-size:6.5px;line-height:1.35;color:#000000;word-break:break-all;">' + esc(invoiceUrl) + '</a>' +
          '</div>';
      }

      /*
        ── The invoiced amount, when it is not what the rows add up to ───────

        The columns add up to what these students cost at the prices held in
        the cohort. The invoice recorded its own total when it was written, and
        if the two disagree the sheet has to say so rather than quietly show
        the prettier number: a finance department reconciles against what was
        actually billed.

        Equal is the normal case, and then nothing is printed.
      */
      var computedTotal = uniformsTotal + feeTotal;
      var mismatchHtml = '';

      if (invoiceTotal !== null && Math.abs(invoiceTotal - computedTotal) >= 0.01) {
        mismatchHtml =
          '<p style="margin:12px 0 0;padding:8px 10px;border:1px solid #111111;font-size:10.5px;">' +
            'Invoiced total: <strong>' + esc(formatCampusInvoiceAmount(invoiceTotal)) + '</strong>. ' +
            'The rows above add up to ' + esc(formatCampusInvoiceAmount(computedTotal)) +
            ' at the prices held in this cohort. The invoice is what the school owes.' +
          '</p>';
      }

      var logoUrl = String(CONFIG.invoiceLogoUrl || '').trim();
      var logoHtml = logoUrl
        ? '<img src="' + esc(logoUrl) + '" alt="" style="display:inline-block;height:' +
          (Number(CONFIG.invoiceLogoHeight) || 34) + 'px;width:auto;">'
        : '';

      var billTo = invoiceBillToLines();

      /*
        Every size here is a step down from what a screen would take. On the
        owner's reference the whole header - company, notices, BILL TO - takes
        about a third of the sheet, and the rest belongs to the students.
      */
      var headerCompany = invoiceTextBlock(
        CONFIG.invoiceCompanyName ? CONFIG.invoiceCompanyName + '\n' + String(CONFIG.invoiceCompanyAddress || '') : String(CONFIG.invoiceCompanyAddress || ''),
        'font-size:12.5px;font-weight:800;letter-spacing:-0.01em;padding-bottom:2px;',
        'font-size:7.5px;line-height:1.4;color:#000000;'
      );

      var pricingNotice = invoiceTextBlock(
        CONFIG.invoicePricingNotice,
        'font-size:7.5px;font-weight:700;line-height:1.4;',
        'font-size:7.5px;line-height:1.4;color:#000000;'
      );

      var notes = invoiceTextBlock(
        CONFIG.invoiceNotes,
        'font-size:7.5px;font-weight:700;line-height:1.4;',
        'font-size:7.5px;line-height:1.4;color:#000000;'
      );

      return '' +
        '<div class="print-report" style="font-family:Inter,Arial,Helvetica,sans-serif;color:#111111;">' +

          /*
            ── Blocks, not tables (owner's screenshot 137) ──────────────────

            This header was laid out with tables, and the printed sheet came
            back with boxes drawn round the company and the notices. The page's
            own print stylesheet borders table cells - reasonably, since every
            other table on it is data - and a table borrowed for layout gets
            the same treatment.

            Two inline-blocks instead. Nothing to draw a line around, and the
            columns still sit side by side on paper, where flexbox is the less
            reliable of the two.
          */
          '<div style="margin:0 0 14px;">' +
            '<div style="display:inline-block;width:60%;vertical-align:top;">' + headerCompany + '</div>' +
            '<div style="display:inline-block;width:39%;vertical-align:top;text-align:right;">' + logoHtml + '</div>' +
          '</div>' +

          /*
            The gap between the two is deliberate and is most of what makes
            this header readable: two blocks of small print running edge to
            edge read as one grey mass. Narrower notes, more air, as on the
            reference.
          */
          /*
            Floated rather than set side by side, so the notes end where the
            logo ends: its right edge is the sheet's, and two blocks that stop
            at the same place read as a column rather than as a paragraph that
            trailed off. The text inside stays left-aligned - right-aligned
            small print is unreadable.
          */
          '<div style="margin:0 0 12px;overflow:hidden;">' +
            '<div style="float:left;width:40%;">' + pricingNotice + '</div>' +
            '<div style="float:right;width:40%;text-align:left;">' + notes + '</div>' +
          '</div>' +

          '<p style="margin:0 0 6px;font-size:11.5px;font-weight:800;letter-spacing:0.01em;">INVOICE</p>' +
          '<p style="margin:0 0 2px;font-size:7.5px;letter-spacing:0.05em;">BILL TO</p>' +
          '<p style="margin:0 0 2px;font-size:10px;font-weight:800;">' + esc(billTo.company || 'School') + '</p>' +
          (billTo.address ? '<p style="margin:0 0 2px;font-size:7.5px;color:#000000;">' + esc(billTo.address) + '</p>' : '') +
          '<p style="margin:0 0 10px;font-size:7px;color:#000000;">Cohort ' + esc(String(currentCohortCode || '')) +
            (invoiceName ? ' &middot; invoice ' + esc(invoiceName) : '') + '</p>' +

          (perStudentLine ? '<p style="margin:0 0 3px;font-size:7.5px;">' + esc(perStudentLine) + '</p>' : '') +

          /*
            ── Widths chosen, not left to the content ───────────────────────

            2026-09-15, owner: the size columns were holding an "M" in a cell
            wide enough for a sentence, while full names were being clipped
            next door. Browsers size columns by their widest content, and a
            money column with "Processing fee" in its heading is wide whatever
            is underneath it.

            So the table is told. The name gets what the size columns give up,
            which is where the space was: sizes are two characters, and 5% of a
            sheet is plenty for two characters.
          */
          '<table style="width:100%;border-collapse:collapse;table-layout:fixed;">' +
            '<colgroup>' +
              '<col style="width:14%;">' +
              '<col style="width:11%;">' +
              '<col style="width:2.5%;">' +
              '<col style="width:' + Math.max(14, 26 - (shortColumns.length * 2)) + '%;">' +
              '<col style="width:8%;">' +
              shortColumns.map(function() { return '<col style="width:7%;">'; }).join('') +
              '<col style="width:8%;">' +
              '<col style="width:9%;">' +
              '<col style="width:8%;">' +
            '</colgroup>' +
            '<thead><tr>' +
              '<th style="' + HEAD + 'text-align:left;">Cohort name</th>' +
              '<th style="' + HEAD + 'text-align:left;">Location</th>' +
              '<th style="' + HEAD + 'width:24px;">#</th>' +
              '<th style="' + HEAD + '">Student</th>' +
              '<th style="' + HEAD + '">Student ID</th>' +
              shortColumns.map(function(title) {
                return '<th style="' + HEAD + '">' + esc(title) + ' size</th>';
              }).join('') +
              '<th style="' + HEAD + '">Uniforms</th>' +
              '<th style="' + HEAD + '">Processing fee</th>' +
              '<th style="' + HEAD + '">Student total</th>' +
            '</tr></thead>' +
            '<tbody>' + (studentRows || emptyRow) + (studentRows ? totalRowHtml : '') + '</tbody>' +
          '</table>' +
          mismatchHtml +
          payHtml +
          '<p style="margin:10px 0 0;font-size:6.5px;color:#000000;">Amounts are before tax. Prices are the ones held in this cohort&rsquo;s price snapshot, the same ones the invoice was built from. Students listed from ' + esc(source) + '.</p>' +
        '</div>';
    }

    function wireCampusInvoicePrintButtons(container, invoices) {
      var buttons = container.querySelectorAll(".cohort-campus-invoice-print");

      Array.prototype.forEach.call(buttons, function(button, index) {
        button.addEventListener("click", function() {
          var invoice = invoices[index];
          if (!invoice) return;

          /*
            Wrapped because the first version of this was not. A mistake inside
            the sheet threw, the handler died with it, and the button did
            nothing at all — the one failure a person cannot tell apart from a
            button that is not wired up. Now it says so on itself.
          */
          try {
            printHtmlInIframe({
              title: [String(currentCohortCode || ""), String(invoice.campus_name || "No campus"), "invoice"].join(" "),
              /*
                Wrapped in #cohort-print-layout, as the status report is. The
                print stylesheet hides every direct child of body that is not
                that element, and it hides them with a selector specific enough
                to outrank the class the sheet carries — so the first version
                printed a page with nothing on it but the title the browser
                puts there itself. The wrapper is what makes the sheet visible,
                and .print-report inside it is what makes its contents visible.
              */
              bodyHtml: "<div id=\"cohort-print-layout\">" + campusInvoicePrintHtml(invoice) + "<" + "/div>"
            });
          } catch (error) {
            button.textContent = "Could not build the sheet";
            button.classList.add("is-said");

            window.setTimeout(function() {
              if (!button.isConnected) return;
              button.textContent = "Save PDF";
              button.classList.remove("is-said");
            }, 2600);
          }
        });
      });
    }

    /*
      ── All unpaid school invoices at once (owner, 2026-11-02) ─────────────

      A school's accounts payable wants every open invoice in one file, not one
      Save PDF per campus per cohort. The dashboard's Unpaid invoices button
      opens this page with ?invoices=unpaid&school=CODE, and the list is built
      from what the page already holds: window.COHORTS and the caches, both
      limited by the section to the cohorts this viewer may see.

      Unpaid means status "created" with a payment link - "Ready to pay" on the
      cards. Paid, still being created, and personal home-delivery orders (not
      school invoices) are left out.

      The sheet itself is campusInvoicePrintHtml, unchanged. It reads the
      loaded cohort from currentCohort / currentCohortCode / currentStudents,
      so withInvoiceCohort points those at each invoice's cohort for the call
      and puts them back afterwards - one sheet, not a second copy of it.
    */
    function isUnpaidInvoicesMode() {
      return String(getParam('invoices') || '').trim().toLowerCase() === 'unpaid';
    }

    function withInvoiceCohort(entry, build) {
      var savedCohort = currentCohort;
      var savedCode = currentCohortCode;
      var savedStudents = currentStudents;

      try {
        var cache = findCacheByCode(entry.code);
        currentCohort = entry.cohort || {};
        currentCohortCode = entry.code;
        currentStudents = buildStatusStudentsList(
          cache ? parseStudentsJson(cache.studentsJson) : [],
          entry.cohort || {}
        );
        return build();
      } finally {
        currentCohort = savedCohort;
        currentCohortCode = savedCode;
        currentStudents = savedStudents;
      }
    }

    function collectUnpaidInvoices() {
      var schoolFilter = normalizeCode(getParam('school') || '');
      var entries = [];
      var unread = 0;
      var seen = {};

      cohorts.forEach(function(cohort) {
        var code = normalizeCode(cohort && cohort.cohortCode);
        if (!code || seen[code]) return;
        seen[code] = true;

        if (schoolFilter && normalizeCode(cohort.schoolCode) !== schoolFilter) return;

        /* A cohort with no cache could not be read - which is not the same as
           a cohort with nothing to pay, and the page says which it was. */
        if (!findCacheByCode(code)) {
          if (isCohortFinalized(cohort)) unread += 1;
          return;
        }

        parseCampusInvoices(code).forEach(function(invoice) {
          var status = String(invoice.status || '').trim().toLowerCase();
          if (status !== 'created' || !String(invoice.invoice_url || '').trim()) return;
          entries.push({ cohort: cohort, code: code, invoice: invoice });
        });
      });

      /* By cohort, then Main before its rounds, then campus - the order each
         cohort's own page uses. */
      entries.sort(function(a, b) {
        var aName = (getCohortLabel(a.cohort) || a.code).toLowerCase();
        var bName = (getCohortLabel(b.cohort) || b.code).toLowerCase();
        if (aName !== bName) return aName < bName ? -1 : 1;
        if (a.code !== b.code) return a.code < b.code ? -1 : 1;

        var aBatch = String(a.invoice.late_batch_code || '');
        var bBatch = String(b.invoice.late_batch_code || '');
        if (aBatch !== bBatch) {
          if (!aBatch) return -1;
          if (!bBatch) return 1;
          return aBatch.localeCompare(bBatch);
        }
        return String(a.invoice.campus_name || '').localeCompare(String(b.invoice.campus_name || ''));
      });

      return { entries: entries, unread: unread };
    }

    /*
      One document - OFF FOR NOW (owner, 2026-11-02: "temporarily"). No button
      calls printAllUnpaidInvoices; it stays so the single PDF can come back
      with one button in #cohort-unpaid-invoices-section. Its cover table,
      unpaidInvoicesCoverHtml, is in use: Download payment links prints it alone.
    */
    /* Fee and tax, said once for the page and the printed links (owner,
       2026-11-02: "still somewhere, in small print"). The exact fee differs
       by cohort and is on each invoice; this only says it is included. */
    var UNPAID_SMALL_PRINT = "Invoice totals include the processing fee where a cohort has one. Amounts are before tax: any tax that applies is added on the payment page. Each invoice is paid separately, on its own link.";

    /* options.title / options.intro: the payment-links document reuses this
       table with its own heading (printUnpaidPaymentLinks). */
    function unpaidInvoicesCoverHtml(entries, options) {
      options = options || {};
      var CELL = 'border:1px solid #000000;padding:3px 5px;font-size:8px;line-height:1.3;vertical-align:top;';
      var HEAD = CELL + 'font-weight:700;text-align:left;' + GREY;

      var outstanding = campusInvoicesOutstanding(entries.map(function(entry) { return entry.invoice; }));
      var billTo = withInvoiceCohort(entries[0], invoiceBillToLines);
      var today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

      var rows = entries.map(function(entry, index) {
        var invoice = entry.invoice;
        var amount = campusInvoiceAmountValue(invoice);
        var url = String(invoice.invoice_url || '').trim();

        return '<tr>' +
          '<td style="' + CELL + 'text-align:center;">' + (index + 1) + '</td>' +
          '<td style="' + CELL + '">' + esc(getCohortLabel(entry.cohort) || entry.code) + '<br>' + esc(entry.code) + '</td>' +
          '<td style="' + CELL + '">' + esc(campusInvoiceScopeLabel(invoice)) + '</td>' +
          '<td style="' + CELL + '">' + esc(String(invoice.campus_name || '').trim() || 'No campus') + '</td>' +
          '<td style="' + CELL + '">' + esc(String(invoice.draft_order_name || '').trim()) + '</td>' +
          '<td style="' + CELL + 'text-align:right;white-space:nowrap;">' + (amount === null ? '-' : esc(formatCampusInvoiceAmount(amount))) + '</td>' +
          '<td style="' + CELL + 'word-break:break-all;"><a href="' + esc(url) + '" style="color:#000000;">' + esc(url) + '</a></td>' +
        '</tr>';
      }).join('');

      /* No total when an amount is missing: a total that leaves one invoice
         out looks like the whole answer (campusInvoicesOutstanding). */
      var totalRow = outstanding
        ? '<tr><td colspan="5" style="' + CELL + 'font-weight:700;text-align:right;' + GREY + '">TOTAL TO PAY</td>' +
          '<td style="' + CELL + 'font-weight:700;text-align:right;white-space:nowrap;' + GREY + '">' + esc(formatCampusInvoiceAmount(outstanding.total)) + '</td>' +
          '<td style="' + CELL + GREY + '"></td></tr>'
        : '';

      return '' +
        '<div class="print-report" style="font-family:Inter,Arial,Helvetica,sans-serif;color:#111111;">' +
          '<p style="margin:0 0 6px;font-size:14px;font-weight:800;">' + esc(options.title || 'UNPAID INVOICES') + '</p>' +
          '<p style="margin:0 0 2px;font-size:10px;font-weight:800;">' + esc(billTo.company || 'School') + '</p>' +
          (billTo.address ? '<p style="margin:0 0 2px;font-size:7.5px;">' + esc(billTo.address) + '</p>' : '') +
          '<p style="margin:0 0 12px;font-size:7.5px;">' + esc(today) + ' &middot; ' + entries.length +
            (entries.length === 1 ? ' invoice' : ' invoices') + '. ' + esc(options.intro || 'Each one follows on its own page, with its students and its payment link.') + '</p>' +
          '<table style="width:100%;border-collapse:collapse;table-layout:fixed;">' +
            '<colgroup><col style="width:4%;"><col style="width:20%;"><col style="width:10%;"><col style="width:14%;"><col style="width:9%;"><col style="width:11%;"><col style="width:32%;"></colgroup>' +
            '<thead><tr>' +
              '<th style="' + HEAD + 'text-align:center;">#</th>' +
              '<th style="' + HEAD + '">Cohort</th>' +
              '<th style="' + HEAD + '">Round</th>' +
              '<th style="' + HEAD + '">Location</th>' +
              '<th style="' + HEAD + '">Invoice</th>' +
              '<th style="' + HEAD + 'text-align:right;">Amount</th>' +
              '<th style="' + HEAD + '">Pay online</th>' +
            '</tr></thead>' +
            '<tbody>' + rows + totalRow + '</tbody>' +
          '</table>' +
          '<p style="margin:10px 0 0;font-size:6.5px;">' + esc(UNPAID_SMALL_PRINT) + '</p>' +
        '</div>';
    }

    function printAllUnpaidInvoices(entries) {
      var pages = entries.map(function(entry) {
        return '<div style="page-break-before:always;break-before:page;">' +
          withInvoiceCohort(entry, function() { return campusInvoicePrintHtml(entry.invoice); }) +
        '<' + '/div>';
      }).join('');

      printHtmlInIframe({
        title: 'Unpaid invoices',
        bodyHtml: '<div id="cohort-print-layout">' + unpaidInvoicesCoverHtml(entries) + pages + '<' + '/div>'
      });
    }

    /*
      One by one, right on the page (owner, 2026-11-02 - first a dialog, then
      moved onto the page: the dialog repeated the list the page already
      showed). Cohorts, their unpaid invoices, a Save PDF on each. A pressed
      button turns green and says Saved, so the admin sees which ones are done.
      Kept in memory only, on purpose: a reload starts the list clean.

      "Saved" means the print window was opened for that invoice - the page
      cannot know whether the PDF was then actually saved.
    */
    var unpaidSavedKeys = {};

    function unpaidInvoiceKey(entry) {
      return [entry.code, String(entry.invoice.late_batch_code || ''), String(entry.invoice.campus_name || ''), String(entry.invoice.draft_order_name || '')].join('|');
    }

    /* Download payment links (owner, 2026-11-02): every unpaid invoice and its
       link on one sheet - the table of the one-document cover, nothing else. */
    function printUnpaidPaymentLinks(entries) {
      printHtmlInIframe({
        title: 'Payment links',
        bodyHtml: '<div id="cohort-print-layout">' + unpaidInvoicesCoverHtml(entries, {
          title: 'PAYMENT LINKS',
          intro: 'Open a link to pay that invoice.'
        }) + '<' + '/div>'
      });
    }

    function printOneUnpaidInvoice(entry) {
      printHtmlInIframe({
        title: [entry.code, String(entry.invoice.campus_name || 'No campus'), 'invoice'].join(' '),
        bodyHtml: '<div id="cohort-print-layout">' +
          withInvoiceCohort(entry, function() { return campusInvoicePrintHtml(entry.invoice); }) + '<' + '/div>'
      });
    }

    function unpaidListHtml(entries) {
      var html = '';
      var lastCode = '';

      entries.forEach(function(entry, index) {
        if (entry.code !== lastCode) {
          if (lastCode) html += '</div>';
          html += '<div class="cohort-unpaid-list-cohort"><p class="cohort-unpaid-list-cohort-name">' +
            esc(getCohortLabel(entry.cohort) || entry.code) + ' <span>' + esc(entry.code) + '</span></p>';
          lastCode = entry.code;
        }

        var amount = campusInvoiceAmountValue(entry.invoice);
        var saved = unpaidSavedKeys[unpaidInvoiceKey(entry)] === true;
        var payUrl = String(entry.invoice.invoice_url || '').trim();

        html += '<div class="cohort-unpaid-list-row">' +
          '<div class="cohort-unpaid-list-row-main">' +
            '<b>' + esc(String(entry.invoice.campus_name || '').trim() || 'No campus') + '</b>' +
            '<span>' + esc(campusInvoiceScopeLabel(entry.invoice)) +
              (entry.invoice.draft_order_name ? ' &middot; ' + esc(String(entry.invoice.draft_order_name)) : '') + '</span>' +
          '</div>' +
          (amount === null ? '' : '<span class="cohort-unpaid-list-amount">' + esc(formatCampusInvoiceAmount(amount)) + '</span>') +
          (payUrl ? '<a class="cohort-unpaid-list-pay" href="' + esc(payUrl) + '" target="_blank" rel="noopener">Pay</a>' : '') +
          '<button type="button" class="cohort-unpaid-list-save' + (saved ? ' is-saved' : '') + '" data-unpaid-each="' + index + '">' +
            (saved ? 'Saved' : 'Save PDF') + '</button>' +
        '</div>';
      });

      if (lastCode) html += '</div>';
      return html;
    }

    function renderUnpaidInvoicesSection() {
      var section = document.getElementById('cohort-unpaid-invoices-section');
      var container = document.getElementById('cohort-unpaid-invoices');
      if (!section || !container) return;

      var found = collectUnpaidInvoices();
      var entries = found.entries;
      var unreadNote = found.unread
        ? '<p class="cohort-campus-invoices-note cohort-unpaid-invoices-warning">' + found.unread +
          (found.unread === 1 ? ' finalized cohort' : ' finalized cohorts') +
          ' could not be read just now, so ' + (found.unread === 1 ? 'its invoices are' : 'their invoices are') +
          ' not in this list. Refresh the page in a minute.</p>'
        : '';

      section.hidden = false;

      /* Three different answers, never one: no cohorts to read, nothing
         owed, or invoices to pay. */
      if (!cohorts.length) {
        container.innerHTML = '<p class="cohort-campus-invoices-note">No cohorts could be found for this account. Sign in with the admin email the cohorts were created with.</p>';
        return;
      }

      if (!entries.length) {
        container.innerHTML = unreadNote || '<p class="cohort-campus-invoices-note">No unpaid invoices. Every school invoice of your cohorts is paid, or none has been created yet.</p>';
        return;
      }

      var outstanding = campusInvoicesOutstanding(entries.map(function(entry) { return entry.invoice; }));
      var totalHtml = outstanding
        ? '<div class="cohort-campus-invoice-total"><span>Still to pay</span><b>' + esc(formatCampusInvoiceAmount(outstanding.total)) + '</b></div>'
        : '';

      container.innerHTML = unreadNote + unpaidListHtml(entries) + totalHtml +
        '<p class="cohort-unpaid-small-print">' + esc(UNPAID_SMALL_PRINT) + '</p>';

      var linksButton = document.getElementById('cohort-unpaid-links');
      if (linksButton) {
        linksButton.hidden = false;
        linksButton.onclick = function() {
          try {
            printUnpaidPaymentLinks(entries);
          } catch (error) {
            linksButton.textContent = 'Could not build the list';
          }
        };
      }

      Array.prototype.forEach.call(container.querySelectorAll('[data-unpaid-each]'), function(button) {
        button.addEventListener('click', function() {
          var entry = entries[Number(button.getAttribute('data-unpaid-each'))];
          if (!entry) return;

          try {
            printOneUnpaidInvoice(entry);
            unpaidSavedKeys[unpaidInvoiceKey(entry)] = true;
            button.classList.add('is-saved');
            button.textContent = 'Saved';
          } catch (error) {
            button.textContent = 'Could not build it';
          }
        });
      });
    }

    function renderCampusInvoicesSection(cohortCode) {
      var section = document.getElementById('cohort-campus-invoices-section');
      var container = document.getElementById('cohort-campus-invoices');
      if (!section || !container) return;

      var invoices = parseCampusInvoices(cohortCode);

      if (!invoices.length) {
        section.hidden = true;
        container.innerHTML = '';
        return;
      }

      /* Main first, then rounds in order — the same order the page tells the
         cohort's story in everywhere else. */
      invoices = invoices.slice().sort(function(a, b) {
        var aBatch = String(a.late_batch_code || '');
        var bBatch = String(b.late_batch_code || '');
        if (aBatch === bBatch) {
          return String(a.campus_name || '').localeCompare(String(b.campus_name || ''));
        }
        if (!aBatch) return -1;
        if (!bBatch) return 1;
        return aBatch.localeCompare(bBatch);
      });

      var outstanding = campusInvoicesOutstanding(invoices);
      var totalHtml = outstanding
        ? '<div class="cohort-campus-invoice-total">' +
            '<span>Still to pay</span>' +
            '<b>' + esc(formatCampusInvoiceAmount(outstanding.total)) + '</b>' +
          '</div>'
        : '';

      section.hidden = false;
      container.innerHTML = campusInvoiceFeeNoticeHtml() + invoices.map(campusInvoiceCardHtml).join('') + totalHtml;

      /* The rows are rebuilt from scratch on every render, so the handlers go
         on with them. Nothing is left listening to a button that no longer
         exists. */
      wireCampusInvoiceCopyButtons(container);

      /* The buttons come out in the order the cards were drawn, which is the
         order of this very array — so position links the two and nothing has
         to be looked up by name. */
      wireCampusInvoicePrintButtons(container, invoices);

      wireCampusInvoiceDemoButtons(container);
    }

    /*
      The demo's paying button. It reveals the sentence sitting next to it and
      then stays pressed-looking, so a second press is obviously pointless.

      Rebuilt with the cards on every render, like the two above, which is why
      nothing here has to be unbound.
    */
    function wireCampusInvoiceDemoButtons(container) {
      var buttons = container.querySelectorAll("[data-demo-invoice]");

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener("click", function() {
          var key = button.getAttribute("data-demo-invoice") || "";

          /* Remembered first, so the next background rebuild draws it open. */
          demoInvoiceNotesShown[key] = true;

          var row = button.closest
            ? button.closest(".cohort-campus-invoice-row")
            : null;
          var note = row
            ? row.querySelector('[data-demo-invoice-note="' + key.replace(/"/g, '\\"') + '"]')
            : null;

          if (note) note.hidden = false;

          button.classList.add("is-answered");
          button.setAttribute("aria-expanded", "true");
        });
      });

      /*
        The cross. Forgetting it here as well as hiding it is the whole point:
        a note that comes back on the next background refresh has not been
        closed, it has been postponed.
      */
      var closers = container.querySelectorAll("[data-demo-invoice-close]");

      Array.prototype.forEach.call(closers, function(closer) {
        closer.addEventListener("click", function(event) {
          event.stopPropagation();

          var key = closer.getAttribute("data-demo-invoice-close") || "";
          delete demoInvoiceNotesShown[key];

          var note = closer.closest
            ? closer.closest("[data-demo-invoice-note]")
            : null;
          if (note) note.hidden = true;

          var row = closer.closest
            ? closer.closest(".cohort-campus-invoice-row")
            : null;
          var button = row ? row.querySelector("[data-demo-invoice]") : null;

          if (button) {
            button.classList.remove("is-answered");
            button.setAttribute("aria-expanded", "false");
          }
        });
      });
    }

    function parseLateBatches(cohortCode) {
      var cache = findCacheByCode(cohortCode);
      if (!cache || !cache.lateBatchesJson) return [];

      try {
        var parsed = JSON.parse(cache.lateBatchesJson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    /*
      lateBatchStatusLabel() lived here until 2026-08-05. The card no longer
      carries a status pill: "Finalized" / "Finalizing…" is already said next to
      the batch name, and "Awaiting responses" only restated that nobody had
      confirmed — which the Confirmed group's own count says better.
    */

    function lateBatchStudentsForBatch(batch, students) {
      var code = String(batch.late_batch_code || '').trim().toUpperCase();
      return (students || []).filter(function(student) {
        return String(student.late_batch_code || '').trim().toUpperCase() === code;
      });
    }

    function lateBatchStudentCardsHtml(title, students) {
      var cardsHtml = students.length
        ? mapStudentsWithListNumbers(students).map(function(entry) {
            return studentCardHtml(entry.student, entry.listNumber, entry.unmatched);
          }).join('')
        : '<div class="late-cohort-empty-row">None</div>';
      return '<div class="late-cohort-sublist">' +
        '<p class="late-cohort-sublist-title">' + esc(title) + ' (' + students.length + ')</p>' +
        '<div class="late-cohort-student-cards">' + cardsHtml + '</div>' +
        '</div>';
    }

    /*
      lateBatchSchoolInvoiceStatusText stood here and turned a batch's status
      into "Created / Creating… / Not created" for the line above the round's
      note. That line went on 2026-08-17 — the School invoices block says the
      same and says it per campus — and this had no other reader. Removed with
      it rather than left looking alive.
    */

    function lateBatchCardHtml(batch, allStudents) {
      var isFinalized = batch.status === 'finalized';
      var isFinalizing = batch.status === 'finalizing' || !!lateBatchFinalizeInFlight[batch.late_batch_code];

      var batchStudents = lateBatchStudentsForBatch(batch, allStudents || []);
      var confirmedStudents = batchStudents.filter(hasSubmittedSizes);
      var waitingStudents = batchStudents.filter(function(student) {
        return !hasSubmittedSizes(student);
      });
      /*
        studentOrdersCreated and invoiceLink were the other two halves of the
        line removed on 2026-08-17. Both counted only for it.
      */

      /*
        2026-08-25 — the round's state is a line, not a suffix (owner).

        It hung after the name inside the same span, so on a narrow card it
        wrapped under the first half of "Late 02" and read as part of the name.
        Now that the head is centred it sits under the deadline on its own
        line, where the eye already ends up, and it is the last thing read
        before the students.
      */
      var titleStatusHtml = '';
      if (isFinalized) {
        titleStatusHtml = '<span class="late-cohort-batch-title-status is-finalized">Finalized</span>';
      } else if (isFinalizing) {
        titleStatusHtml = '<span class="late-cohort-batch-title-status is-finalizing">Finalizing…</span>';
      }

      var actionHtml;
      if (isFinalized || isFinalizing) {
        actionHtml = '';
      } else if (confirmedStudents.length < 1) {
        actionHtml = '<button type="button" class="late-cohort-finalize-btn" disabled title="No confirmed students yet in this batch">Finalize Late Batch</button>';
      } else {
        actionHtml = '<button type="button" class="late-cohort-finalize-btn" data-late-batch-code="' + esc(batch.late_batch_code) + '">Finalize Late Batch</button>';
      }

      /*
        The per-batch "Send reminder to all" was removed 2026-08-05 (step 3 of
        docs/roster-editing-rework-plan.md). Reminders are sent from the cohort
        dashboard now; this page keeps finalize only. The status paragraph goes
        with it — nothing on this page writes to it any more.
      */

      if (actionHtml) {
        actionHtml = '<div class="late-cohort-batch-actions">' + actionHtml + '</div>';
      }

      /*
        Rebuilt 2026-08-05 to match the dashboard's language: one dark card, a
        large name and deadline, the action above the list, and the list always
        open. What went: the Invited / Confirmed / Waiting pill row and the
        "Awaiting responses" pill — each group already states its own count, so
        those were the same numbers a third time. The <details> wrapper went too:
        hiding the students behind "Show students" made the block look empty.
      */
      /*
        2026-08-25 — the action sits above the name, centred (owner).

        It stood to the right of the round's title, where a wide card pushed it
        far from the words it acts on and a narrow one dropped it underneath
        them. Above and centred, it is in the same place at every width, and it
        is the first thing on a card whose whole purpose is that one decision.
      */
      return '' +
        '<div class="late-cohort-batch-card" data-late-batch-code="' + esc(batch.late_batch_code) + '">' +
          actionHtml +
          '<div class="late-cohort-batch-head">' +
            '<div class="late-cohort-batch-headline">' +
              '<span class="late-cohort-batch-title">Late ' + esc((batch.late_batch_code || '').replace(/^LATE-/i, '')) + '</span>' +
              '<span class="late-cohort-batch-deadline">' + esc(batch.late_deadline_display || batch.late_deadline || '—') + '</span>' +
              '<span class="late-cohort-batch-deadline-label">Deadline</span>' +
              titleStatusHtml +
            '</div>' +
          '</div>' +
          /*
            2026-08-17 — the invoice line is gone from here (owner).

            It said "School invoice: Created · Student orders: 0 of 2" with a
            link, directly above the School invoices block that says the same
            thing per campus, with the amount, the status and the way through
            to the order. Two answers to one question, and the shorter one had
            no campus in it — on a cohort billed per campus that reading is
            wrong more often than right.

            The block below is the authority. Nothing is lost by removing this.
          */
          '<p class="late-cohort-batch-note">Everyone in this late round receives their order at their home address.</p>' +
          /*
            2026-08-11 — only while the round is still open. Once it is
            finalized there is nothing left to edit and no reminder left to
            send: the orders exist and the invoice is out. The sentence below
            about starting the next round is the one that still applies.
          */
          (isFinalized
            ? ''
            : '<p class="late-cohort-batch-note">To edit these students or send them a reminder, open this cohort on the dashboard and use the Late ' +
              esc((batch.late_batch_code || '').replace(/^LATE-/i, '')) + ' list there.</p>') +
          (isFinalized && waitingStudents.length > 0
            ? '<p class="late-cohort-carryover-prompt">' + waitingStudents.length +
              (waitingStudents.length === 1 ? ' student hasn\'t' : ' students haven\'t') +
              ' submitted yet. Start the next late round from the dashboard.</p>'
            : '') +
          '<div class="late-cohort-batch-lists">' +
            lateBatchStudentCardsHtml('Pending', waitingStudents) +
            lateBatchStudentCardsHtml('Confirmed', confirmedStudents) +
          '</div>' +
        '</div>';
    }

    function renderLateBatchesSection(cohortCode) {
      /*
        The invoice list is redrawn from here on purpose. Both sections are
        built from the same cache and go stale at the same moments, and this
        function is already called from every one of them — nine call sites,
        which is exactly how many places a second call would have to be
        remembered in, and forgotten in one of them.
      */
      renderCampusInvoicesSection(cohortCode);

      var section = document.getElementById('late-cohort-section');
      var container = document.getElementById('late-cohort-batches');
      if (!section || !container) return;

      var batches = parseLateBatches(cohortCode).slice().sort(function(a, b) {
        return Number(a.late_batch_index || 0) - Number(b.late_batch_index || 0);
      });

      if (!batches.length) {
        section.style.display = 'none';
        container.innerHTML = '';
        return;
      }

      var openBatchCodes = Array.prototype.map.call(
        container.querySelectorAll('.late-cohort-batch-card'),
        function(card) {
          var details = card.querySelector('.late-cohort-batch-details');
          return (details && details.open) ? card.getAttribute('data-late-batch-code') : null;
        }
      ).filter(Boolean);

      /*
        2026-08-25 — newest round on top (owner).

        Rounds were listed in the order they were created, so the one being
        worked on sank further down the page with every round opened. The
        number in the code is the order, so it sorts on that rather than on
        the position in the array, which no rule guarantees.
      */
      var orderedBatches = batches.slice().sort(function(a, b) {
        var an = parseInt(String(a.late_batch_code || '').replace(/[^0-9]/g, ''), 10) || 0;
        var bn = parseInt(String(b.late_batch_code || '').replace(/[^0-9]/g, ''), 10) || 0;
        return bn - an;
      });

      section.style.display = '';
      container.innerHTML = orderedBatches.map(function(batch) {
        return lateBatchCardHtml(batch, currentStudents);
      }).join('');

      openBatchCodes.forEach(function(code) {
        var card = container.querySelector('.late-cohort-batch-card[data-late-batch-code="' + CSS.escape(code) + '"]');
        var details = card && card.querySelector('.late-cohort-batch-details');
        if (details) details.open = true;
      });

      container.querySelectorAll('.late-cohort-finalize-btn[data-late-batch-code]:not(:disabled)').forEach(function(button) {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';
        button.addEventListener('click', function() {
          finalizeLateBatch(button.dataset.lateBatchCode, button);
        });
      });

    }

    function openLateBatchFinalizeModal(lateBatchCode) {
      return new Promise(function(resolve) {
        var overlay = document.getElementById('late-batch-finalize-modal-overlay');
        var confirmButton = document.getElementById('late-batch-finalize-modal-confirm');
        var cancelButton = document.getElementById('late-batch-finalize-modal-cancel');
        var titleEl = document.getElementById('late-batch-finalize-modal-title');

        if (!overlay || !confirmButton || !cancelButton) {
          resolve(false);
          return;
        }

        if (titleEl) {
          titleEl.textContent = 'Finalize ' + lateBatchCode + '?';
        }

        /*
          ── 2026-08-24 — the three numbers, as on the main dialog (owner) ─────

          A round writes a school invoice exactly as the main cohort does, so
          the admin gets the same three facts before pressing: who is on the
          bill, who answered and has not paid and is left off it, and who has
          not answered at all.

          Counted from the round's own students, using the same three helpers
          the dashboard uses — isConfirmedForFinalize is the browser's copy of
          the rule cohort-finalize-late applies, and the two are meant to be
          read together.

          Not de-duplicated on purpose: the task counts records, and so should
          the number that predicts what it will do.
        */
        var batchCodeKey = String(lateBatchCode || '').trim().toUpperCase();

        var batchStudents = (currentStudents || []).filter(function(student) {
          return String(student.late_batch_code || '').trim().toUpperCase() === batchCodeKey;
        });

        var billedCount = batchStudents.filter(isConfirmedForFinalize).length;
        var unpaidCount = batchStudents.filter(isAwaitingPaymentStudent).length;

        var waitingCount = batchStudents.filter(function(student) {
          if (isRemovedStudent(student)) return false;
          if (isAwaitingPaymentStudent(student)) return false;
          return !hasSubmittedSizes(student);
        }).length;

        var lateBilledEl = document.getElementById('late-finalize-count-billed');
        var lateUnpaidEl = document.getElementById('late-finalize-count-unpaid');
        var lateWaitingEl = document.getElementById('late-finalize-count-waiting');
        var noteEl = document.getElementById('late-finalize-note');

        if (lateBilledEl) lateBilledEl.textContent = billedCount;
        if (lateUnpaidEl) lateUnpaidEl.textContent = unpaidCount;
        if (lateWaitingEl) lateWaitingEl.textContent = waitingCount;

        /*
          The same warning the main dialog carries, one round further along: a
          student left off THIS invoice is in exactly the position the round was
          opened to rescue somebody from, and only another round can reach them.
        */
        if (noteEl) {
          var strandedCount = unpaidCount + waitingCount;

          if (strandedCount > 0) {
            /* The second half is word for word the main dialog's — see the note
               beside it in cohort-status.liquid. Only the first sentence differs,
               because this one points at the next round rather than the first. */
            noteEl.innerHTML = (strandedCount === 1
              ? '<strong>1 student in this round is not on this invoice.</strong> '
              : '<strong>' + strandedCount + ' students in this round are not on this invoice.</strong> ') +
              '<strong>When this round is finalized, start another round for them.</strong> ' +
              'It gives them a new deadline and their own letter, so they can still confirm or pay, and go on the school\u2019s next invoice. Without a new round, they cannot join later.';
            noteEl.style.display = 'block';
          } else {
            noteEl.textContent = '';
            noteEl.style.display = 'none';
          }
        }

        function closeModal(result) {
          overlay.classList.remove('show');
          overlay.setAttribute('aria-hidden', 'true');
          confirmButton.removeEventListener('click', onConfirm);
          cancelButton.removeEventListener('click', onCancel);
          overlay.removeEventListener('click', onOverlayClick);
          document.removeEventListener('keydown', onKeyDown);
          resolve(result);
        }

        function onConfirm() {
          closeModal(true);
        }

        function onCancel() {
          closeModal(false);
        }

        function onOverlayClick(event) {
          if (event.target === overlay) closeModal(false);
        }

        function onKeyDown(event) {
          if (event.key === 'Escape') closeModal(false);
        }

        confirmButton.addEventListener('click', onConfirm);
        cancelButton.addEventListener('click', onCancel);
        overlay.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeyDown);
        overlay.classList.add('show');
        overlay.setAttribute('aria-hidden', 'false');
        cancelButton.focus();
      });
    }

    function finalizeLateBatch(lateBatchCode, button) {
      if (!lateBatchCode || !currentCohortCode) return;

      if (!finalizeLateWebhookUrl) {
        if (demoFinalizeClosedNotice()) return;
        showFinalizeNotice('Setup required', 'Missing Finalize Late Batch webhook URL in section settings.', 'error');
        return;
      }

      if (lateBatchFinalizeInFlight[lateBatchCode]) return;

      openLateBatchFinalizeModal(lateBatchCode).then(function(confirmed) {
        if (confirmed) runLateBatchFinalize(lateBatchCode, button);
      });
    }

    function runLateBatchFinalize(lateBatchCode, button) {
      lateBatchFinalizeInFlight[lateBatchCode] = true;

      if (button) {
        button.disabled = true;
        button.textContent = 'Finalizing…';
      }

      /*
        Re-render first so the batch card immediately drops its action buttons
        and switches to the "Finalizing…" title state, then run the same notice
        + progress-bar treatment the main cohort finalize uses. The progress bar
        owns the page reload, so there is nothing to do in the success handler.
      */
      renderLateBatchesSection(currentCohortCode);
      showFinalizeNotice('', '');
      setFinalizeNoticeLoading(true, FINALIZE_IN_PROGRESS_MESSAGE);
      setStatusPageBlocked(true);
      writeActionLock('Finalizing', FINALIZE_ACTION_LOCK_MS, {
        action: 'finalize_late',
        lateBatchCode: lateBatchCode
      });
      startFinalizeProgress(function() {
        markFinalizeJustCompleted(currentCohortCode, lateBatchCode);
        reloadWithCohort(currentCohortCode);
      });

      fetch(finalizeLateWebhookUrl, webhookInit({
        action: 'finalize_late_cohort',
        cohort_code: currentCohortCode,
        late_batch_code: lateBatchCode
      })).then(function(response) {
        if (!response.ok) {
          return response.text().then(function(text) {
            throw new Error(text || 'Finalize Late Batch request failed.');
          });
        }
        return response.text();
      }).catch(function(error) {
        stopFinalizeProgress();
        setFinalizeNoticeLoading(false);
        clearActionLock();
        setStatusPageBlocked(false);
        delete lateBatchFinalizeInFlight[lateBatchCode];
        if (button) {
          button.disabled = false;
          button.textContent = 'Finalize Late Batch';
        }
        renderLateBatchesSection(currentCohortCode);
        showFinalizeNotice(
          'Finalize Late Batch request failed',
          error && error.message ? error.message : 'Something went wrong.',
          'error'
        );
      });
    }

    /*
      2026-10-16 (owner) - on the demo the finalize address is printed only for
      a signed-in visitor, so a stranger pressing Finalize met "Setup required -
      Missing finalize webhook URL", which reads as a broken page. On the demo
      that is not a fault: say why in plain words. A live page keeps the setup
      message, where a missing address really is a setup mistake.
    */
    function openShowcaseModal() {
      var overlay = document.getElementById('cohort-showcase-modal');
      if (!overlay) return;

      var create = document.getElementById('cohort-showcase-modal-create');
      if (create) {
        var dashboard = create.getAttribute('data-dashboard') || create.getAttribute('href') || '/';
        create.setAttribute('data-dashboard', dashboard);
        if (CONFIG.demoSignedIn) {
          create.textContent = 'Create my cohort';
          create.href = dashboard;
        } else {
          create.textContent = 'Sign in and create my cohort';
          create.href = '/account/login?return_url=' + encodeURIComponent(dashboard);
        }
      }

      if (!overlay.dataset.bound) {
        overlay.dataset.bound = '1';
        overlay.addEventListener('click', function(event) {
          if (event.target === overlay || event.target.id === 'cohort-showcase-modal-close') {
            overlay.classList.remove('show');
            overlay.setAttribute('aria-hidden', 'true');
          }
        });
        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && overlay.classList.contains('show')) {
            overlay.classList.remove('show');
            overlay.setAttribute('aria-hidden', 'true');
          }
        });
      }

      overlay.classList.add('show');
      overlay.setAttribute('aria-hidden', 'false');
      var close = document.getElementById('cohort-showcase-modal-close');
      if (close) close.focus();
    }

    function demoFinalizeClosedNotice() {
      if (!CONFIG.demoMode) return false;

      var code = normalizeCode(currentCohortCode);
      var showcase = String(CONFIG.showcaseCohortCodes || '').split(',').map(function(item) {
        return normalizeCode(item);
      }).filter(Boolean);

      if (code && showcase.indexOf(code) !== -1) {
        /* 2026-10-16 (owner, demo stage 5): the showcase window, the same
           one the demo dashboard opens. */
        openShowcaseModal();
        return true;
      }

      if (!CONFIG.demoSignedIn) {
        showFinalizeNotice(
          'Sign in to finalize',
          'In the demo you can finalize a cohort you created yourself. Sign in, create a cohort on the demo dashboard, and come back to finalize it - you will see its invoices, which in the demo can never be paid.',
          ''
        );
        return true;
      }

      return false;
    }

    function finalizeCohort() {
      var button = document.getElementById('cohort-finalize-button');

      if (!currentCohortCode) {
        showFinalizeNotice('Cannot finalize', 'Load a cohort before finalizing.', 'error');
        return;
      }

      if (!finalizeWebhookUrl) {
        if (demoFinalizeClosedNotice()) return;
        showFinalizeNotice('Setup required', 'Missing finalize webhook URL in section settings.', 'error');
        return;
      }

      if (isCohortFinalized(currentCohort)) {
        openFinalizedInfoModal();
        return;
      }

      if (countConfirmedForFinalize(currentStudents) < 1) {
        /*
          Same two reasons the dashboard tells apart (2026-08-12): nobody has
          answered, or everybody has and nobody has paid for delivery yet.
        */
        var awaitingPayment = (currentStudents || []).filter(isAwaitingPaymentStudent).length;
        var blockedMessage = NO_CONFIRMED_STUDENTS_MESSAGE;

        if (awaitingPayment > 0) {
          blockedMessage = awaitingPayment === 1
            ? 'Nothing to finalize yet: 1 student has filled in the form but has not paid for delivery. The school is billed for a student once that payment goes through.'
            : 'Nothing to finalize yet: ' + awaitingPayment + ' students have filled in the form but have not paid for delivery. The school is billed for a student once that payment goes through.';
        }

        showFinalizeNotice('', '');
        showFinalizeBlockedBanner(true, blockedMessage);
        pulseFinalizeBlockedBanner();
        return;
      }

      var confirmedCount = countConfirmedForFinalize(currentStudents);
      var notConfirmedCount = countApprovedListPending(currentStudents, currentCohort);

      /* 2026-08-17 — counted here and passed in, so the modal stays a modal
         and does not go looking through the student list itself. */
      var awaitingPaymentCount = (currentStudents || []).filter(function(student) {
        return !isRemovedStudent(student) && isAwaitingPaymentStudent(student);
      }).length;

      openFinalizeModal({
        notConfirmedCount: notConfirmedCount,
        billedCount: confirmedCount,
        awaitingPaymentCount: awaitingPaymentCount
      }).then(function(confirmed) {
        if (!confirmed) return;

        button.disabled = true;
        button.textContent = 'Finalizing...';
        showFinalizeNotice('', '');
        setFinalizeNoticeLoading(true, FINALIZE_IN_PROGRESS_MESSAGE);
        setStatusPageBlocked(true);
        writeActionLock('Finalizing', FINALIZE_ACTION_LOCK_MS, { action: 'finalize' });
        startFinalizeProgress(function() {
          markFinalizeJustCompleted(currentCohortCode, '');
          reloadWithCohort(currentCohortCode);
        });

        fetch(finalizeWebhookUrl, webhookInit({
          action: 'finalize_cohort',
          cohort_code: currentCohortCode,
          cohort: currentCohortCode,
          cohort_id: currentCohort && currentCohort.cohortId ? currentCohort.cohortId : currentCohortCode
        })).then(function(response) {
          if (!response.ok) {
            return response.text().then(function(text) {
              throw new Error(text || 'Finalize request failed.');
            });
          }

          return response.text();
        }).catch(function(error) {
          stopFinalizeProgress();
          setFinalizeNoticeLoading(false);
          clearActionLock();
          setStatusPageBlocked(false);
          showFinalizeNotice(
            'Finalize request failed',
            error && error.message ? error.message : 'Something went wrong.',
            'error'
          );
          button.disabled = false;
          updateFinalizeButtonState(currentCohort, currentStudents);
      renderLateBatchesSection(currentCohortCode);
        });
      });
    }

    /*
      ── 2026-08-19 — поиск переживает автообновление (владелица) ─────────

      Страница сама обновляется в фоне, и это хорошо. Но фильтр держался на
      классе, который вешался на карточки студентов, — а обновление рисует
      карточки заново. Поле поиска при этом не трогается: оно в разметке, а
      не в перерисовываемой части.

      Со стороны это выглядело как сброс поиска: в строке набранное имя, а
      в списке снова все.

      Фильтр — это не разовое действие, а состояние экрана, и после каждой
      отрисовки его надо восстанавливать. Источник правды один — то, что
      сейчас в поле; поэтому помощник читает поле сам, и вызывающему не надо
      помнить, что туда передать.
    */
    function reapplySearchFilter() {
      var input = document.getElementById('student-search-input');
      if (!input) return;

      applySearchFilter(input.value);
    }

    function applySearchFilter(query) {
      var normalized = String(query || '').trim().toLowerCase();
      var cards = document.querySelectorAll('.student-card');

      cards.forEach(function(card) {
        var haystack = card.getAttribute('data-search') || '';
        card.classList.toggle('hidden-by-search', normalized && haystack.indexOf(normalized) === -1);
      });
    }

    /*
      Kept from the block below: still used by the deadline badge in the cohort
      summary (see the "overdue" flag), which has nothing to do with editing.
    */
    function isPastDate(value) {
      if (!value) return false;
      var parts = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!parts) return false;
      var date = new Date(parts[1] + '-' + parts[2] + '-' + parts[3] + 'T23:59:59');
      return date.getTime() < Date.now();
    }

    /*
      ── Removed 2026-08-05, step 3 of docs/roster-editing-rework-plan.md ──────

      Everything that let this page WRITE is gone: per-student email editing and
      its save handler, student removal and its confirmation modal, the resend
      modal with its late-batch reuse detection, the single and bulk reminder
      senders, and every handler that bound them.

      Why, in one line: the dashboard and this page carried independent copies of
      the same rules, and every disagreement the admin was shown came from those
      copies drifting apart. One writer removes the class of bug instead of
      fixing instances of it.

      This page now shows the cohort and finalizes it. Editing, reminders and
      late rounds live on the dashboard.
    */
    function bindPendingResendHandler() {}


    function reloadWithCohort(code) {
      var normalized = normalizeCode(code);

      if (!normalized) {
        setMessage('Please enter a valid cohort code.', 'error');
        return;
      }

      /*
        Our own navigation — the post-finalize reload runs while the action lock
        is deliberately still held, and the admin must not be asked to confirm a
        reload the page asked for itself.
      */
      allowNextUnload = true;
      window.location.href = window.location.pathname + '?cohort=' + encodeURIComponent(normalized) + '&_t=' + Date.now();
    }

    /*
      A page reload aborts any request still in flight. Losing a cohort creation
      that way is exactly how the 2026-08-02 "no events in Mechanic at all" bug
      happened: the browser cancelled the POST before it reached Mechanic, so the
      task never ran and nothing was created. A live action lock means a write is
      still in the air, so make the browser ask before leaving.
    */
    function bindUnloadGuard() {
      window.addEventListener('beforeunload', function(event) {
        if (allowNextUnload) {
          allowNextUnload = false;
          return;
        }

        /*
          Only for this page's own cohort. Asking "are you sure" about work on
          a cohort the person is not looking at is a click they have no way to
          judge - and the honest answer is always yes, leave.
        */
        if (!lockAppliesToThisPage(readActionLock())) return;

        event.preventDefault();
        /* Legacy browsers need returnValue set; the text itself is browser-controlled. */
        event.returnValue = '';
        return '';
      });
    }

    function init() {
      var form = document.getElementById('cohort-status-form');
      var input = document.getElementById('cohort-code-input');
      var searchInput = document.getElementById('student-search-input');
      var csvButton = document.getElementById('download-csv-button');
      var printButton = document.getElementById('print-pdf-button');
      var finalizeButton = document.getElementById('cohort-finalize-button');
      var printLayout = document.getElementById('cohort-print-layout');

      if (printLayout && printLayout.parentElement !== document.body) {
        document.body.appendChild(printLayout);
      }

      bindInfoTips(document.querySelector('.cohort-status-shell'));
      bindUnloadGuard();
      updateAdminDashboardLink(null);

      if (form) {
        form.addEventListener('submit', function(event) {
          event.preventDefault();
          reloadWithCohort(input.value);
        });
      }

      searchInput.addEventListener('input', function() {
        applySearchFilter(searchInput.value);
      });

      csvButton.addEventListener('click', downloadCsv);
      printButton.addEventListener('click', printPdf);
      finalizeButton.addEventListener('click', finalizeCohort);
      bindPendingResendHandler();

      document.addEventListener('visibilitychange', function() {
        if (!document.hidden && currentCohortCode && !isStatusEmailEditing() && Date.now() >= reminderStatusHoldUntil) {
          backgroundSyncStatusPage(currentCohortCode);
        }
      });

      var presetCode = getParam('cohort') || getParam('code') || getParam('cohort_code');

      if (presetCode) {
        input.value = presetCode;
        loadAndRender(presetCode);
      }

      /* Opened from the dashboard's Unpaid invoices button. */
      if (isUnpaidInvoicesMode()) {
        renderUnpaidInvoicesSection();
      }

      /*
        Last, so the cohort is already loaded and the finalize poll below has
        real data to check against.
      */
      restoreActionLockUi();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
